/* eslint-disable */

import { AllTypesProps, ReturnTypes, Ops } from './const';
export const HOST = "http://kanopiplatform.test/graphql/"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json() as Promise<GraphQLResponse>;
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

export const Thunder =
  (fn: FetchFunction) =>
  <O extends keyof typeof Ops, SCLR extends ScalarDefinition, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<SCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: (Z & ValueTypes[R]) | ValueTypes[R],
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) =>
    fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: graphqlOptions?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (graphqlOptions?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: graphqlOptions.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, SCLR>>;

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  (fn: SubscriptionFunction) =>
  <O extends keyof typeof Ops, SCLR extends ScalarDefinition, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<SCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: (Z & ValueTypes[R]) | ValueTypes[R],
    ops?: OperationOptions & { variables?: ExtractVariables<Z> },
  ) => {
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: graphqlOptions?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], SCLR>;
    if (returnedFunction?.on && graphqlOptions?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, SCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, SCLR>) => {
          if (graphqlOptions?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: graphqlOptions.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: (Z & ValueTypes[R]) | ValueTypes[R],
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    const entries = Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])] as const);
    const objectFromEntries = entries.reduce<Record<string, unknown>>((a, [k, v]) => {
      a[k] = v;
      return a;
    }, {});
    return objectFromEntries;
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  type: T,
  field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : never,
) => fn as (args?: any, source?: any) => ReturnType<typeof fn>;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S;
type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : IsArray<R, '__typename' extends keyof DST ? { __typename: true } : Record<string, never>, SCLR>
        : never;
    }[keyof SRC] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <T>(t: T | V) => T;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['ID']: unknown;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariablesDeep<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariablesDeep<Query[K]>> }[keyof Query]>;

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariablesDeep<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = GraphQLTypes["QuestionFlowType"]
export type ScalarCoders = {
	PageSize?: ScalarResolver;
	DateTime?: ScalarResolver;
	UUID?: ScalarResolver;
	JSONString?: ScalarResolver;
	Date?: ScalarResolver;
	GenericScalar?: ScalarResolver;
	ExpectedErrorType?: ScalarResolver;
}
type ZEUS_UNIONS = never

export type ValueTypes = {
    ["Query"]: AliasType<{
stripeConfig?: [{	productKey: string | Variable<any, string>},ValueTypes["StripeConfigType"]],
paymentBreakdown?: [{	riskProfileId: string | Variable<any, string>,	paymentMethodId: string | Variable<any, string>},ValueTypes["PaymentBreakdownType"]],
	admin?:ValueTypes["AdminType"],
	/** Return details for an Organization. */
	organization?:ValueTypes["OrganizationType"],
	/** Return details for an SSO Configuration. */
	ssoConfiguration?:ValueTypes["SsoConfigurationType"],
documents?: [{	document_Type?: Array<string | undefined | null> | undefined | null | Variable<any, string>},ValueTypes["GeneratedDocumentType"]],
download?: [{	id: string | Variable<any, string>},ValueTypes["DownloadDocumentType"]],
downloadFile?: [{	key: string | Variable<any, string>},ValueTypes["DownloadFileType"]],
allAnzsicCodeDivisions?: [{	year: string | Variable<any, string>},ValueTypes["AnzsicCodeDivisionType"]],
	allQuestionSets?:ValueTypes["QuestionSetType"],
	allQuestions?:ValueTypes["QuestionType"],
claim?: [{	id: string | Variable<any, string>},ValueTypes["ClaimType"]],
claimProfile?: [{	id: string | Variable<any, string>},ValueTypes["ClaimProfileType"]],
claimState?: [{	claimProfileId: string | Variable<any, string>,	filterBy?: ValueTypes["ClaimStateFilterEnum"] | undefined | null | Variable<any, string>},ValueTypes["ClaimStateType"]],
riskProfile?: [{	id: string | Variable<any, string>},ValueTypes["RiskProfileType"]],
policy?: [{	id: string | Variable<any, string>},ValueTypes["PolicyType"]],
policies?: [{	/** Status (all, active, inactive) */
	status?: string | undefined | null | Variable<any, string>,	/** Django object unique identification field */
	id?: string | undefined | null | Variable<any, string>},ValueTypes["PolicyType"]],
	/** Return the active policy if there is one. */
	activePolicy?:ValueTypes["PolicyType"],
availableCovers?: [{	riskProfileId: string | Variable<any, string>},ValueTypes["CoverType"]],
riskState?: [{	riskProfileId: string | Variable<any, string>,	filterBy?: ValueTypes["RiskStateFilterEnum"] | undefined | null | Variable<any, string>},ValueTypes["RiskStateType"]],
coverLimitations?: [{	kind?: ValueTypes["CoverLimitationKind"] | undefined | null | Variable<any, string>,	cover?: string | undefined | null | Variable<any, string>,	/** Django object unique identification field */
	id?: string | undefined | null | Variable<any, string>,	/** Number of results to return per page. Default 'default_limit': None, and 'max_limit': None */
	limit?: number | undefined | null | Variable<any, string>,	/** The initial index from which to return the results. Default: 0 */
	offset?: number | undefined | null | Variable<any, string>,	/** A string or comma delimited string values that indicate the default ordering when obtaining lists of objects. */
	ordering?: string | undefined | null | Variable<any, string>},ValueTypes["CoverLimitationType"]],
policyUpdateQuote?: [{	id: string | Variable<any, string>},ValueTypes["PolicyUpdateQuoteType"]],
policyUpdate?: [{	id: string | Variable<any, string>},ValueTypes["PolicyUpdateQuoteType"]],
policyCancellationQuote?: [{	policyId: string | Variable<any, string>},ValueTypes["PolicyCancellationQuoteType"]],
policyRenewalQuote?: [{	policyId: string | Variable<any, string>},ValueTypes["PolicyRenewalQuoteType"]],
	/** Theme definition */
	loadTheme?:ValueTypes["ThemeType"],
	/** Generate context for Cybersource card tokenization */
	cybersourceGenerateContext?:ValueTypes["CybersourceContextType"],
claims?: [{	/** Status type (open, close) */
	statusType?: string | undefined | null | Variable<any, string>,	/** Django object unique identification field */
	id?: string | undefined | null | Variable<any, string>},ValueTypes["ClaimType"]],
validateAddressBz?: [{	address: string | Variable<any, string>},ValueTypes["ValidateAddressBzType"]],
searchAddressBz?: [{	query: string | Variable<any, string>},ValueTypes["SearchAddressBzType"]],
	paymentMethod?:ValueTypes["PaymentMethodType"],
	claimsAllowed?:boolean | `@${string}`,
riskProfilePaymentAllowed?: [{	id: string | Variable<any, string>},boolean | `@${string}`],
		__typename?: boolean | `@${string}`
}>;
	["StripeConfigType"]: AliasType<{
	account?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PaymentBreakdownType"]: AliasType<{
	premium?:boolean | `@${string}`,
	surcharge?:boolean | `@${string}`,
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AdminType"]: AliasType<{
customers?: [{	search?: string | undefined | null | Variable<any, string>,	page?: number | undefined | null | Variable<any, string>,	pageSize?: number | undefined | null | Variable<any, string>},ValueTypes["CustomersType"]],
customer?: [{	id: string | Variable<any, string>},ValueTypes["CustomerDetailType"]],
policies?: [{	search?: string | undefined | null | Variable<any, string>,	page?: number | undefined | null | Variable<any, string>,	pageSize?: number | undefined | null | Variable<any, string>},ValueTypes["PoliciesType"]],
policy?: [{	id: string | Variable<any, string>},ValueTypes["PolicyType"]],
quotes?: [{	search?: string | undefined | null | Variable<any, string>,	filterBy?: ValueTypes["QuoteFilterBy"] | undefined | null | Variable<any, string>,	page?: number | undefined | null | Variable<any, string>,	pageSize?: number | undefined | null | Variable<any, string>},ValueTypes["QuotesType"]],
quote?: [{	id: string | Variable<any, string>},ValueTypes["QuoteDetailType"]],
claims?: [{	search?: string | undefined | null | Variable<any, string>,	filterBy?: ValueTypes["ClaimFilterBy"] | undefined | null | Variable<any, string>,	page?: number | undefined | null | Variable<any, string>,	pageSize?: number | undefined | null | Variable<any, string>},ValueTypes["ClaimsType"]],
claim?: [{	id: string | Variable<any, string>},ValueTypes["ClaimDetailType"]],
	products?:ValueTypes["ProductType"],
	distributionPartners?:ValueTypes["DistributionPartnerType"],
reports?: [{	search?: string | undefined | null | Variable<any, string>,	filterBy?: string | undefined | null | Variable<any, string>,	page?: number | undefined | null | Variable<any, string>,	pageSize?: number | undefined | null | Variable<any, string>},ValueTypes["ReportsType"]],
report?: [{	id: string | Variable<any, string>},ValueTypes["ReportType"]],
	claimsAllowed?:boolean | `@${string}`,
	/** Returns all data analytics */
	dataAnalytics?:ValueTypes["DataAnalyticsType"],
		__typename?: boolean | `@${string}`
}>;
	["CustomersType"]: AliasType<{
	totalItemCount?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	pageSize?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	hasNext?:boolean | `@${string}`,
	hasPrev?:boolean | `@${string}`,
	items?:ValueTypes["UserType"],
		__typename?: boolean | `@${string}`
}>;
	/** Set default page sizes for pagination. */
["PageSize"]:unknown;
	["UserType"]: AliasType<{
	id?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	isStaff?:boolean | `@${string}`,
	isActive?:boolean | `@${string}`,
	dateJoined?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	/** For lazy users only. Once a user has registered, the `email` address field is the one we care about. */
	contactEmail?:boolean | `@${string}`,
	contactNumber?:boolean | `@${string}`,
	organization?:ValueTypes["OrganizationType"],
	isSsoEnabled?:boolean | `@${string}`,
	isLazy?:boolean | `@${string}`,
	isPasswordLess?:boolean | `@${string}`,
	allowCustomerPortalAccess?:boolean | `@${string}`,
	isHijacked?:boolean | `@${string}`,
	latestReferrer?:ValueTypes["DistributionPartnerType"],
	allowAdminPortalAccess?:boolean | `@${string}`,
	fullName?:boolean | `@${string}`,
	allowUpdatePaymentMethod?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** The `DateTime` scalar type represents a DateTime
value as specified by
[iso8601](https://en.wikipedia.org/wiki/ISO_8601). */
["DateTime"]:unknown;
	/** Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
in fields, resolvers and input. */
["UUID"]:unknown;
	["OrganizationType"]: AliasType<{
	/** The name of the organization */
	name?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	/** The operating hours for this Organization. Will be displayed within any contact us sections. */
	operatingHours?:boolean | `@${string}`,
	/** The customer facing email address to get in touch with this Organization. Will be displayed within any contact us sections. */
	emailAddress?:boolean | `@${string}`,
	/** The website for this Organization. Will be displayed within any contact us sections. */
	website?:boolean | `@${string}`,
	/** The disclaimer will be shown in the footer of any customer facing page. Supports basic HTML. */
	disclaimer?:boolean | `@${string}`,
	disclaimerLinks?:ValueTypes["DisclaimerLinksType"],
	phoneDisplay?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DisclaimerLinksType"]: AliasType<{
	name?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DistributionPartnerType"]: AliasType<{
	name?:boolean | `@${string}`,
	/** Will be used to identify the Distribution Partner when loading a product directly via URL (i.e. `/getquote?product=[product.key]&distributionPartner=[key]`) */
	key?:boolean | `@${string}`,
	/** If True, allow users coming from this distribution partner to set their password and access the customer portal. If False, they remain password-less users and can't access the customer portal. */
	allowCustomerPortalAccess?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerDetailType"]: AliasType<{
	details?:ValueTypes["UserType"],
	quotes?:ValueTypes["QuoteType"],
	policies?:ValueTypes["PolicyType"],
	claims?:ValueTypes["ClaimType"],
	payments?:ValueTypes["TransactionType"],
		__typename?: boolean | `@${string}`
}>;
	["QuoteType"]: AliasType<{
	id?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	currentRiskData?:boolean | `@${string}`,
	product?:ValueTypes["ProductType"],
	covers?:ValueTypes["CoverType"],
	exposures?:ValueTypes["ExposureType"],
	limitations?:ValueTypes["CoverLimitationType"],
	state?:boolean | `@${string}`,
	referralState?:boolean | `@${string}`,
	createdTimestamp?:boolean | `@${string}`,
	quotedTimestamp?:boolean | `@${string}`,
	updatedTimestamp?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	finishDate?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	preTaxPremium?:boolean | `@${string}`,
	postTaxPremium?:boolean | `@${string}`,
	unadjustedPostTaxPremium?:boolean | `@${string}`,
	commission?:boolean | `@${string}`,
	amountDue?:boolean | `@${string}`,
	paymentFrequency?:boolean | `@${string}`,
	/** Other pricing-related figures */
	pricingOthers?:boolean | `@${string}`,
	/** Quote messages */
	messages?:boolean | `@${string}`,
	privateMessages?:boolean | `@${string}`,
	installments?:ValueTypes["InstallmentType"],
	policyPeriod?:ValueTypes["PolicyPeriodType"],
	policyUpdates?:ValueTypes["PolicyUpdateQuoteType"],
	policyRenewals?:ValueTypes["PolicyRenewalQuoteType"],
	purchaseTransactions?:ValueTypes["TransactionType"],
	updateTransactions?:ValueTypes["TransactionType"],
	periodicPrice?:boolean | `@${string}`,
	userReference?:boolean | `@${string}`,
	documents?:ValueTypes["GeneratedDocumentType"],
	stateDisplay?:boolean | `@${string}`,
	fees?:ValueTypes["FeeSummaryType"],
	referralStateDisplay?:boolean | `@${string}`,
	referredQuestionSetKeys?:boolean | `@${string}`,
	isBound?:boolean | `@${string}`,
	daysToExpiry?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RiskProfileType"]: AliasType<{
	id?:boolean | `@${string}`,
	owner?:ValueTypes["UserType"],
	riskData?:boolean | `@${string}`,
	quotes?:ValueTypes["QuoteType"],
	/** The original risk profile created in the Multi-Product flow */
	asParentInBundledRiskProfiles?:ValueTypes["BundledRiskProfileType"],
	paymentFrequency?:boolean | `@${string}`,
	periodicPrice?:boolean | `@${string}`,
	availableProducts?:ValueTypes["ProductType"],
	enabledProducts?:ValueTypes["ProductType"],
	referredProducts?:ValueTypes["ProductType"],
	knockoutProducts?:ValueTypes["ProductType"],
	enabledCovers?:ValueTypes["CoverType"],
	enabledExposures?:boolean | `@${string}`,
	enabledLimitations?:ValueTypes["CoverLimitationType"],
	state?:boolean | `@${string}`,
	quoteDocumentGenerateStatus?:boolean | `@${string}`,
	policyDocumentGenerateStatus?:boolean | `@${string}`,
	policyPeriods?:ValueTypes["PolicyPeriodType"],
	data?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	finishDate?:boolean | `@${string}`,
riskStateQuestionSets?: [{	filterBy?: ValueTypes["RiskStateFilterEnum"] | undefined | null | Variable<any, string>},ValueTypes["QuestionSetType"]],
		__typename?: boolean | `@${string}`
}>;
	/** Allows use of a JSON String for input / output from the GraphQL schema.

Use of this type is *not recommended* as you lose the benefits of having a defined, static
schema (one of the key benefits of GraphQL). */
["JSONString"]:unknown;
	["BundledRiskProfileType"]: AliasType<{
	id?:boolean | `@${string}`,
	/** Used to link a risk profile to a bundle in a Multi-Product flow */
	riskProfiles?:ValueTypes["RiskProfileType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["QuotePaymentFrequency"]:QuotePaymentFrequency;
	["ProductType"]: AliasType<{
	id?:boolean | `@${string}`,
	provider?:ValueTypes["ProviderType"],
	key?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	covers?:ValueTypes["CoverType"],
	exposures?:ValueTypes["ExposureType"],
	policyCancellationQuotes?:ValueTypes["PolicyCancellationQuoteType"],
	name?:boolean | `@${string}`,
	autoRenewAllowed?:boolean | `@${string}`,
	renewalPeriod?:boolean | `@${string}`,
	updateAllowed?:boolean | `@${string}`,
	cancellationAllowed?:boolean | `@${string}`,
	cancellationCoolingOffPeriod?:boolean | `@${string}`,
	claimsAllowed?:boolean | `@${string}`,
	paymentGateway?:boolean | `@${string}`,
	skipPayments?:boolean | `@${string}`,
	autoQuote?:boolean | `@${string}`,
	quoteDisclaimer?:boolean | `@${string}`,
	availableCovers?:ValueTypes["CoverType"],
		__typename?: boolean | `@${string}`
}>;
	["ProviderType"]: AliasType<{
	name?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	logo?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CoverType"]: AliasType<{
	id?:boolean | `@${string}`,
	product?:ValueTypes["ProductType"],
	parentCover?:ValueTypes["CoverType"],
	/** Whether this cover is enabled by default on an exposure. */
	isDefault?:boolean | `@${string}`,
	exposure?:ValueTypes["ExposureType"],
	key?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	icon?:boolean | `@${string}`,
	subCovers?:ValueTypes["CoverType"],
	details?:ValueTypes["CoverLimitationType"],
	coverQuestionSets?:ValueTypes["CoverQuestionSetType"],
	coverquestionflowSet?:ValueTypes["CoverQuestionFlowType"],
	coversummaryquestionflowSet?:ValueTypes["CoverSummaryQuestionFlowType"],
	claimcoverquestionflowSet?:ValueTypes["ClaimCoverQuestionFlowType"],
	editable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ExposureType"]: AliasType<{
	id?:boolean | `@${string}`,
	/** An identifier for the exposure. */
	key?:boolean | `@${string}`,
	/** A category for the exposure. E.g. car, property, person, etc. */
	type?:boolean | `@${string}`,
	/** Human readable text for display purposes. */
	name?:boolean | `@${string}`,
	product?:ValueTypes["ProductType"],
	/** The maximum number of exposures allowed for this key for this product. */
	limit?:boolean | `@${string}`,
	/** The path in the risk data to a value used to identify the exposure. */
	userReferencePath?:boolean | `@${string}`,
	icon?:boolean | `@${string}`,
	covers?:ValueTypes["CoverType"],
	exposureQuestionSets?:ValueTypes["ExposureQuestionSetType"],
	exposurequestionflowSet?:ValueTypes["ExposureQuestionFlowType"],
		__typename?: boolean | `@${string}`
}>;
	["ExposureQuestionSetType"]: AliasType<{
	id?:boolean | `@${string}`,
	exposure?:ValueTypes["ExposureType"],
	questionSet?:ValueTypes["QuestionSetType"],
	/** The key of the exposure item in the risk data that this question set is related to. Not to be confused with the db model attribute Exposure.key. */
	exposureItemKey?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["QuestionSetType"]: AliasType<{
	id?:boolean | `@${string}`,
	/** Will be used as the URL slug. */
	key?:boolean | `@${string}`,
	/** A small headline for this question set. */
	title?:boolean | `@${string}`,
	/** Main headline for this question set. */
	description?:boolean | `@${string}`,
	/** An optional label to help group the questions under this question set. */
	label?:boolean | `@${string}`,
	/** Optional help text displayed below the description. Callouts may be used instead for better display options. */
	help?:boolean | `@${string}`,
	/** Questions may be skipped (i.e. not delivered to a user) if they have a single default value. In all other cases, they will be shown. */
	skippable?:boolean | `@${string}`,
	/** Optional list of serialized `Validator` classes to execute upon answer of this question set. These validators will be have access/context of all questions within the question set (as opposed to question validators which don't). */
	validators?:boolean | `@${string}`,
	/** The order this question set will be delivered in relation to other question sets. */
	order?:boolean | `@${string}`,
	questions?:ValueTypes["QuestionType"],
	/** For nested forms. Only used for `input_type` with `form` or `form-list` values. */
	parentQuestions?:ValueTypes["QuestionType"],
	rhetoricals?:ValueTypes["RhetoricalType"],
	enquiries?:ValueTypes["EnquiryType"],
	coverQuestionSets?:ValueTypes["CoverQuestionSetType"],
	exposureQuestionSets?:ValueTypes["ExposureQuestionSetType"],
		__typename?: boolean | `@${string}`
}>;
	["QuestionType"]: AliasType<{
	id?:boolean | `@${string}`,
	questionSet?:ValueTypes["QuestionSetType"],
	/** The input field label. */
	label?:boolean | `@${string}`,
	/** The summary display label, falls back to the `label` if not set. */
	displayLabel?:boolean | `@${string}`,
	/** Used to optionally display a more prominent title for a question. (Usually used in combination with `{"show_label": False}` on `input_args`) */
	title?:boolean | `@${string}`,
	/** An optional caption for the input field, displayed underneath it. */
	help?:boolean | `@${string}`,
	/** The type of input field for this question. See `inputRegistry` and `displayRegistry` for possible values. */
	inputType?:boolean | `@${string}`,
	/** Special arguments to be passed (as props) to the chosen `input_type`, that allows customizing its behavour. Check the chosen `input_type` component (or other similar questions) for possible values for each input type. */
	inputArgs?:boolean | `@${string}`,
	/** For nested forms. Only used for `input_type` with `form` or `form-list` values. */
	inputForm?:ValueTypes["QuestionSetType"],
	/** The path to where the answer from the user will be stored. */
	storagePath?:boolean | `@${string}`,
	/** Default value (if any). */
	default?:boolean | `@${string}`,
	/** Optional list of serialized `Validator` classes to execute upon answer of this question. */
	validators?:boolean | `@${string}`,
	/** The order this question will be delivered in relation to other questions. */
	order?:boolean | `@${string}`,
	/** Metadata for this question. */
	metadata?:boolean | `@${string}`,
	answers?:ValueTypes["AnswerType"],
	rhetoricals?:ValueTypes["RhetoricalType"],
		__typename?: boolean | `@${string}`
}>;
	["AnswerType"]: AliasType<{
	id?:boolean | `@${string}`,
	question?:ValueTypes["QuestionType"],
	value?:boolean | `@${string}`,
	source?:ValueTypes["DataProviderType"],
		__typename?: boolean | `@${string}`
}>;
	["DataProviderType"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RhetoricalType"]: AliasType<{
	id?:boolean | `@${string}`,
	/** An internal reference name to help identify this object. Needs to be unique for each release and question/question set. */
	name?:boolean | `@${string}`,
	questionSet?:ValueTypes["QuestionSetType"],
	question?:ValueTypes["QuestionType"],
	kind?:boolean | `@${string}`,
	/** Special arguments to be passed (as props) to the chosen `kind`, that allows customizing its behavour. Check the chosen `kind` component (or other similar rhetoricals) for possible values for each kind. */
	args?:boolean | `@${string}`,
	/** The order this object will be delivered in relation to other objects from this question or question set. */
	order?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["RhetoricalKind"]:RhetoricalKind;
	["EnquiryType"]: AliasType<{
	id?:boolean | `@${string}`,
	user?:ValueTypes["UserType"],
	questionFlow?:ValueTypes["QuestionFlowType"],
	questionSet?:ValueTypes["QuestionSetType"],
	timestamp?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["QuestionFlowType"]:AliasType<{
		id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"];
		['...on ExposureQuestionFlowType']?: Omit<ValueTypes["ExposureQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on CoverQuestionFlowType']?: Omit<ValueTypes["CoverQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on CoverSummaryQuestionFlowType']?: Omit<ValueTypes["CoverSummaryQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on ClaimCoverQuestionFlowType']?: Omit<ValueTypes["ClaimCoverQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on QuoteQuestionFlowType']?: Omit<ValueTypes["QuoteQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on PolicyHolderQuestionFlowType']?: Omit<ValueTypes["PolicyHolderQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on AdjustmentQuestionFlowType']?: Omit<ValueTypes["AdjustmentQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on CancellationQuestionFlowType']?: Omit<ValueTypes["CancellationQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on QuoteSummaryQuestionFlowType']?: Omit<ValueTypes["QuoteSummaryQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on KnockoutQuestionFlowType']?: Omit<ValueTypes["KnockoutQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on ClaimQuestionFlowType']?: Omit<ValueTypes["ClaimQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on UpdateQuestionFlowType']?: Omit<ValueTypes["UpdateQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on LegalQuestionFlowType']?: Omit<ValueTypes["LegalQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on PolicyDetailsQuestionFlowType']?: Omit<ValueTypes["PolicyDetailsQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		['...on ClaimProductQuestionFlowType']?: Omit<ValueTypes["ClaimProductQuestionFlowType"],keyof ValueTypes["QuestionFlowType"]>;
		__typename?: boolean | `@${string}`
}>;
	["MessageType"]: AliasType<{
	id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	content?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["MessageKind"]:MessageKind;
	["CoverQuestionSetType"]: AliasType<{
	id?:boolean | `@${string}`,
	cover?:ValueTypes["CoverType"],
	questionSet?:ValueTypes["QuestionSetType"],
		__typename?: boolean | `@${string}`
}>;
	["ExposureQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	exposure?:ValueTypes["ExposureType"],
	exposureItemKey?:boolean | `@${string}`,
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["CoverLimitationType"]: AliasType<{
	id?:boolean | `@${string}`,
	cover?:ValueTypes["CoverType"],
	key?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	overrides?:ValueTypes["CoverLimitationType"],
	/** Default limitations are enabled by default, while extra limitations are enabled by the underwriter during the adjust referral quote process. */
	level?:boolean | `@${string}`,
	overriddenBy?:ValueTypes["CoverLimitationType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["CoverLimitationKind"]:CoverLimitationKind;
	/** An enumeration. */
["CoverLimitationLevel"]:CoverLimitationLevel;
	["CoverQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	cover?:ValueTypes["CoverType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["CoverSummaryQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	cover?:ValueTypes["CoverType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["ClaimCoverQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	claimProfile?:ValueTypes["ClaimProfileType"],
	cover?:ValueTypes["CoverType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["ClaimProfileType"]: AliasType<{
	id?:boolean | `@${string}`,
	owner?:ValueTypes["UserType"],
	claim?:ValueTypes["ClaimType"],
	policyPeriods?:ValueTypes["PolicyPeriodType"],
	products?:ValueTypes["ProductType"],
	covers?:ValueTypes["CoverType"],
claimStateQuestionSets?: [{	filterBy?: ValueTypes["ClaimStateFilterEnum"] | undefined | null | Variable<any, string>},ValueTypes["QuestionSetType"]],
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ClaimType"]: AliasType<{
	id?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	policyPeriods?:ValueTypes["PolicyPeriodType"],
	claimNumber?:boolean | `@${string}`,
	claimProfile?:ValueTypes["ClaimProfileType"],
	status?:boolean | `@${string}`,
	policyNumber?:boolean | `@${string}`,
	statusType?:boolean | `@${string}`,
	statusTypeDisplay?:boolean | `@${string}`,
	decision?:boolean | `@${string}`,
	closedDate?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PolicyPeriodType"]: AliasType<{
	id?:boolean | `@${string}`,
	policy?:ValueTypes["PolicyType"],
	quote?:ValueTypes["QuoteType"],
	boundTimestamp?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	finishDate?:boolean | `@${string}`,
	periodNumber?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	/** Policy Period in effect at the moment of creating this renewal quote. */
	renewalQuotes?:ValueTypes["PolicyRenewalQuoteType"],
	claims?:ValueTypes["ClaimType"],
	transactions?:ValueTypes["TransactionType"],
	policyNumber?:boolean | `@${string}`,
	documents?:ValueTypes["GeneratedDocumentType"],
	latestTransaction?:ValueTypes["TransactionType"],
		__typename?: boolean | `@${string}`
}>;
	["PolicyType"]: AliasType<{
	id?:boolean | `@${string}`,
	policyNumber?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	autoRenewEnabled?:boolean | `@${string}`,
	currentPeriod?:ValueTypes["PolicyPeriodType"],
	status?:boolean | `@${string}`,
	periods?:ValueTypes["PolicyPeriodType"],
	updateQuotes?:ValueTypes["PolicyUpdateQuoteType"],
	cancellationQuotes?:ValueTypes["PolicyCancellationQuoteType"],
	renewalQuotes?:ValueTypes["PolicyRenewalQuoteType"],
	transactions?:ValueTypes["TransactionType"],
	documents?:ValueTypes["GeneratedDocumentType"],
	statusDisplay?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	startDate?:boolean | `@${string}`,
	finishDate?:boolean | `@${string}`,
	quote?:ValueTypes["QuoteType"],
	policyUpdate?:ValueTypes["PolicyUpdateQuoteType"],
	latestUpdate?:ValueTypes["PolicyUpdateQuoteType"],
	draftUpdate?:ValueTypes["QuoteType"],
	policyCancellationQuote?:ValueTypes["PolicyCancellationQuoteType"],
	updateAllowed?:boolean | `@${string}`,
	cancellationAllowed?:boolean | `@${string}`,
	claimsAllowed?:boolean | `@${string}`,
	latestRenewal?:ValueTypes["PolicyRenewalQuoteType"],
	latestCancellation?:ValueTypes["PolicyCancellationQuoteType"],
	isWithinRenewalPeriod?:boolean | `@${string}`,
	isPendingCancellation?:boolean | `@${string}`,
	policyPeriods?:ValueTypes["PolicyPeriodType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["PolicyStatus"]:PolicyStatus;
	["PolicyUpdateQuoteType"]: AliasType<{
	id?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	modified?:boolean | `@${string}`,
	policy?:ValueTypes["PolicyType"],
	quote?:ValueTypes["QuoteType"],
	/** Pro-rata amount balance to charge or refund. */
	proRataAmountDue?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PolicyCancellationQuoteType"]: AliasType<{
	id?:boolean | `@${string}`,
	policy?:ValueTypes["PolicyType"],
	state?:boolean | `@${string}`,
	effectiveDate?:boolean | `@${string}`,
	amountDue?:boolean | `@${string}`,
	fees?:ValueTypes["FeeSummaryType"],
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["PolicyCancellationQuoteState"]:PolicyCancellationQuoteState;
	/** The `Date` scalar type represents a Date
value as specified by
[iso8601](https://en.wikipedia.org/wiki/ISO_8601). */
["Date"]:unknown;
	["FeeSummaryType"]: AliasType<{
	breakdown?:ValueTypes["FeeType"],
	taxes?:boolean | `@${string}`,
	fees?:boolean | `@${string}`,
	stampDuty?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FeeType"]: AliasType<{
	kind?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
	feeType?:ValueTypes["FeeTypeType"],
		__typename?: boolean | `@${string}`
}>;
	["FeeTypeType"]: AliasType<{
	key?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["FeeTypeKind"]:FeeTypeKind;
	["PolicyRenewalQuoteType"]: AliasType<{
	id?:boolean | `@${string}`,
	policy?:ValueTypes["PolicyType"],
	/** Policy Period in effect at the moment of creating this renewal quote. */
	policyPeriod?:ValueTypes["PolicyPeriodType"],
	quote?:ValueTypes["QuoteType"],
	submittedTimestamp?:boolean | `@${string}`,
	canDiscard?:boolean | `@${string}`,
	canAccept?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TransactionType"]: AliasType<{
	id?:boolean | `@${string}`,
	policyPeriod?:ValueTypes["PolicyPeriodType"],
	status?:boolean | `@${string}`,
	paymentProfile?:ValueTypes["PaymentProfileType"],
	/** Unique identifier for this transaction within the payment gateway. */
	paymentGatewayTransactionReference?:boolean | `@${string}`,
	actionType?:boolean | `@${string}`,
	transactionType?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
	currency?:boolean | `@${string}`,
	policyNumber?:boolean | `@${string}`,
	statusDisplay?:boolean | `@${string}`,
	transactionTypeDisplay?:boolean | `@${string}`,
	actionTypeDisplay?:boolean | `@${string}`,
	amountWithSurcharge?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["TransactionStatus"]:TransactionStatus;
	["PaymentProfileType"]: AliasType<{
	id?:boolean | `@${string}`,
	/** To help the customer identify this payment profile (i.e. last 4 digits of a cc). */
	customerReference?:boolean | `@${string}`,
	paymentGateway?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["PaymentProfilePaymentGateway"]:PaymentProfilePaymentGateway;
	/** An enumeration. */
["TransactionActionType"]:TransactionActionType;
	/** An enumeration. */
["TransactionTransactionType"]:TransactionTransactionType;
	/** An enumeration. */
["TransactionCurrency"]:TransactionCurrency;
	["GeneratedDocumentType"]: AliasType<{
	id?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	modified?:boolean | `@${string}`,
	objectId?:boolean | `@${string}`,
	user?:ValueTypes["UserType"],
	file?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["PolicyPeriodKind"]:PolicyPeriodKind;
	/** An enumeration. */
["ClaimStatusChoices"]:ClaimStatusChoices;
	/** An enumeration. */
["ClaimStatusTypes"]:ClaimStatusTypes;
	/** An enumeration. */
["ClaimStateFilterEnum"]:ClaimStateFilterEnum;
	/** An enumeration. */
["PaymentGateway"]:PaymentGateway;
	/** The `GenericScalar` scalar type represents a generic
GraphQL scalar value that could be:
String, Boolean, Int, Float, List or Object. */
["GenericScalar"]:unknown;
	/** An enumeration. */
["RiskStateFilterEnum"]:RiskStateFilterEnum;
	/** An enumeration. */
["QuoteState"]:QuoteState;
	/** An enumeration. */
["QuoteReferralState"]:QuoteReferralState;
	["InstallmentType"]: AliasType<{
	id?:boolean | `@${string}`,
	quote?:ValueTypes["QuoteType"],
	dueDate?:boolean | `@${string}`,
	inclusivePrice?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	fees?:ValueTypes["FeeType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["InstallmentKind"]:InstallmentKind;
	["PoliciesType"]: AliasType<{
	totalItemCount?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	pageSize?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	hasNext?:boolean | `@${string}`,
	hasPrev?:boolean | `@${string}`,
	items?:ValueTypes["PolicyType"],
		__typename?: boolean | `@${string}`
}>;
	["QuotesType"]: AliasType<{
	totalItemCount?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	pageSize?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	hasNext?:boolean | `@${string}`,
	hasPrev?:boolean | `@${string}`,
	items?:ValueTypes["QuoteType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["QuoteFilterBy"]:QuoteFilterBy;
	["QuoteDetailType"]: AliasType<{
	details?:ValueTypes["QuoteType"],
	notes?:ValueTypes["NoteType"],
		__typename?: boolean | `@${string}`
}>;
	["NoteType"]: AliasType<{
	id?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	content?:boolean | `@${string}`,
	author?:ValueTypes["UserType"],
		__typename?: boolean | `@${string}`
}>;
	["ClaimsType"]: AliasType<{
	totalItemCount?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	pageSize?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	hasNext?:boolean | `@${string}`,
	hasPrev?:boolean | `@${string}`,
	items?:ValueTypes["ClaimType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["ClaimFilterBy"]:ClaimFilterBy;
	["ClaimDetailType"]: AliasType<{
	details?:ValueTypes["ClaimType"],
	notes?:ValueTypes["NoteType"],
		__typename?: boolean | `@${string}`
}>;
	["ReportsType"]: AliasType<{
	totalItemCount?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	pageSize?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	hasNext?:boolean | `@${string}`,
	hasPrev?:boolean | `@${string}`,
	items?:ValueTypes["ReportType"],
	reportTypes?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReportType"]: AliasType<{
	id?:boolean | `@${string}`,
	file?:boolean | `@${string}`,
	/** Start date/time of report data date range. */
	startDatetime?:boolean | `@${string}`,
	/** End date/time of report data date range. */
	endDatetime?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	generatedDate?:boolean | `@${string}`,
	reportType?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	taskStatus?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DataAnalyticsType"]: AliasType<{
	totalQuotes?:ValueTypes["DataAnalyticsCardType"],
	quotesThisMonth?:ValueTypes["DataAnalyticsCardType"],
	policiesByStatus?:ValueTypes["DataAnalyticsCardType"],
	policiesRenewed?:ValueTypes["DataAnalyticsCardType"],
	totalActivePolicies?:ValueTypes["DataAnalyticsCardType"],
	totalCustomers?:ValueTypes["DataAnalyticsCardType"],
	totalClaims?:ValueTypes["DataAnalyticsCardType"],
	conversionRate?:ValueTypes["DataAnalyticsCardType"],
	totalGwp?:ValueTypes["DataAnalyticsCardType"],
		__typename?: boolean | `@${string}`
}>;
	["DataAnalyticsCardType"]: AliasType<{
	title?:boolean | `@${string}`,
	summaryValue?:boolean | `@${string}`,
	summaryValueType?:boolean | `@${string}`,
	statistics?:ValueTypes["DataAnalyticsStatisticType"],
		__typename?: boolean | `@${string}`
}>;
	["DataAnalyticsStatisticType"]: AliasType<{
	label?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SsoConfigurationType"]: AliasType<{
	/** Unique identifier for this configuration within the IDP platform. This is required to authenticate authenticator as a client. */
	clientIdKey?:boolean | `@${string}`,
	/** Login URL for this configuration. For the login button link use the Login initialize URL. */
	loginUrl?:boolean | `@${string}`,
	/** Logout URL for this configuration. */
	logoutUrl?:boolean | `@${string}`,
	/** Call back URL for this configuration. */
	callbackUrl?:boolean | `@${string}`,
	/** Success redirect URL for this configuration. */
	successRedirectUrl?:boolean | `@${string}`,
	/** Error redirect URL for this configuration. */
	errorRedirectUrl?:boolean | `@${string}`,
	isClientSecretKeySet?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DownloadDocumentType"]: AliasType<{
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DownloadFileType"]: AliasType<{
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AnzsicCodeDivisionType"]: AliasType<{
	id?:boolean | `@${string}`,
	year?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	subdivisions?:ValueTypes["AnzsicCodeSubdivisionType"],
		__typename?: boolean | `@${string}`
}>;
	["AnzsicCodeSubdivisionType"]: AliasType<{
	id?:boolean | `@${string}`,
	division?:ValueTypes["AnzsicCodeDivisionType"],
	year?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	groups?:ValueTypes["AnzsicCodeGroupType"],
		__typename?: boolean | `@${string}`
}>;
	["AnzsicCodeGroupType"]: AliasType<{
	id?:boolean | `@${string}`,
	subdivision?:ValueTypes["AnzsicCodeSubdivisionType"],
	year?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	classes?:ValueTypes["AnzsicCodeClassType"],
		__typename?: boolean | `@${string}`
}>;
	["AnzsicCodeClassType"]: AliasType<{
	id?:boolean | `@${string}`,
	group?:ValueTypes["AnzsicCodeGroupType"],
	year?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ClaimStateType"]: AliasType<{
	claimProfile?:ValueTypes["ClaimProfileType"],
	questionSets?:ValueTypes["QuestionSetType"],
		__typename?: boolean | `@${string}`
}>;
	["RiskStateType"]: AliasType<{
	riskProfile?:ValueTypes["RiskProfileType"],
	questionSets?:ValueTypes["QuestionSetType"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeType"]: AliasType<{
	logo?:ValueTypes["LogoType"],
	themeOverride?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LogoType"]: AliasType<{
	src?:boolean | `@${string}`,
	altText?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CybersourceContextType"]: AliasType<{
	context?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateAddressBzType"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SearchAddressBzType"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PaymentMethodType"]: AliasType<{
	cardNumber?:boolean | `@${string}`,
	cardType?:boolean | `@${string}`,
	expiryDate?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mutation"]: AliasType<{
	admin?:ValueTypes["AdminMutation"],
hijackUser?: [{	input: ValueTypes["HijackUserInput"] | Variable<any, string>},ValueTypes["TokenType"]],
	/** Release user endpoint.

This endpoint triggers the django-release function. */
	releaseUser?:ValueTypes["TokenType"],
ssoVerification?: [{	authenticatorType: string | Variable<any, string>,	credential?: string | undefined | null | Variable<any, string>},ValueTypes["TokenType"]],
ssoAuthenticate?: [{	authenticatorType: string | Variable<any, string>},ValueTypes["SsoRedirectType"]],
completePayment?: [{	input?: ValueTypes["CompletePaymentInput"] | undefined | null | Variable<any, string>},ValueTypes["CompletePaymentMutation"]],
confirmQuote?: [{	riskProfileId: string | Variable<any, string>},ValueTypes["ConfirmQuoteMutation"]],
updatePaymentMethod?: [{	input?: ValueTypes["UpdatePaymentMethodInput"] | undefined | null | Variable<any, string>},ValueTypes["UpdatePaymentMethodMutation"]],
refreshUser?: [{	input?: ValueTypes["RefreshUserInput"] | undefined | null | Variable<any, string>},ValueTypes["TokenType"]],
tokenAuth?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>},ValueTypes["ObtainJSONWebToken"]],
	/** Logout a user. */
	logoutUser?:ValueTypes["LogoutUserMutation"],
sendPasswordResetEmail?: [{	email: string | Variable<any, string>},ValueTypes["SendPasswordResetEmailMutation"]],
passwordReset?: [{	token: string | Variable<any, string>,	newPassword1: string | Variable<any, string>,	newPassword2: string | Variable<any, string>},ValueTypes["PasswordReset"]],
updateAccount?: [{	contactEmail?: string | undefined | null | Variable<any, string>},ValueTypes["UpdateAccount"]],
registerUser?: [{	email: string | Variable<any, string>,	password1: string | Variable<any, string>,	password2: string | Variable<any, string>},ValueTypes["RegisterUserMutation"]],
registerPasswordLessUser?: [{	email: string | Variable<any, string>},ValueTypes["RegisterPasswordLessUserMutation"]],
updateSsoConfiguration?: [{	input?: ValueTypes["SsoConfigurationInput"] | undefined | null | Variable<any, string>},ValueTypes["SsoConfigurationOutputType"]],
dataImport?: [{	input: ValueTypes["DataImportInput"] | Variable<any, string>},ValueTypes["DataImportMutation"]],
sortedImport?: [{	input?: ValueTypes["SortedImportInput"] | undefined | null | Variable<any, string>},ValueTypes["SortedImportMutation"]],
startQuote?: [{	input?: ValueTypes["StartQuoteInput"] | undefined | null | Variable<any, string>},ValueTypes["QuoteQuestionFlowType"]],
startCancellation?: [{	input?: ValueTypes["StartPolicyCancellationInput"] | undefined | null | Variable<any, string>},ValueTypes["CancellationQuestionFlowType"]],
startCover?: [{	input?: ValueTypes["StartCoverInput"] | undefined | null | Variable<any, string>},ValueTypes["CoverQuestionFlowType"]],
startCoverSummary?: [{	input?: ValueTypes["StartCoverSummaryInput"] | undefined | null | Variable<any, string>},ValueTypes["CoverSummaryQuestionFlowType"]],
startExposure?: [{	input?: ValueTypes["StartExposureInput"] | undefined | null | Variable<any, string>},ValueTypes["ExposureQuestionFlowType"]],
startQuoteSummary?: [{	input?: ValueTypes["StartQuoteSummaryInput"] | undefined | null | Variable<any, string>},ValueTypes["QuoteSummaryQuestionFlowType"]],
startPolicyholder?: [{	input?: ValueTypes["StartPolicyHolderInput"] | undefined | null | Variable<any, string>},ValueTypes["PolicyHolderQuestionFlowType"]],
startKnockouts?: [{	input?: ValueTypes["StartKnockoutsInput"] | undefined | null | Variable<any, string>},ValueTypes["KnockoutQuestionFlowType"]],
startClaim?: [{	input?: ValueTypes["StartClaimInput"] | undefined | null | Variable<any, string>},ValueTypes["ClaimQuestionFlowType"]],
submitClaim?: [{	input: ValueTypes["SubmitClaimInput"] | Variable<any, string>},ValueTypes["ClaimType"]],
answerEnquiry?: [{	input: ValueTypes["AnswerEnquiryInput"] | Variable<any, string>},ValueTypes["QuestionFlowType"]],
priceRiskProfile?: [{	input: ValueTypes["RiskProfileInput"] | Variable<any, string>},ValueTypes["RiskProfileType"]],
updateRiskCover?: [{	input: ValueTypes["UpdateRiskCoverInput"] | Variable<any, string>},ValueTypes["RiskProfileType"]],
updateRiskExposure?: [{	input: ValueTypes["UpdateRiskExposureInput"] | Variable<any, string>},ValueTypes["RiskProfileType"]],
updatePolicy?: [{	input: ValueTypes["UpdatePolicyInput"] | Variable<any, string>},ValueTypes["PolicyType"]],
bindQuotes?: [{	input: ValueTypes["BindQuotesInput"] | Variable<any, string>},ValueTypes["PolicyPeriodType"]],
generateDocuments?: [{	policyId?: string | undefined | null | Variable<any, string>,	quoteId?: string | undefined | null | Variable<any, string>},ValueTypes["GenerateDocuments"]],
generateDocument?: [{	force?: boolean | undefined | null | Variable<any, string>,	policyId?: string | undefined | null | Variable<any, string>,	quoteId?: string | undefined | null | Variable<any, string>,	type?: string | undefined | null | Variable<any, string>},ValueTypes["GenerateDocument"]],
startPolicyUpdate?: [{	input?: ValueTypes["StartPolicyUpdateInput"] | undefined | null | Variable<any, string>},ValueTypes["UpdateQuestionFlowType"]],
confirmPolicyUpdate?: [{	input: ValueTypes["ConfirmPolicyUpdateInput"] | Variable<any, string>},ValueTypes["PolicyType"]],
policyUpdateSummary?: [{	input: ValueTypes["PolicyUpdateSummaryInput"] | Variable<any, string>},ValueTypes["PolicyUpdateSummaryChangesType"]],
policyCancellationSummary?: [{	input: ValueTypes["PolicyCancellationSummaryInput"] | Variable<any, string>},ValueTypes["PolicyCancellationQuoteType"]],
confirmPolicyCancellation?: [{	input: ValueTypes["ConfirmPolicyCancellationInput"] | Variable<any, string>},ValueTypes["PolicyType"]],
policyRenewalSummary?: [{	input: ValueTypes["PolicyRenewalSummaryInput"] | Variable<any, string>},ValueTypes["PolicyRenewalSummaryChangesType"]],
toggleEnabledProducts?: [{	input: ValueTypes["ToggleEnabledProductsInput"] | Variable<any, string>},ValueTypes["RiskProfileType"]],
discardRenewalQuote?: [{	input: ValueTypes["RenewalQuoteInput"] | Variable<any, string>},ValueTypes["PolicyRenewalQuoteType"]],
createRenewalQuote?: [{	input: ValueTypes["CreateRenewalQuoteInput"] | Variable<any, string>},ValueTypes["PolicyRenewalQuoteType"]],
acceptRenewalQuote?: [{	input: ValueTypes["RenewalQuoteInput"] | Variable<any, string>},ValueTypes["PolicyRenewalQuoteType"]],
		__typename?: boolean | `@${string}`
}>;
	["AdminMutation"]: AliasType<{
closeClaim?: [{	claimId: string | Variable<any, string>,	decision: ValueTypes["ClosedStatus"] | Variable<any, string>},ValueTypes["CloseClaimMutation"]],
createLazyUser?: [{	input: ValueTypes["CreateLazyUserInput"] | Variable<any, string>},ValueTypes["UserType"]],
createNote?: [{	assocObjId: string | Variable<any, string>,	assocObjModel: ValueTypes["NoteAssociationLimit"] | Variable<any, string>,	content: string | Variable<any, string>},ValueTypes["NoteType"]],
editReferredQuote?: [{	input?: ValueTypes["EditQuoteInput"] | undefined | null | Variable<any, string>},ValueTypes["QuoteQuestionFlowType"]],
editPolicyholder?: [{	input?: ValueTypes["EditPolicyholderInput"] | undefined | null | Variable<any, string>},ValueTypes["PolicyHolderQuestionFlowType"]],
emailQuote?: [{	input: ValueTypes["SendQuoteEmailInput"] | Variable<any, string>},ValueTypes["SendQuoteEmailMutation"]],
generateReport?: [{	input?: ValueTypes["GenerateReportInput"] | undefined | null | Variable<any, string>},ValueTypes["ReportType"]],
priceReferredRiskProfile?: [{	checkReferred?: boolean | undefined | null | Variable<any, string>,	riskProfileId: string | Variable<any, string>},ValueTypes["RiskProfileType"]],
startAdjustment?: [{	input?: ValueTypes["StartAdjustmentInput"] | undefined | null | Variable<any, string>},ValueTypes["AdjustmentQuestionFlowType"]],
updateQuoteReferralState?: [{	note?: string | undefined | null | Variable<any, string>,	quoteId: string | Variable<any, string>,	referralState: ValueTypes["ReferralState"] | Variable<any, string>},ValueTypes["UpdateQuoteReferralStateMutation"]],
discardRenewalQuote?: [{	input?: ValueTypes["RenewalQuoteInput"] | undefined | null | Variable<any, string>},ValueTypes["AdminDiscardRenewalQuoteMutation"]],
		__typename?: boolean | `@${string}`
}>;
	["CloseClaimMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	claim?:ValueTypes["ClaimType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["ClosedStatus"]:ClosedStatus;
	["CreateLazyUserInput"]: {
	email: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>
};
	/**
    Enumeration to define valid associations for a note.

    Enum Members:
    - POLICY: Association with a policy object in the 'insurance' app.
    - QUOTE: Association with a quote object in the 'insurance' app.
    - CLAIM: Association with a claim object in the 'insurance' app.
     */
["NoteAssociationLimit"]:NoteAssociationLimit;
	["QuoteQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["EditQuoteInput"]: {
	quoteId: string | Variable<any, string>
};
	["PolicyHolderQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["EditPolicyholderInput"]: {
	riskProfileId: string | Variable<any, string>
};
	/** Send quote email endpoint.

This endpoint will email a quote link to user */
["SendQuoteEmailMutation"]: AliasType<{
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SendQuoteEmailInput"]: {
	quoteId: string | Variable<any, string>,
	toEmail: string | Variable<any, string>
};
	["GenerateReportInput"]: {
	reportType: string | Variable<any, string>,
	startDate: string | Variable<any, string>,
	endDate: string | Variable<any, string>
};
	["AdjustmentQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["StartAdjustmentInput"]: {
	riskProfileId: string | Variable<any, string>,
	questionSetKey?: string | undefined | null | Variable<any, string>,
	restart?: boolean | undefined | null | Variable<any, string>
};
	/** Update a referred quote's referral state. */
["UpdateQuoteReferralStateMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	quote?:ValueTypes["QuoteType"],
	note?:ValueTypes["NoteType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["ReferralState"]:ReferralState;
	["AdminDiscardRenewalQuoteMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	renewalQuote?:ValueTypes["PolicyRenewalQuoteType"],
		__typename?: boolean | `@${string}`
}>;
	["RenewalQuoteInput"]: {
	renewalQuoteId: string | Variable<any, string>
};
	["TokenType"]: AliasType<{
	token?:boolean | `@${string}`,
	user?:ValueTypes["UserType"],
		__typename?: boolean | `@${string}`
}>;
	["HijackUserInput"]: {
	userId: string | Variable<any, string>
};
	["SsoRedirectType"]: AliasType<{
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompletePaymentMutation"]: AliasType<{
	paymentSuccess?:boolean | `@${string}`,
	bindSuccess?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompletePaymentInput"]: {
	riskProfileId: string | Variable<any, string>,
	metadata: ValueTypes["GenericScalar"] | Variable<any, string>
};
	["ConfirmQuoteMutation"]: AliasType<{
	paymentSuccess?:boolean | `@${string}`,
	bindSuccess?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdatePaymentMethodMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdatePaymentMethodInput"]: {
	metadata: ValueTypes["GenericScalar"] | Variable<any, string>
};
	["RefreshUserInput"]: {
	distributionPartner?: string | undefined | null | Variable<any, string>
};
	/** Authenticate a given email/password combination. */
["ObtainJSONWebToken"]: AliasType<{
	token?:boolean | `@${string}`,
	user?:ValueTypes["UserType"],
		__typename?: boolean | `@${string}`
}>;
	/** Logout a user. */
["LogoutUserMutation"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Resets the password of a user and sends them an email.

If the user has an unusable password, this will do nothing; no error will be raised
and and no email will be sent. */
["SendPasswordResetEmailMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/**
    Errors messages and codes mapped to
    fields or non fields errors.
    Example:
    {
        field_name: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ],
        other_field: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ],
        nonFieldErrors: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ]
    }
     */
["ExpectedErrorType"]:unknown;
	/** Change user password without old password.

Receive the token that was sent by email.

If token and new passwords are valid, update
user password and in case of using refresh
tokens, revoke all of them.

Also, if user has not been verified yet, verify it. */
["PasswordReset"]: AliasType<{
	success?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdateAccount"]: AliasType<{
	success?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Convert an existing LazyUser/PasswordLessUser into a User. */
["RegisterUserMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
	user?:ValueTypes["UserType"],
	token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Convert an existing LazyUser into a PasswordLessUser. */
["RegisterPasswordLessUserMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
	user?:ValueTypes["UserType"],
	token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SsoConfigurationOutputType"]: AliasType<{
	clientIdKey?:boolean | `@${string}`,
	loginUrl?:boolean | `@${string}`,
	logoutUrl?:boolean | `@${string}`,
	callbackUrl?:boolean | `@${string}`,
	successRedirectUrl?:boolean | `@${string}`,
	errorRedirectUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SsoConfigurationInput"]: {
	clientIdKey?: string | undefined | null | Variable<any, string>,
	clientSecretKey?: string | undefined | null | Variable<any, string>,
	loginUrl?: string | undefined | null | Variable<any, string>,
	logoutUrl?: string | undefined | null | Variable<any, string>,
	callbackUrl?: string | undefined | null | Variable<any, string>,
	successRedirectUrl?: string | undefined | null | Variable<any, string>,
	errorRedirectUrl?: string | undefined | null | Variable<any, string>
};
	/** Perform a Data Import for a new or existing user.

A risk profile is created and a one-time login link is returned. */
["DataImportMutation"]: AliasType<{
	oneTimeLoginUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DataImportInput"]: {
	distributionPartner: string | Variable<any, string>,
	enabledProducts: Array<string | undefined | null> | Variable<any, string>,
	userReference?: string | undefined | null | Variable<any, string>,
	email?: string | undefined | null | Variable<any, string>,
	riskData?: ValueTypes["GenericScalar"] | undefined | null | Variable<any, string>
};
	["SortedImportMutation"]: AliasType<{
	loginUrl?:boolean | `@${string}`,
	user?:ValueTypes["SortedUserType"],
		__typename?: boolean | `@${string}`
}>;
	["SortedUserType"]: AliasType<{
	id?:boolean | `@${string}`,
	sortedId?:boolean | `@${string}`,
	customerNumber?:boolean | `@${string}`,
	user?:ValueTypes["UserType"],
	email?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	workPhone?:boolean | `@${string}`,
	homePhone?:boolean | `@${string}`,
	mobile?:boolean | `@${string}`,
	dateOfBirth?:boolean | `@${string}`,
	propertyRoles?:ValueTypes["SortedUserPropertyRoleType"],
		__typename?: boolean | `@${string}`
}>;
	["SortedUserPropertyRoleType"]: AliasType<{
	id?:boolean | `@${string}`,
	sortedUser?:ValueTypes["SortedUserType"],
	serviceNumber?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
		__typename?: boolean | `@${string}`
}>;
	["SortedImportInput"]: {
	customerNumber: string | Variable<any, string>,
	serviceNumber: string | Variable<any, string>,
	email: string | Variable<any, string>
};
	["StartQuoteInput"]: {
	create?: boolean | undefined | null | Variable<any, string>,
	questionSetKey?: string | undefined | null | Variable<any, string>,
	enabledProducts?: Array<string | undefined | null> | undefined | null | Variable<any, string>,
	restart?: boolean | undefined | null | Variable<any, string>,
	autoQuote?: boolean | undefined | null | Variable<any, string>,
	fileLink?: string | undefined | null | Variable<any, string>
};
	["CancellationQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["StartPolicyCancellationInput"]: {
	policyId: string | Variable<any, string>,
	questionSetKey?: string | undefined | null | Variable<any, string>,
	restart?: boolean | undefined | null | Variable<any, string>
};
	["StartCoverInput"]: {
	riskProfileId: string | Variable<any, string>,
	coverId: string | Variable<any, string>,
	questionSetKey?: string | undefined | null | Variable<any, string>,
	restart?: boolean | undefined | null | Variable<any, string>
};
	["StartCoverSummaryInput"]: {
	riskProfileId: string | Variable<any, string>,
	coverId: string | Variable<any, string>,
	questionSetKey?: string | undefined | null | Variable<any, string>,
	restart?: boolean | undefined | null | Variable<any, string>
};
	["StartExposureInput"]: {
	riskProfileId: string | Variable<any, string>,
	exposureId: string | Variable<any, string>,
	exposureItemKey?: string | undefined | null | Variable<any, string>,
	questionSetKey?: string | undefined | null | Variable<any, string>,
	restart?: boolean | undefined | null | Variable<any, string>
};
	["QuoteSummaryQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["StartQuoteSummaryInput"]: {
	riskProfileId: string | Variable<any, string>,
	questionSetKey?: string | undefined | null | Variable<any, string>,
	restart?: boolean | undefined | null | Variable<any, string>
};
	["StartPolicyHolderInput"]: {
	riskProfileId: string | Variable<any, string>,
	questionSetKey?: string | undefined | null | Variable<any, string>,
	restart?: boolean | undefined | null | Variable<any, string>
};
	["KnockoutQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["StartKnockoutsInput"]: {
	riskProfileId: string | Variable<any, string>,
	questionSetKey?: string | undefined | null | Variable<any, string>,
	restart?: boolean | undefined | null | Variable<any, string>
};
	["ClaimQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	claimProfile?:ValueTypes["ClaimProfileType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["StartClaimInput"]: {
	policyId: string | Variable<any, string>,
	questionSetKey?: string | undefined | null | Variable<any, string>,
	restart?: boolean | undefined | null | Variable<any, string>
};
	["SubmitClaimInput"]: {
	claimProfileId: string | Variable<any, string>
};
	["AnswerEnquiryInput"]: {
	questionFlowId: string | Variable<any, string>,
	answers?: ValueTypes["JSONString"] | undefined | null | Variable<any, string>,
	skipNext?: boolean | undefined | null | Variable<any, string>
};
	["RiskProfileInput"]: {
	riskProfileId: string | Variable<any, string>,
	enabledProducts?: Array<string | undefined | null> | undefined | null | Variable<any, string>
};
	["UpdateRiskCoverInput"]: {
	riskProfileId: string | Variable<any, string>,
	coverId: string | Variable<any, string>,
	enabled?: boolean | undefined | null | Variable<any, string>,
	answers?: ValueTypes["JSONString"] | undefined | null | Variable<any, string>
};
	["UpdateRiskExposureInput"]: {
	riskProfileId: string | Variable<any, string>,
	exposureId: string | Variable<any, string>,
	exposureItemKey: string | Variable<any, string>,
	enabled?: boolean | undefined | null | Variable<any, string>,
	answers?: ValueTypes["JSONString"] | undefined | null | Variable<any, string>
};
	["UpdatePolicyInput"]: {
	policyId: string | Variable<any, string>,
	autoRenewEnabled?: boolean | undefined | null | Variable<any, string>
};
	["BindQuotesInput"]: {
	riskProfileId: string | Variable<any, string>
};
	/** Generates multiple documents.

If 'quote_id' or 'policy_id' is provided, this will generate all documents
associated with the 'quote' or 'bind' events depending on which was provided. */
["GenerateDocuments"]: AliasType<{
	documents?:ValueTypes["GeneratedDocumentType"],
		__typename?: boolean | `@${string}`
}>;
	/** Generates a single document for the given 'type'.

'quote_id' or 'policy_id' is required to link the generated document to and find
the relevant product. */
["GenerateDocument"]: AliasType<{
	document?:ValueTypes["GeneratedDocumentType"],
		__typename?: boolean | `@${string}`
}>;
	["UpdateQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
	riskProfile?:ValueTypes["RiskProfileType"],
		__typename?: boolean | `@${string}`
}>;
	["StartPolicyUpdateInput"]: {
	policyId: string | Variable<any, string>,
	flow?: string | undefined | null | Variable<any, string>,
	questionSetKey?: string | undefined | null | Variable<any, string>,
	create?: boolean | undefined | null | Variable<any, string>,
	restart?: boolean | undefined | null | Variable<any, string>,
	coverId?: string | undefined | null | Variable<any, string>,
	autoQuote?: boolean | undefined | null | Variable<any, string>
};
	["ConfirmPolicyUpdateInput"]: {
	policyId: string | Variable<any, string>,
	startDate: ValueTypes["Date"] | Variable<any, string>,
	autoRenewEnabled?: boolean | undefined | null | Variable<any, string>
};
	["PolicyUpdateSummaryChangesType"]: AliasType<{
	proRataAmount?:boolean | `@${string}`,
	oldPeriodicPrice?:boolean | `@${string}`,
	newPeriodicPrice?:boolean | `@${string}`,
	surcharge?:boolean | `@${string}`,
	amountDue?:boolean | `@${string}`,
	oldPaymentFrequency?:boolean | `@${string}`,
	newPaymentFrequency?:boolean | `@${string}`,
	newStartDate?:boolean | `@${string}`,
	newFinishDate?:boolean | `@${string}`,
	summary?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PolicyUpdateSummaryInput"]: {
	policyId: string | Variable<any, string>
};
	["PolicyCancellationSummaryInput"]: {
	policyId: string | Variable<any, string>
};
	["ConfirmPolicyCancellationInput"]: {
	policyId: string | Variable<any, string>,
	policyCancellationQuoteId: string | Variable<any, string>
};
	["PolicyRenewalSummaryChangesType"]: AliasType<{
	proRataAmount?:boolean | `@${string}`,
	oldPeriodicPrice?:boolean | `@${string}`,
	newPeriodicPrice?:boolean | `@${string}`,
	surcharge?:boolean | `@${string}`,
	amountDue?:boolean | `@${string}`,
	oldPaymentFrequency?:boolean | `@${string}`,
	newPaymentFrequency?:boolean | `@${string}`,
	newStartDate?:boolean | `@${string}`,
	newFinishDate?:boolean | `@${string}`,
	summary?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PolicyRenewalSummaryInput"]: {
	policyId: string | Variable<any, string>
};
	["ToggleEnabledProductsInput"]: {
	riskProfileId: string | Variable<any, string>,
	productKey: string | Variable<any, string>,
	enabled?: boolean | undefined | null | Variable<any, string>,
	answers?: ValueTypes["JSONString"] | undefined | null | Variable<any, string>
};
	["CreateRenewalQuoteInput"]: {
	policyId: string | Variable<any, string>
};
	["LegalQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["PolicyDetailsQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ValueTypes["RiskProfileType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["ClaimProductQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ValueTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	claimProfile?:ValueTypes["ClaimProfileType"],
	history?:ValueTypes["EnquiryType"],
	messages?:ValueTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>
  }

export type ResolverInputTypes = {
    ["Query"]: AliasType<{
stripeConfig?: [{	productKey: string},ResolverInputTypes["StripeConfigType"]],
paymentBreakdown?: [{	riskProfileId: string,	paymentMethodId: string},ResolverInputTypes["PaymentBreakdownType"]],
	admin?:ResolverInputTypes["AdminType"],
	/** Return details for an Organization. */
	organization?:ResolverInputTypes["OrganizationType"],
	/** Return details for an SSO Configuration. */
	ssoConfiguration?:ResolverInputTypes["SsoConfigurationType"],
documents?: [{	document_Type?: Array<string | undefined | null> | undefined | null},ResolverInputTypes["GeneratedDocumentType"]],
download?: [{	id: string},ResolverInputTypes["DownloadDocumentType"]],
downloadFile?: [{	key: string},ResolverInputTypes["DownloadFileType"]],
allAnzsicCodeDivisions?: [{	year: string},ResolverInputTypes["AnzsicCodeDivisionType"]],
	allQuestionSets?:ResolverInputTypes["QuestionSetType"],
	allQuestions?:ResolverInputTypes["QuestionType"],
claim?: [{	id: string},ResolverInputTypes["ClaimType"]],
claimProfile?: [{	id: string},ResolverInputTypes["ClaimProfileType"]],
claimState?: [{	claimProfileId: string,	filterBy?: ResolverInputTypes["ClaimStateFilterEnum"] | undefined | null},ResolverInputTypes["ClaimStateType"]],
riskProfile?: [{	id: string},ResolverInputTypes["RiskProfileType"]],
policy?: [{	id: string},ResolverInputTypes["PolicyType"]],
policies?: [{	/** Status (all, active, inactive) */
	status?: string | undefined | null,	/** Django object unique identification field */
	id?: string | undefined | null},ResolverInputTypes["PolicyType"]],
	/** Return the active policy if there is one. */
	activePolicy?:ResolverInputTypes["PolicyType"],
availableCovers?: [{	riskProfileId: string},ResolverInputTypes["CoverType"]],
riskState?: [{	riskProfileId: string,	filterBy?: ResolverInputTypes["RiskStateFilterEnum"] | undefined | null},ResolverInputTypes["RiskStateType"]],
coverLimitations?: [{	kind?: ResolverInputTypes["CoverLimitationKind"] | undefined | null,	cover?: string | undefined | null,	/** Django object unique identification field */
	id?: string | undefined | null,	/** Number of results to return per page. Default 'default_limit': None, and 'max_limit': None */
	limit?: number | undefined | null,	/** The initial index from which to return the results. Default: 0 */
	offset?: number | undefined | null,	/** A string or comma delimited string values that indicate the default ordering when obtaining lists of objects. */
	ordering?: string | undefined | null},ResolverInputTypes["CoverLimitationType"]],
policyUpdateQuote?: [{	id: string},ResolverInputTypes["PolicyUpdateQuoteType"]],
policyUpdate?: [{	id: string},ResolverInputTypes["PolicyUpdateQuoteType"]],
policyCancellationQuote?: [{	policyId: string},ResolverInputTypes["PolicyCancellationQuoteType"]],
policyRenewalQuote?: [{	policyId: string},ResolverInputTypes["PolicyRenewalQuoteType"]],
	/** Theme definition */
	loadTheme?:ResolverInputTypes["ThemeType"],
	/** Generate context for Cybersource card tokenization */
	cybersourceGenerateContext?:ResolverInputTypes["CybersourceContextType"],
claims?: [{	/** Status type (open, close) */
	statusType?: string | undefined | null,	/** Django object unique identification field */
	id?: string | undefined | null},ResolverInputTypes["ClaimType"]],
validateAddressBz?: [{	address: string},ResolverInputTypes["ValidateAddressBzType"]],
searchAddressBz?: [{	query: string},ResolverInputTypes["SearchAddressBzType"]],
	paymentMethod?:ResolverInputTypes["PaymentMethodType"],
	claimsAllowed?:boolean | `@${string}`,
riskProfilePaymentAllowed?: [{	id: string},boolean | `@${string}`],
		__typename?: boolean | `@${string}`
}>;
	["StripeConfigType"]: AliasType<{
	account?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PaymentBreakdownType"]: AliasType<{
	premium?:boolean | `@${string}`,
	surcharge?:boolean | `@${string}`,
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AdminType"]: AliasType<{
customers?: [{	search?: string | undefined | null,	page?: number | undefined | null,	pageSize?: number | undefined | null},ResolverInputTypes["CustomersType"]],
customer?: [{	id: string},ResolverInputTypes["CustomerDetailType"]],
policies?: [{	search?: string | undefined | null,	page?: number | undefined | null,	pageSize?: number | undefined | null},ResolverInputTypes["PoliciesType"]],
policy?: [{	id: string},ResolverInputTypes["PolicyType"]],
quotes?: [{	search?: string | undefined | null,	filterBy?: ResolverInputTypes["QuoteFilterBy"] | undefined | null,	page?: number | undefined | null,	pageSize?: number | undefined | null},ResolverInputTypes["QuotesType"]],
quote?: [{	id: string},ResolverInputTypes["QuoteDetailType"]],
claims?: [{	search?: string | undefined | null,	filterBy?: ResolverInputTypes["ClaimFilterBy"] | undefined | null,	page?: number | undefined | null,	pageSize?: number | undefined | null},ResolverInputTypes["ClaimsType"]],
claim?: [{	id: string},ResolverInputTypes["ClaimDetailType"]],
	products?:ResolverInputTypes["ProductType"],
	distributionPartners?:ResolverInputTypes["DistributionPartnerType"],
reports?: [{	search?: string | undefined | null,	filterBy?: string | undefined | null,	page?: number | undefined | null,	pageSize?: number | undefined | null},ResolverInputTypes["ReportsType"]],
report?: [{	id: string},ResolverInputTypes["ReportType"]],
	claimsAllowed?:boolean | `@${string}`,
	/** Returns all data analytics */
	dataAnalytics?:ResolverInputTypes["DataAnalyticsType"],
		__typename?: boolean | `@${string}`
}>;
	["CustomersType"]: AliasType<{
	totalItemCount?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	pageSize?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	hasNext?:boolean | `@${string}`,
	hasPrev?:boolean | `@${string}`,
	items?:ResolverInputTypes["UserType"],
		__typename?: boolean | `@${string}`
}>;
	/** Set default page sizes for pagination. */
["PageSize"]:unknown;
	["UserType"]: AliasType<{
	id?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	isStaff?:boolean | `@${string}`,
	isActive?:boolean | `@${string}`,
	dateJoined?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	/** For lazy users only. Once a user has registered, the `email` address field is the one we care about. */
	contactEmail?:boolean | `@${string}`,
	contactNumber?:boolean | `@${string}`,
	organization?:ResolverInputTypes["OrganizationType"],
	isSsoEnabled?:boolean | `@${string}`,
	isLazy?:boolean | `@${string}`,
	isPasswordLess?:boolean | `@${string}`,
	allowCustomerPortalAccess?:boolean | `@${string}`,
	isHijacked?:boolean | `@${string}`,
	latestReferrer?:ResolverInputTypes["DistributionPartnerType"],
	allowAdminPortalAccess?:boolean | `@${string}`,
	fullName?:boolean | `@${string}`,
	allowUpdatePaymentMethod?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** The `DateTime` scalar type represents a DateTime
value as specified by
[iso8601](https://en.wikipedia.org/wiki/ISO_8601). */
["DateTime"]:unknown;
	/** Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
in fields, resolvers and input. */
["UUID"]:unknown;
	["OrganizationType"]: AliasType<{
	/** The name of the organization */
	name?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	/** The operating hours for this Organization. Will be displayed within any contact us sections. */
	operatingHours?:boolean | `@${string}`,
	/** The customer facing email address to get in touch with this Organization. Will be displayed within any contact us sections. */
	emailAddress?:boolean | `@${string}`,
	/** The website for this Organization. Will be displayed within any contact us sections. */
	website?:boolean | `@${string}`,
	/** The disclaimer will be shown in the footer of any customer facing page. Supports basic HTML. */
	disclaimer?:boolean | `@${string}`,
	disclaimerLinks?:ResolverInputTypes["DisclaimerLinksType"],
	phoneDisplay?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DisclaimerLinksType"]: AliasType<{
	name?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DistributionPartnerType"]: AliasType<{
	name?:boolean | `@${string}`,
	/** Will be used to identify the Distribution Partner when loading a product directly via URL (i.e. `/getquote?product=[product.key]&distributionPartner=[key]`) */
	key?:boolean | `@${string}`,
	/** If True, allow users coming from this distribution partner to set their password and access the customer portal. If False, they remain password-less users and can't access the customer portal. */
	allowCustomerPortalAccess?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerDetailType"]: AliasType<{
	details?:ResolverInputTypes["UserType"],
	quotes?:ResolverInputTypes["QuoteType"],
	policies?:ResolverInputTypes["PolicyType"],
	claims?:ResolverInputTypes["ClaimType"],
	payments?:ResolverInputTypes["TransactionType"],
		__typename?: boolean | `@${string}`
}>;
	["QuoteType"]: AliasType<{
	id?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	currentRiskData?:boolean | `@${string}`,
	product?:ResolverInputTypes["ProductType"],
	covers?:ResolverInputTypes["CoverType"],
	exposures?:ResolverInputTypes["ExposureType"],
	limitations?:ResolverInputTypes["CoverLimitationType"],
	state?:boolean | `@${string}`,
	referralState?:boolean | `@${string}`,
	createdTimestamp?:boolean | `@${string}`,
	quotedTimestamp?:boolean | `@${string}`,
	updatedTimestamp?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	finishDate?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	preTaxPremium?:boolean | `@${string}`,
	postTaxPremium?:boolean | `@${string}`,
	unadjustedPostTaxPremium?:boolean | `@${string}`,
	commission?:boolean | `@${string}`,
	amountDue?:boolean | `@${string}`,
	paymentFrequency?:boolean | `@${string}`,
	/** Other pricing-related figures */
	pricingOthers?:boolean | `@${string}`,
	/** Quote messages */
	messages?:boolean | `@${string}`,
	privateMessages?:boolean | `@${string}`,
	installments?:ResolverInputTypes["InstallmentType"],
	policyPeriod?:ResolverInputTypes["PolicyPeriodType"],
	policyUpdates?:ResolverInputTypes["PolicyUpdateQuoteType"],
	policyRenewals?:ResolverInputTypes["PolicyRenewalQuoteType"],
	purchaseTransactions?:ResolverInputTypes["TransactionType"],
	updateTransactions?:ResolverInputTypes["TransactionType"],
	periodicPrice?:boolean | `@${string}`,
	userReference?:boolean | `@${string}`,
	documents?:ResolverInputTypes["GeneratedDocumentType"],
	stateDisplay?:boolean | `@${string}`,
	fees?:ResolverInputTypes["FeeSummaryType"],
	referralStateDisplay?:boolean | `@${string}`,
	referredQuestionSetKeys?:boolean | `@${string}`,
	isBound?:boolean | `@${string}`,
	daysToExpiry?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RiskProfileType"]: AliasType<{
	id?:boolean | `@${string}`,
	owner?:ResolverInputTypes["UserType"],
	riskData?:boolean | `@${string}`,
	quotes?:ResolverInputTypes["QuoteType"],
	/** The original risk profile created in the Multi-Product flow */
	asParentInBundledRiskProfiles?:ResolverInputTypes["BundledRiskProfileType"],
	paymentFrequency?:boolean | `@${string}`,
	periodicPrice?:boolean | `@${string}`,
	availableProducts?:ResolverInputTypes["ProductType"],
	enabledProducts?:ResolverInputTypes["ProductType"],
	referredProducts?:ResolverInputTypes["ProductType"],
	knockoutProducts?:ResolverInputTypes["ProductType"],
	enabledCovers?:ResolverInputTypes["CoverType"],
	enabledExposures?:boolean | `@${string}`,
	enabledLimitations?:ResolverInputTypes["CoverLimitationType"],
	state?:boolean | `@${string}`,
	quoteDocumentGenerateStatus?:boolean | `@${string}`,
	policyDocumentGenerateStatus?:boolean | `@${string}`,
	policyPeriods?:ResolverInputTypes["PolicyPeriodType"],
	data?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	finishDate?:boolean | `@${string}`,
riskStateQuestionSets?: [{	filterBy?: ResolverInputTypes["RiskStateFilterEnum"] | undefined | null},ResolverInputTypes["QuestionSetType"]],
		__typename?: boolean | `@${string}`
}>;
	/** Allows use of a JSON String for input / output from the GraphQL schema.

Use of this type is *not recommended* as you lose the benefits of having a defined, static
schema (one of the key benefits of GraphQL). */
["JSONString"]:unknown;
	["BundledRiskProfileType"]: AliasType<{
	id?:boolean | `@${string}`,
	/** Used to link a risk profile to a bundle in a Multi-Product flow */
	riskProfiles?:ResolverInputTypes["RiskProfileType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["QuotePaymentFrequency"]:QuotePaymentFrequency;
	["ProductType"]: AliasType<{
	id?:boolean | `@${string}`,
	provider?:ResolverInputTypes["ProviderType"],
	key?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	covers?:ResolverInputTypes["CoverType"],
	exposures?:ResolverInputTypes["ExposureType"],
	policyCancellationQuotes?:ResolverInputTypes["PolicyCancellationQuoteType"],
	name?:boolean | `@${string}`,
	autoRenewAllowed?:boolean | `@${string}`,
	renewalPeriod?:boolean | `@${string}`,
	updateAllowed?:boolean | `@${string}`,
	cancellationAllowed?:boolean | `@${string}`,
	cancellationCoolingOffPeriod?:boolean | `@${string}`,
	claimsAllowed?:boolean | `@${string}`,
	paymentGateway?:boolean | `@${string}`,
	skipPayments?:boolean | `@${string}`,
	autoQuote?:boolean | `@${string}`,
	quoteDisclaimer?:boolean | `@${string}`,
	availableCovers?:ResolverInputTypes["CoverType"],
		__typename?: boolean | `@${string}`
}>;
	["ProviderType"]: AliasType<{
	name?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	logo?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CoverType"]: AliasType<{
	id?:boolean | `@${string}`,
	product?:ResolverInputTypes["ProductType"],
	parentCover?:ResolverInputTypes["CoverType"],
	/** Whether this cover is enabled by default on an exposure. */
	isDefault?:boolean | `@${string}`,
	exposure?:ResolverInputTypes["ExposureType"],
	key?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	icon?:boolean | `@${string}`,
	subCovers?:ResolverInputTypes["CoverType"],
	details?:ResolverInputTypes["CoverLimitationType"],
	coverQuestionSets?:ResolverInputTypes["CoverQuestionSetType"],
	coverquestionflowSet?:ResolverInputTypes["CoverQuestionFlowType"],
	coversummaryquestionflowSet?:ResolverInputTypes["CoverSummaryQuestionFlowType"],
	claimcoverquestionflowSet?:ResolverInputTypes["ClaimCoverQuestionFlowType"],
	editable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ExposureType"]: AliasType<{
	id?:boolean | `@${string}`,
	/** An identifier for the exposure. */
	key?:boolean | `@${string}`,
	/** A category for the exposure. E.g. car, property, person, etc. */
	type?:boolean | `@${string}`,
	/** Human readable text for display purposes. */
	name?:boolean | `@${string}`,
	product?:ResolverInputTypes["ProductType"],
	/** The maximum number of exposures allowed for this key for this product. */
	limit?:boolean | `@${string}`,
	/** The path in the risk data to a value used to identify the exposure. */
	userReferencePath?:boolean | `@${string}`,
	icon?:boolean | `@${string}`,
	covers?:ResolverInputTypes["CoverType"],
	exposureQuestionSets?:ResolverInputTypes["ExposureQuestionSetType"],
	exposurequestionflowSet?:ResolverInputTypes["ExposureQuestionFlowType"],
		__typename?: boolean | `@${string}`
}>;
	["ExposureQuestionSetType"]: AliasType<{
	id?:boolean | `@${string}`,
	exposure?:ResolverInputTypes["ExposureType"],
	questionSet?:ResolverInputTypes["QuestionSetType"],
	/** The key of the exposure item in the risk data that this question set is related to. Not to be confused with the db model attribute Exposure.key. */
	exposureItemKey?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["QuestionSetType"]: AliasType<{
	id?:boolean | `@${string}`,
	/** Will be used as the URL slug. */
	key?:boolean | `@${string}`,
	/** A small headline for this question set. */
	title?:boolean | `@${string}`,
	/** Main headline for this question set. */
	description?:boolean | `@${string}`,
	/** An optional label to help group the questions under this question set. */
	label?:boolean | `@${string}`,
	/** Optional help text displayed below the description. Callouts may be used instead for better display options. */
	help?:boolean | `@${string}`,
	/** Questions may be skipped (i.e. not delivered to a user) if they have a single default value. In all other cases, they will be shown. */
	skippable?:boolean | `@${string}`,
	/** Optional list of serialized `Validator` classes to execute upon answer of this question set. These validators will be have access/context of all questions within the question set (as opposed to question validators which don't). */
	validators?:boolean | `@${string}`,
	/** The order this question set will be delivered in relation to other question sets. */
	order?:boolean | `@${string}`,
	questions?:ResolverInputTypes["QuestionType"],
	/** For nested forms. Only used for `input_type` with `form` or `form-list` values. */
	parentQuestions?:ResolverInputTypes["QuestionType"],
	rhetoricals?:ResolverInputTypes["RhetoricalType"],
	enquiries?:ResolverInputTypes["EnquiryType"],
	coverQuestionSets?:ResolverInputTypes["CoverQuestionSetType"],
	exposureQuestionSets?:ResolverInputTypes["ExposureQuestionSetType"],
		__typename?: boolean | `@${string}`
}>;
	["QuestionType"]: AliasType<{
	id?:boolean | `@${string}`,
	questionSet?:ResolverInputTypes["QuestionSetType"],
	/** The input field label. */
	label?:boolean | `@${string}`,
	/** The summary display label, falls back to the `label` if not set. */
	displayLabel?:boolean | `@${string}`,
	/** Used to optionally display a more prominent title for a question. (Usually used in combination with `{"show_label": False}` on `input_args`) */
	title?:boolean | `@${string}`,
	/** An optional caption for the input field, displayed underneath it. */
	help?:boolean | `@${string}`,
	/** The type of input field for this question. See `inputRegistry` and `displayRegistry` for possible values. */
	inputType?:boolean | `@${string}`,
	/** Special arguments to be passed (as props) to the chosen `input_type`, that allows customizing its behavour. Check the chosen `input_type` component (or other similar questions) for possible values for each input type. */
	inputArgs?:boolean | `@${string}`,
	/** For nested forms. Only used for `input_type` with `form` or `form-list` values. */
	inputForm?:ResolverInputTypes["QuestionSetType"],
	/** The path to where the answer from the user will be stored. */
	storagePath?:boolean | `@${string}`,
	/** Default value (if any). */
	default?:boolean | `@${string}`,
	/** Optional list of serialized `Validator` classes to execute upon answer of this question. */
	validators?:boolean | `@${string}`,
	/** The order this question will be delivered in relation to other questions. */
	order?:boolean | `@${string}`,
	/** Metadata for this question. */
	metadata?:boolean | `@${string}`,
	answers?:ResolverInputTypes["AnswerType"],
	rhetoricals?:ResolverInputTypes["RhetoricalType"],
		__typename?: boolean | `@${string}`
}>;
	["AnswerType"]: AliasType<{
	id?:boolean | `@${string}`,
	question?:ResolverInputTypes["QuestionType"],
	value?:boolean | `@${string}`,
	source?:ResolverInputTypes["DataProviderType"],
		__typename?: boolean | `@${string}`
}>;
	["DataProviderType"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RhetoricalType"]: AliasType<{
	id?:boolean | `@${string}`,
	/** An internal reference name to help identify this object. Needs to be unique for each release and question/question set. */
	name?:boolean | `@${string}`,
	questionSet?:ResolverInputTypes["QuestionSetType"],
	question?:ResolverInputTypes["QuestionType"],
	kind?:boolean | `@${string}`,
	/** Special arguments to be passed (as props) to the chosen `kind`, that allows customizing its behavour. Check the chosen `kind` component (or other similar rhetoricals) for possible values for each kind. */
	args?:boolean | `@${string}`,
	/** The order this object will be delivered in relation to other objects from this question or question set. */
	order?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["RhetoricalKind"]:RhetoricalKind;
	["EnquiryType"]: AliasType<{
	id?:boolean | `@${string}`,
	user?:ResolverInputTypes["UserType"],
	questionFlow?:ResolverInputTypes["QuestionFlowType"],
	questionSet?:ResolverInputTypes["QuestionSetType"],
	timestamp?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["QuestionFlowType"]:AliasType<{
		id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"];
		['...on ExposureQuestionFlowType']?: Omit<ResolverInputTypes["ExposureQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on CoverQuestionFlowType']?: Omit<ResolverInputTypes["CoverQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on CoverSummaryQuestionFlowType']?: Omit<ResolverInputTypes["CoverSummaryQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on ClaimCoverQuestionFlowType']?: Omit<ResolverInputTypes["ClaimCoverQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on QuoteQuestionFlowType']?: Omit<ResolverInputTypes["QuoteQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on PolicyHolderQuestionFlowType']?: Omit<ResolverInputTypes["PolicyHolderQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on AdjustmentQuestionFlowType']?: Omit<ResolverInputTypes["AdjustmentQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on CancellationQuestionFlowType']?: Omit<ResolverInputTypes["CancellationQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on QuoteSummaryQuestionFlowType']?: Omit<ResolverInputTypes["QuoteSummaryQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on KnockoutQuestionFlowType']?: Omit<ResolverInputTypes["KnockoutQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on ClaimQuestionFlowType']?: Omit<ResolverInputTypes["ClaimQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on UpdateQuestionFlowType']?: Omit<ResolverInputTypes["UpdateQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on LegalQuestionFlowType']?: Omit<ResolverInputTypes["LegalQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on PolicyDetailsQuestionFlowType']?: Omit<ResolverInputTypes["PolicyDetailsQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		['...on ClaimProductQuestionFlowType']?: Omit<ResolverInputTypes["ClaimProductQuestionFlowType"],keyof ResolverInputTypes["QuestionFlowType"]>;
		__typename?: boolean | `@${string}`
}>;
	["MessageType"]: AliasType<{
	id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	content?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["MessageKind"]:MessageKind;
	["CoverQuestionSetType"]: AliasType<{
	id?:boolean | `@${string}`,
	cover?:ResolverInputTypes["CoverType"],
	questionSet?:ResolverInputTypes["QuestionSetType"],
		__typename?: boolean | `@${string}`
}>;
	["ExposureQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	exposure?:ResolverInputTypes["ExposureType"],
	exposureItemKey?:boolean | `@${string}`,
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["CoverLimitationType"]: AliasType<{
	id?:boolean | `@${string}`,
	cover?:ResolverInputTypes["CoverType"],
	key?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	overrides?:ResolverInputTypes["CoverLimitationType"],
	/** Default limitations are enabled by default, while extra limitations are enabled by the underwriter during the adjust referral quote process. */
	level?:boolean | `@${string}`,
	overriddenBy?:ResolverInputTypes["CoverLimitationType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["CoverLimitationKind"]:CoverLimitationKind;
	/** An enumeration. */
["CoverLimitationLevel"]:CoverLimitationLevel;
	["CoverQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	cover?:ResolverInputTypes["CoverType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["CoverSummaryQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	cover?:ResolverInputTypes["CoverType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["ClaimCoverQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	claimProfile?:ResolverInputTypes["ClaimProfileType"],
	cover?:ResolverInputTypes["CoverType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["ClaimProfileType"]: AliasType<{
	id?:boolean | `@${string}`,
	owner?:ResolverInputTypes["UserType"],
	claim?:ResolverInputTypes["ClaimType"],
	policyPeriods?:ResolverInputTypes["PolicyPeriodType"],
	products?:ResolverInputTypes["ProductType"],
	covers?:ResolverInputTypes["CoverType"],
claimStateQuestionSets?: [{	filterBy?: ResolverInputTypes["ClaimStateFilterEnum"] | undefined | null},ResolverInputTypes["QuestionSetType"]],
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ClaimType"]: AliasType<{
	id?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	policyPeriods?:ResolverInputTypes["PolicyPeriodType"],
	claimNumber?:boolean | `@${string}`,
	claimProfile?:ResolverInputTypes["ClaimProfileType"],
	status?:boolean | `@${string}`,
	policyNumber?:boolean | `@${string}`,
	statusType?:boolean | `@${string}`,
	statusTypeDisplay?:boolean | `@${string}`,
	decision?:boolean | `@${string}`,
	closedDate?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PolicyPeriodType"]: AliasType<{
	id?:boolean | `@${string}`,
	policy?:ResolverInputTypes["PolicyType"],
	quote?:ResolverInputTypes["QuoteType"],
	boundTimestamp?:boolean | `@${string}`,
	startDate?:boolean | `@${string}`,
	finishDate?:boolean | `@${string}`,
	periodNumber?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	/** Policy Period in effect at the moment of creating this renewal quote. */
	renewalQuotes?:ResolverInputTypes["PolicyRenewalQuoteType"],
	claims?:ResolverInputTypes["ClaimType"],
	transactions?:ResolverInputTypes["TransactionType"],
	policyNumber?:boolean | `@${string}`,
	documents?:ResolverInputTypes["GeneratedDocumentType"],
	latestTransaction?:ResolverInputTypes["TransactionType"],
		__typename?: boolean | `@${string}`
}>;
	["PolicyType"]: AliasType<{
	id?:boolean | `@${string}`,
	policyNumber?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	autoRenewEnabled?:boolean | `@${string}`,
	currentPeriod?:ResolverInputTypes["PolicyPeriodType"],
	status?:boolean | `@${string}`,
	periods?:ResolverInputTypes["PolicyPeriodType"],
	updateQuotes?:ResolverInputTypes["PolicyUpdateQuoteType"],
	cancellationQuotes?:ResolverInputTypes["PolicyCancellationQuoteType"],
	renewalQuotes?:ResolverInputTypes["PolicyRenewalQuoteType"],
	transactions?:ResolverInputTypes["TransactionType"],
	documents?:ResolverInputTypes["GeneratedDocumentType"],
	statusDisplay?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	startDate?:boolean | `@${string}`,
	finishDate?:boolean | `@${string}`,
	quote?:ResolverInputTypes["QuoteType"],
	policyUpdate?:ResolverInputTypes["PolicyUpdateQuoteType"],
	latestUpdate?:ResolverInputTypes["PolicyUpdateQuoteType"],
	draftUpdate?:ResolverInputTypes["QuoteType"],
	policyCancellationQuote?:ResolverInputTypes["PolicyCancellationQuoteType"],
	updateAllowed?:boolean | `@${string}`,
	cancellationAllowed?:boolean | `@${string}`,
	claimsAllowed?:boolean | `@${string}`,
	latestRenewal?:ResolverInputTypes["PolicyRenewalQuoteType"],
	latestCancellation?:ResolverInputTypes["PolicyCancellationQuoteType"],
	isWithinRenewalPeriod?:boolean | `@${string}`,
	isPendingCancellation?:boolean | `@${string}`,
	policyPeriods?:ResolverInputTypes["PolicyPeriodType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["PolicyStatus"]:PolicyStatus;
	["PolicyUpdateQuoteType"]: AliasType<{
	id?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	modified?:boolean | `@${string}`,
	policy?:ResolverInputTypes["PolicyType"],
	quote?:ResolverInputTypes["QuoteType"],
	/** Pro-rata amount balance to charge or refund. */
	proRataAmountDue?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PolicyCancellationQuoteType"]: AliasType<{
	id?:boolean | `@${string}`,
	policy?:ResolverInputTypes["PolicyType"],
	state?:boolean | `@${string}`,
	effectiveDate?:boolean | `@${string}`,
	amountDue?:boolean | `@${string}`,
	fees?:ResolverInputTypes["FeeSummaryType"],
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["PolicyCancellationQuoteState"]:PolicyCancellationQuoteState;
	/** The `Date` scalar type represents a Date
value as specified by
[iso8601](https://en.wikipedia.org/wiki/ISO_8601). */
["Date"]:unknown;
	["FeeSummaryType"]: AliasType<{
	breakdown?:ResolverInputTypes["FeeType"],
	taxes?:boolean | `@${string}`,
	fees?:boolean | `@${string}`,
	stampDuty?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FeeType"]: AliasType<{
	kind?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
	feeType?:ResolverInputTypes["FeeTypeType"],
		__typename?: boolean | `@${string}`
}>;
	["FeeTypeType"]: AliasType<{
	key?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["FeeTypeKind"]:FeeTypeKind;
	["PolicyRenewalQuoteType"]: AliasType<{
	id?:boolean | `@${string}`,
	policy?:ResolverInputTypes["PolicyType"],
	/** Policy Period in effect at the moment of creating this renewal quote. */
	policyPeriod?:ResolverInputTypes["PolicyPeriodType"],
	quote?:ResolverInputTypes["QuoteType"],
	submittedTimestamp?:boolean | `@${string}`,
	canDiscard?:boolean | `@${string}`,
	canAccept?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TransactionType"]: AliasType<{
	id?:boolean | `@${string}`,
	policyPeriod?:ResolverInputTypes["PolicyPeriodType"],
	status?:boolean | `@${string}`,
	paymentProfile?:ResolverInputTypes["PaymentProfileType"],
	/** Unique identifier for this transaction within the payment gateway. */
	paymentGatewayTransactionReference?:boolean | `@${string}`,
	actionType?:boolean | `@${string}`,
	transactionType?:boolean | `@${string}`,
	amount?:boolean | `@${string}`,
	currency?:boolean | `@${string}`,
	policyNumber?:boolean | `@${string}`,
	statusDisplay?:boolean | `@${string}`,
	transactionTypeDisplay?:boolean | `@${string}`,
	actionTypeDisplay?:boolean | `@${string}`,
	amountWithSurcharge?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["TransactionStatus"]:TransactionStatus;
	["PaymentProfileType"]: AliasType<{
	id?:boolean | `@${string}`,
	/** To help the customer identify this payment profile (i.e. last 4 digits of a cc). */
	customerReference?:boolean | `@${string}`,
	paymentGateway?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["PaymentProfilePaymentGateway"]:PaymentProfilePaymentGateway;
	/** An enumeration. */
["TransactionActionType"]:TransactionActionType;
	/** An enumeration. */
["TransactionTransactionType"]:TransactionTransactionType;
	/** An enumeration. */
["TransactionCurrency"]:TransactionCurrency;
	["GeneratedDocumentType"]: AliasType<{
	id?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	modified?:boolean | `@${string}`,
	objectId?:boolean | `@${string}`,
	user?:ResolverInputTypes["UserType"],
	file?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["PolicyPeriodKind"]:PolicyPeriodKind;
	/** An enumeration. */
["ClaimStatusChoices"]:ClaimStatusChoices;
	/** An enumeration. */
["ClaimStatusTypes"]:ClaimStatusTypes;
	/** An enumeration. */
["ClaimStateFilterEnum"]:ClaimStateFilterEnum;
	/** An enumeration. */
["PaymentGateway"]:PaymentGateway;
	/** The `GenericScalar` scalar type represents a generic
GraphQL scalar value that could be:
String, Boolean, Int, Float, List or Object. */
["GenericScalar"]:unknown;
	/** An enumeration. */
["RiskStateFilterEnum"]:RiskStateFilterEnum;
	/** An enumeration. */
["QuoteState"]:QuoteState;
	/** An enumeration. */
["QuoteReferralState"]:QuoteReferralState;
	["InstallmentType"]: AliasType<{
	id?:boolean | `@${string}`,
	quote?:ResolverInputTypes["QuoteType"],
	dueDate?:boolean | `@${string}`,
	inclusivePrice?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	fees?:ResolverInputTypes["FeeType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["InstallmentKind"]:InstallmentKind;
	["PoliciesType"]: AliasType<{
	totalItemCount?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	pageSize?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	hasNext?:boolean | `@${string}`,
	hasPrev?:boolean | `@${string}`,
	items?:ResolverInputTypes["PolicyType"],
		__typename?: boolean | `@${string}`
}>;
	["QuotesType"]: AliasType<{
	totalItemCount?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	pageSize?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	hasNext?:boolean | `@${string}`,
	hasPrev?:boolean | `@${string}`,
	items?:ResolverInputTypes["QuoteType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["QuoteFilterBy"]:QuoteFilterBy;
	["QuoteDetailType"]: AliasType<{
	details?:ResolverInputTypes["QuoteType"],
	notes?:ResolverInputTypes["NoteType"],
		__typename?: boolean | `@${string}`
}>;
	["NoteType"]: AliasType<{
	id?:boolean | `@${string}`,
	created?:boolean | `@${string}`,
	content?:boolean | `@${string}`,
	author?:ResolverInputTypes["UserType"],
		__typename?: boolean | `@${string}`
}>;
	["ClaimsType"]: AliasType<{
	totalItemCount?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	pageSize?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	hasNext?:boolean | `@${string}`,
	hasPrev?:boolean | `@${string}`,
	items?:ResolverInputTypes["ClaimType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["ClaimFilterBy"]:ClaimFilterBy;
	["ClaimDetailType"]: AliasType<{
	details?:ResolverInputTypes["ClaimType"],
	notes?:ResolverInputTypes["NoteType"],
		__typename?: boolean | `@${string}`
}>;
	["ReportsType"]: AliasType<{
	totalItemCount?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	pageSize?:boolean | `@${string}`,
	pageCount?:boolean | `@${string}`,
	hasNext?:boolean | `@${string}`,
	hasPrev?:boolean | `@${string}`,
	items?:ResolverInputTypes["ReportType"],
	reportTypes?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReportType"]: AliasType<{
	id?:boolean | `@${string}`,
	file?:boolean | `@${string}`,
	/** Start date/time of report data date range. */
	startDatetime?:boolean | `@${string}`,
	/** End date/time of report data date range. */
	endDatetime?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	generatedDate?:boolean | `@${string}`,
	reportType?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	taskStatus?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DataAnalyticsType"]: AliasType<{
	totalQuotes?:ResolverInputTypes["DataAnalyticsCardType"],
	quotesThisMonth?:ResolverInputTypes["DataAnalyticsCardType"],
	policiesByStatus?:ResolverInputTypes["DataAnalyticsCardType"],
	policiesRenewed?:ResolverInputTypes["DataAnalyticsCardType"],
	totalActivePolicies?:ResolverInputTypes["DataAnalyticsCardType"],
	totalCustomers?:ResolverInputTypes["DataAnalyticsCardType"],
	totalClaims?:ResolverInputTypes["DataAnalyticsCardType"],
	conversionRate?:ResolverInputTypes["DataAnalyticsCardType"],
	totalGwp?:ResolverInputTypes["DataAnalyticsCardType"],
		__typename?: boolean | `@${string}`
}>;
	["DataAnalyticsCardType"]: AliasType<{
	title?:boolean | `@${string}`,
	summaryValue?:boolean | `@${string}`,
	summaryValueType?:boolean | `@${string}`,
	statistics?:ResolverInputTypes["DataAnalyticsStatisticType"],
		__typename?: boolean | `@${string}`
}>;
	["DataAnalyticsStatisticType"]: AliasType<{
	label?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SsoConfigurationType"]: AliasType<{
	/** Unique identifier for this configuration within the IDP platform. This is required to authenticate authenticator as a client. */
	clientIdKey?:boolean | `@${string}`,
	/** Login URL for this configuration. For the login button link use the Login initialize URL. */
	loginUrl?:boolean | `@${string}`,
	/** Logout URL for this configuration. */
	logoutUrl?:boolean | `@${string}`,
	/** Call back URL for this configuration. */
	callbackUrl?:boolean | `@${string}`,
	/** Success redirect URL for this configuration. */
	successRedirectUrl?:boolean | `@${string}`,
	/** Error redirect URL for this configuration. */
	errorRedirectUrl?:boolean | `@${string}`,
	isClientSecretKeySet?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DownloadDocumentType"]: AliasType<{
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DownloadFileType"]: AliasType<{
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AnzsicCodeDivisionType"]: AliasType<{
	id?:boolean | `@${string}`,
	year?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	subdivisions?:ResolverInputTypes["AnzsicCodeSubdivisionType"],
		__typename?: boolean | `@${string}`
}>;
	["AnzsicCodeSubdivisionType"]: AliasType<{
	id?:boolean | `@${string}`,
	division?:ResolverInputTypes["AnzsicCodeDivisionType"],
	year?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	groups?:ResolverInputTypes["AnzsicCodeGroupType"],
		__typename?: boolean | `@${string}`
}>;
	["AnzsicCodeGroupType"]: AliasType<{
	id?:boolean | `@${string}`,
	subdivision?:ResolverInputTypes["AnzsicCodeSubdivisionType"],
	year?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	classes?:ResolverInputTypes["AnzsicCodeClassType"],
		__typename?: boolean | `@${string}`
}>;
	["AnzsicCodeClassType"]: AliasType<{
	id?:boolean | `@${string}`,
	group?:ResolverInputTypes["AnzsicCodeGroupType"],
	year?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ClaimStateType"]: AliasType<{
	claimProfile?:ResolverInputTypes["ClaimProfileType"],
	questionSets?:ResolverInputTypes["QuestionSetType"],
		__typename?: boolean | `@${string}`
}>;
	["RiskStateType"]: AliasType<{
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	questionSets?:ResolverInputTypes["QuestionSetType"],
		__typename?: boolean | `@${string}`
}>;
	["ThemeType"]: AliasType<{
	logo?:ResolverInputTypes["LogoType"],
	themeOverride?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LogoType"]: AliasType<{
	src?:boolean | `@${string}`,
	altText?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CybersourceContextType"]: AliasType<{
	context?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateAddressBzType"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SearchAddressBzType"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PaymentMethodType"]: AliasType<{
	cardNumber?:boolean | `@${string}`,
	cardType?:boolean | `@${string}`,
	expiryDate?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mutation"]: AliasType<{
	admin?:ResolverInputTypes["AdminMutation"],
hijackUser?: [{	input: ResolverInputTypes["HijackUserInput"]},ResolverInputTypes["TokenType"]],
	/** Release user endpoint.

This endpoint triggers the django-release function. */
	releaseUser?:ResolverInputTypes["TokenType"],
ssoVerification?: [{	authenticatorType: string,	credential?: string | undefined | null},ResolverInputTypes["TokenType"]],
ssoAuthenticate?: [{	authenticatorType: string},ResolverInputTypes["SsoRedirectType"]],
completePayment?: [{	input?: ResolverInputTypes["CompletePaymentInput"] | undefined | null},ResolverInputTypes["CompletePaymentMutation"]],
confirmQuote?: [{	riskProfileId: string},ResolverInputTypes["ConfirmQuoteMutation"]],
updatePaymentMethod?: [{	input?: ResolverInputTypes["UpdatePaymentMethodInput"] | undefined | null},ResolverInputTypes["UpdatePaymentMethodMutation"]],
refreshUser?: [{	input?: ResolverInputTypes["RefreshUserInput"] | undefined | null},ResolverInputTypes["TokenType"]],
tokenAuth?: [{	email: string,	password: string},ResolverInputTypes["ObtainJSONWebToken"]],
	/** Logout a user. */
	logoutUser?:ResolverInputTypes["LogoutUserMutation"],
sendPasswordResetEmail?: [{	email: string},ResolverInputTypes["SendPasswordResetEmailMutation"]],
passwordReset?: [{	token: string,	newPassword1: string,	newPassword2: string},ResolverInputTypes["PasswordReset"]],
updateAccount?: [{	contactEmail?: string | undefined | null},ResolverInputTypes["UpdateAccount"]],
registerUser?: [{	email: string,	password1: string,	password2: string},ResolverInputTypes["RegisterUserMutation"]],
registerPasswordLessUser?: [{	email: string},ResolverInputTypes["RegisterPasswordLessUserMutation"]],
updateSsoConfiguration?: [{	input?: ResolverInputTypes["SsoConfigurationInput"] | undefined | null},ResolverInputTypes["SsoConfigurationOutputType"]],
dataImport?: [{	input: ResolverInputTypes["DataImportInput"]},ResolverInputTypes["DataImportMutation"]],
sortedImport?: [{	input?: ResolverInputTypes["SortedImportInput"] | undefined | null},ResolverInputTypes["SortedImportMutation"]],
startQuote?: [{	input?: ResolverInputTypes["StartQuoteInput"] | undefined | null},ResolverInputTypes["QuoteQuestionFlowType"]],
startCancellation?: [{	input?: ResolverInputTypes["StartPolicyCancellationInput"] | undefined | null},ResolverInputTypes["CancellationQuestionFlowType"]],
startCover?: [{	input?: ResolverInputTypes["StartCoverInput"] | undefined | null},ResolverInputTypes["CoverQuestionFlowType"]],
startCoverSummary?: [{	input?: ResolverInputTypes["StartCoverSummaryInput"] | undefined | null},ResolverInputTypes["CoverSummaryQuestionFlowType"]],
startExposure?: [{	input?: ResolverInputTypes["StartExposureInput"] | undefined | null},ResolverInputTypes["ExposureQuestionFlowType"]],
startQuoteSummary?: [{	input?: ResolverInputTypes["StartQuoteSummaryInput"] | undefined | null},ResolverInputTypes["QuoteSummaryQuestionFlowType"]],
startPolicyholder?: [{	input?: ResolverInputTypes["StartPolicyHolderInput"] | undefined | null},ResolverInputTypes["PolicyHolderQuestionFlowType"]],
startKnockouts?: [{	input?: ResolverInputTypes["StartKnockoutsInput"] | undefined | null},ResolverInputTypes["KnockoutQuestionFlowType"]],
startClaim?: [{	input?: ResolverInputTypes["StartClaimInput"] | undefined | null},ResolverInputTypes["ClaimQuestionFlowType"]],
submitClaim?: [{	input: ResolverInputTypes["SubmitClaimInput"]},ResolverInputTypes["ClaimType"]],
answerEnquiry?: [{	input: ResolverInputTypes["AnswerEnquiryInput"]},ResolverInputTypes["QuestionFlowType"]],
priceRiskProfile?: [{	input: ResolverInputTypes["RiskProfileInput"]},ResolverInputTypes["RiskProfileType"]],
updateRiskCover?: [{	input: ResolverInputTypes["UpdateRiskCoverInput"]},ResolverInputTypes["RiskProfileType"]],
updateRiskExposure?: [{	input: ResolverInputTypes["UpdateRiskExposureInput"]},ResolverInputTypes["RiskProfileType"]],
updatePolicy?: [{	input: ResolverInputTypes["UpdatePolicyInput"]},ResolverInputTypes["PolicyType"]],
bindQuotes?: [{	input: ResolverInputTypes["BindQuotesInput"]},ResolverInputTypes["PolicyPeriodType"]],
generateDocuments?: [{	policyId?: string | undefined | null,	quoteId?: string | undefined | null},ResolverInputTypes["GenerateDocuments"]],
generateDocument?: [{	force?: boolean | undefined | null,	policyId?: string | undefined | null,	quoteId?: string | undefined | null,	type?: string | undefined | null},ResolverInputTypes["GenerateDocument"]],
startPolicyUpdate?: [{	input?: ResolverInputTypes["StartPolicyUpdateInput"] | undefined | null},ResolverInputTypes["UpdateQuestionFlowType"]],
confirmPolicyUpdate?: [{	input: ResolverInputTypes["ConfirmPolicyUpdateInput"]},ResolverInputTypes["PolicyType"]],
policyUpdateSummary?: [{	input: ResolverInputTypes["PolicyUpdateSummaryInput"]},ResolverInputTypes["PolicyUpdateSummaryChangesType"]],
policyCancellationSummary?: [{	input: ResolverInputTypes["PolicyCancellationSummaryInput"]},ResolverInputTypes["PolicyCancellationQuoteType"]],
confirmPolicyCancellation?: [{	input: ResolverInputTypes["ConfirmPolicyCancellationInput"]},ResolverInputTypes["PolicyType"]],
policyRenewalSummary?: [{	input: ResolverInputTypes["PolicyRenewalSummaryInput"]},ResolverInputTypes["PolicyRenewalSummaryChangesType"]],
toggleEnabledProducts?: [{	input: ResolverInputTypes["ToggleEnabledProductsInput"]},ResolverInputTypes["RiskProfileType"]],
discardRenewalQuote?: [{	input: ResolverInputTypes["RenewalQuoteInput"]},ResolverInputTypes["PolicyRenewalQuoteType"]],
createRenewalQuote?: [{	input: ResolverInputTypes["CreateRenewalQuoteInput"]},ResolverInputTypes["PolicyRenewalQuoteType"]],
acceptRenewalQuote?: [{	input: ResolverInputTypes["RenewalQuoteInput"]},ResolverInputTypes["PolicyRenewalQuoteType"]],
		__typename?: boolean | `@${string}`
}>;
	["AdminMutation"]: AliasType<{
closeClaim?: [{	claimId: string,	decision: ResolverInputTypes["ClosedStatus"]},ResolverInputTypes["CloseClaimMutation"]],
createLazyUser?: [{	input: ResolverInputTypes["CreateLazyUserInput"]},ResolverInputTypes["UserType"]],
createNote?: [{	assocObjId: string,	assocObjModel: ResolverInputTypes["NoteAssociationLimit"],	content: string},ResolverInputTypes["NoteType"]],
editReferredQuote?: [{	input?: ResolverInputTypes["EditQuoteInput"] | undefined | null},ResolverInputTypes["QuoteQuestionFlowType"]],
editPolicyholder?: [{	input?: ResolverInputTypes["EditPolicyholderInput"] | undefined | null},ResolverInputTypes["PolicyHolderQuestionFlowType"]],
emailQuote?: [{	input: ResolverInputTypes["SendQuoteEmailInput"]},ResolverInputTypes["SendQuoteEmailMutation"]],
generateReport?: [{	input?: ResolverInputTypes["GenerateReportInput"] | undefined | null},ResolverInputTypes["ReportType"]],
priceReferredRiskProfile?: [{	checkReferred?: boolean | undefined | null,	riskProfileId: string},ResolverInputTypes["RiskProfileType"]],
startAdjustment?: [{	input?: ResolverInputTypes["StartAdjustmentInput"] | undefined | null},ResolverInputTypes["AdjustmentQuestionFlowType"]],
updateQuoteReferralState?: [{	note?: string | undefined | null,	quoteId: string,	referralState: ResolverInputTypes["ReferralState"]},ResolverInputTypes["UpdateQuoteReferralStateMutation"]],
discardRenewalQuote?: [{	input?: ResolverInputTypes["RenewalQuoteInput"] | undefined | null},ResolverInputTypes["AdminDiscardRenewalQuoteMutation"]],
		__typename?: boolean | `@${string}`
}>;
	["CloseClaimMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	claim?:ResolverInputTypes["ClaimType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["ClosedStatus"]:ClosedStatus;
	["CreateLazyUserInput"]: {
	email: string,
	firstName: string,
	lastName: string
};
	/**
    Enumeration to define valid associations for a note.

    Enum Members:
    - POLICY: Association with a policy object in the 'insurance' app.
    - QUOTE: Association with a quote object in the 'insurance' app.
    - CLAIM: Association with a claim object in the 'insurance' app.
     */
["NoteAssociationLimit"]:NoteAssociationLimit;
	["QuoteQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["EditQuoteInput"]: {
	quoteId: string
};
	["PolicyHolderQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["EditPolicyholderInput"]: {
	riskProfileId: string
};
	/** Send quote email endpoint.

This endpoint will email a quote link to user */
["SendQuoteEmailMutation"]: AliasType<{
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SendQuoteEmailInput"]: {
	quoteId: string,
	toEmail: string
};
	["GenerateReportInput"]: {
	reportType: string,
	startDate: string,
	endDate: string
};
	["AdjustmentQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["StartAdjustmentInput"]: {
	riskProfileId: string,
	questionSetKey?: string | undefined | null,
	restart?: boolean | undefined | null
};
	/** Update a referred quote's referral state. */
["UpdateQuoteReferralStateMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	quote?:ResolverInputTypes["QuoteType"],
	note?:ResolverInputTypes["NoteType"],
		__typename?: boolean | `@${string}`
}>;
	/** An enumeration. */
["ReferralState"]:ReferralState;
	["AdminDiscardRenewalQuoteMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	renewalQuote?:ResolverInputTypes["PolicyRenewalQuoteType"],
		__typename?: boolean | `@${string}`
}>;
	["RenewalQuoteInput"]: {
	renewalQuoteId: string
};
	["TokenType"]: AliasType<{
	token?:boolean | `@${string}`,
	user?:ResolverInputTypes["UserType"],
		__typename?: boolean | `@${string}`
}>;
	["HijackUserInput"]: {
	userId: string
};
	["SsoRedirectType"]: AliasType<{
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompletePaymentMutation"]: AliasType<{
	paymentSuccess?:boolean | `@${string}`,
	bindSuccess?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompletePaymentInput"]: {
	riskProfileId: string,
	metadata: ResolverInputTypes["GenericScalar"]
};
	["ConfirmQuoteMutation"]: AliasType<{
	paymentSuccess?:boolean | `@${string}`,
	bindSuccess?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdatePaymentMethodMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdatePaymentMethodInput"]: {
	metadata: ResolverInputTypes["GenericScalar"]
};
	["RefreshUserInput"]: {
	distributionPartner?: string | undefined | null
};
	/** Authenticate a given email/password combination. */
["ObtainJSONWebToken"]: AliasType<{
	token?:boolean | `@${string}`,
	user?:ResolverInputTypes["UserType"],
		__typename?: boolean | `@${string}`
}>;
	/** Logout a user. */
["LogoutUserMutation"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Resets the password of a user and sends them an email.

If the user has an unusable password, this will do nothing; no error will be raised
and and no email will be sent. */
["SendPasswordResetEmailMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/**
    Errors messages and codes mapped to
    fields or non fields errors.
    Example:
    {
        field_name: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ],
        other_field: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ],
        nonFieldErrors: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ]
    }
     */
["ExpectedErrorType"]:unknown;
	/** Change user password without old password.

Receive the token that was sent by email.

If token and new passwords are valid, update
user password and in case of using refresh
tokens, revoke all of them.

Also, if user has not been verified yet, verify it. */
["PasswordReset"]: AliasType<{
	success?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdateAccount"]: AliasType<{
	success?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Convert an existing LazyUser/PasswordLessUser into a User. */
["RegisterUserMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
	user?:ResolverInputTypes["UserType"],
	token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Convert an existing LazyUser into a PasswordLessUser. */
["RegisterPasswordLessUserMutation"]: AliasType<{
	success?:boolean | `@${string}`,
	errors?:boolean | `@${string}`,
	user?:ResolverInputTypes["UserType"],
	token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SsoConfigurationOutputType"]: AliasType<{
	clientIdKey?:boolean | `@${string}`,
	loginUrl?:boolean | `@${string}`,
	logoutUrl?:boolean | `@${string}`,
	callbackUrl?:boolean | `@${string}`,
	successRedirectUrl?:boolean | `@${string}`,
	errorRedirectUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SsoConfigurationInput"]: {
	clientIdKey?: string | undefined | null,
	clientSecretKey?: string | undefined | null,
	loginUrl?: string | undefined | null,
	logoutUrl?: string | undefined | null,
	callbackUrl?: string | undefined | null,
	successRedirectUrl?: string | undefined | null,
	errorRedirectUrl?: string | undefined | null
};
	/** Perform a Data Import for a new or existing user.

A risk profile is created and a one-time login link is returned. */
["DataImportMutation"]: AliasType<{
	oneTimeLoginUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DataImportInput"]: {
	distributionPartner: string,
	enabledProducts: Array<string | undefined | null>,
	userReference?: string | undefined | null,
	email?: string | undefined | null,
	riskData?: ResolverInputTypes["GenericScalar"] | undefined | null
};
	["SortedImportMutation"]: AliasType<{
	loginUrl?:boolean | `@${string}`,
	user?:ResolverInputTypes["SortedUserType"],
		__typename?: boolean | `@${string}`
}>;
	["SortedUserType"]: AliasType<{
	id?:boolean | `@${string}`,
	sortedId?:boolean | `@${string}`,
	customerNumber?:boolean | `@${string}`,
	user?:ResolverInputTypes["UserType"],
	email?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	workPhone?:boolean | `@${string}`,
	homePhone?:boolean | `@${string}`,
	mobile?:boolean | `@${string}`,
	dateOfBirth?:boolean | `@${string}`,
	propertyRoles?:ResolverInputTypes["SortedUserPropertyRoleType"],
		__typename?: boolean | `@${string}`
}>;
	["SortedUserPropertyRoleType"]: AliasType<{
	id?:boolean | `@${string}`,
	sortedUser?:ResolverInputTypes["SortedUserType"],
	serviceNumber?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
		__typename?: boolean | `@${string}`
}>;
	["SortedImportInput"]: {
	customerNumber: string,
	serviceNumber: string,
	email: string
};
	["StartQuoteInput"]: {
	create?: boolean | undefined | null,
	questionSetKey?: string | undefined | null,
	enabledProducts?: Array<string | undefined | null> | undefined | null,
	restart?: boolean | undefined | null,
	autoQuote?: boolean | undefined | null,
	fileLink?: string | undefined | null
};
	["CancellationQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["StartPolicyCancellationInput"]: {
	policyId: string,
	questionSetKey?: string | undefined | null,
	restart?: boolean | undefined | null
};
	["StartCoverInput"]: {
	riskProfileId: string,
	coverId: string,
	questionSetKey?: string | undefined | null,
	restart?: boolean | undefined | null
};
	["StartCoverSummaryInput"]: {
	riskProfileId: string,
	coverId: string,
	questionSetKey?: string | undefined | null,
	restart?: boolean | undefined | null
};
	["StartExposureInput"]: {
	riskProfileId: string,
	exposureId: string,
	exposureItemKey?: string | undefined | null,
	questionSetKey?: string | undefined | null,
	restart?: boolean | undefined | null
};
	["QuoteSummaryQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["StartQuoteSummaryInput"]: {
	riskProfileId: string,
	questionSetKey?: string | undefined | null,
	restart?: boolean | undefined | null
};
	["StartPolicyHolderInput"]: {
	riskProfileId: string,
	questionSetKey?: string | undefined | null,
	restart?: boolean | undefined | null
};
	["KnockoutQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["StartKnockoutsInput"]: {
	riskProfileId: string,
	questionSetKey?: string | undefined | null,
	restart?: boolean | undefined | null
};
	["ClaimQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	claimProfile?:ResolverInputTypes["ClaimProfileType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["StartClaimInput"]: {
	policyId: string,
	questionSetKey?: string | undefined | null,
	restart?: boolean | undefined | null
};
	["SubmitClaimInput"]: {
	claimProfileId: string
};
	["AnswerEnquiryInput"]: {
	questionFlowId: string,
	answers?: ResolverInputTypes["JSONString"] | undefined | null,
	skipNext?: boolean | undefined | null
};
	["RiskProfileInput"]: {
	riskProfileId: string,
	enabledProducts?: Array<string | undefined | null> | undefined | null
};
	["UpdateRiskCoverInput"]: {
	riskProfileId: string,
	coverId: string,
	enabled?: boolean | undefined | null,
	answers?: ResolverInputTypes["JSONString"] | undefined | null
};
	["UpdateRiskExposureInput"]: {
	riskProfileId: string,
	exposureId: string,
	exposureItemKey: string,
	enabled?: boolean | undefined | null,
	answers?: ResolverInputTypes["JSONString"] | undefined | null
};
	["UpdatePolicyInput"]: {
	policyId: string,
	autoRenewEnabled?: boolean | undefined | null
};
	["BindQuotesInput"]: {
	riskProfileId: string
};
	/** Generates multiple documents.

If 'quote_id' or 'policy_id' is provided, this will generate all documents
associated with the 'quote' or 'bind' events depending on which was provided. */
["GenerateDocuments"]: AliasType<{
	documents?:ResolverInputTypes["GeneratedDocumentType"],
		__typename?: boolean | `@${string}`
}>;
	/** Generates a single document for the given 'type'.

'quote_id' or 'policy_id' is required to link the generated document to and find
the relevant product. */
["GenerateDocument"]: AliasType<{
	document?:ResolverInputTypes["GeneratedDocumentType"],
		__typename?: boolean | `@${string}`
}>;
	["UpdateQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
	riskProfile?:ResolverInputTypes["RiskProfileType"],
		__typename?: boolean | `@${string}`
}>;
	["StartPolicyUpdateInput"]: {
	policyId: string,
	flow?: string | undefined | null,
	questionSetKey?: string | undefined | null,
	create?: boolean | undefined | null,
	restart?: boolean | undefined | null,
	coverId?: string | undefined | null,
	autoQuote?: boolean | undefined | null
};
	["ConfirmPolicyUpdateInput"]: {
	policyId: string,
	startDate: ResolverInputTypes["Date"],
	autoRenewEnabled?: boolean | undefined | null
};
	["PolicyUpdateSummaryChangesType"]: AliasType<{
	proRataAmount?:boolean | `@${string}`,
	oldPeriodicPrice?:boolean | `@${string}`,
	newPeriodicPrice?:boolean | `@${string}`,
	surcharge?:boolean | `@${string}`,
	amountDue?:boolean | `@${string}`,
	oldPaymentFrequency?:boolean | `@${string}`,
	newPaymentFrequency?:boolean | `@${string}`,
	newStartDate?:boolean | `@${string}`,
	newFinishDate?:boolean | `@${string}`,
	summary?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PolicyUpdateSummaryInput"]: {
	policyId: string
};
	["PolicyCancellationSummaryInput"]: {
	policyId: string
};
	["ConfirmPolicyCancellationInput"]: {
	policyId: string,
	policyCancellationQuoteId: string
};
	["PolicyRenewalSummaryChangesType"]: AliasType<{
	proRataAmount?:boolean | `@${string}`,
	oldPeriodicPrice?:boolean | `@${string}`,
	newPeriodicPrice?:boolean | `@${string}`,
	surcharge?:boolean | `@${string}`,
	amountDue?:boolean | `@${string}`,
	oldPaymentFrequency?:boolean | `@${string}`,
	newPaymentFrequency?:boolean | `@${string}`,
	newStartDate?:boolean | `@${string}`,
	newFinishDate?:boolean | `@${string}`,
	summary?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PolicyRenewalSummaryInput"]: {
	policyId: string
};
	["ToggleEnabledProductsInput"]: {
	riskProfileId: string,
	productKey: string,
	enabled?: boolean | undefined | null,
	answers?: ResolverInputTypes["JSONString"] | undefined | null
};
	["CreateRenewalQuoteInput"]: {
	policyId: string
};
	["LegalQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["PolicyDetailsQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	riskProfile?:ResolverInputTypes["RiskProfileType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["ClaimProductQuestionFlowType"]: AliasType<{
	id?:boolean | `@${string}`,
	started?:boolean | `@${string}`,
	finished?:boolean | `@${string}`,
	currentEnquiry?:ResolverInputTypes["EnquiryType"],
	maxSets?:boolean | `@${string}`,
	currentSet?:boolean | `@${string}`,
	claimProfile?:ResolverInputTypes["ClaimProfileType"],
	history?:ResolverInputTypes["EnquiryType"],
	messages?:ResolverInputTypes["MessageType"],
		__typename?: boolean | `@${string}`
}>;
	["schema"]: AliasType<{
	query?:ResolverInputTypes["Query"],
	mutation?:ResolverInputTypes["Mutation"],
		__typename?: boolean | `@${string}`
}>
  }

export type ModelTypes = {
    ["Query"]: {
		/** Stripe configuration */
	stripeConfig?: ModelTypes["StripeConfigType"] | undefined,
	/** Payment breakdown into premium, surcharge and total */
	paymentBreakdown?: ModelTypes["PaymentBreakdownType"] | undefined,
	admin?: ModelTypes["AdminType"] | undefined,
	/** Return details for an Organization. */
	organization?: ModelTypes["OrganizationType"] | undefined,
	/** Return details for an SSO Configuration. */
	ssoConfiguration?: ModelTypes["SsoConfigurationType"] | undefined,
	/** List all generated documents of a given document type. */
	documents?: Array<ModelTypes["GeneratedDocumentType"] | undefined> | undefined,
	/** Download a given generated document. */
	download?: ModelTypes["DownloadDocumentType"] | undefined,
	/** Download an uploaded file. */
	downloadFile?: ModelTypes["DownloadFileType"] | undefined,
	allAnzsicCodeDivisions?: Array<ModelTypes["AnzsicCodeDivisionType"] | undefined> | undefined,
	allQuestionSets?: Array<ModelTypes["QuestionSetType"] | undefined> | undefined,
	allQuestions?: Array<ModelTypes["QuestionType"] | undefined> | undefined,
	/** Return all details for a given Claim. */
	claim?: ModelTypes["ClaimType"] | undefined,
	/** Return all details for a given Claim Profile. */
	claimProfile?: ModelTypes["ClaimProfileType"] | undefined,
	/** Return all or part of a Claim Profile's state. */
	claimState?: ModelTypes["ClaimStateType"] | undefined,
	/** Return all details for a given Risk Profile. */
	riskProfile?: ModelTypes["RiskProfileType"] | undefined,
	/** Return all details for a given Policy. */
	policy?: ModelTypes["PolicyType"] | undefined,
	/** List all policies, optionally filtered by active/inactive status. */
	policies?: Array<ModelTypes["PolicyType"] | undefined> | undefined,
	/** Return the active policy if there is one. */
	activePolicy?: ModelTypes["PolicyType"] | undefined,
	/** Return a list of available covers for a given Risk Profile. */
	availableCovers?: Array<ModelTypes["CoverType"] | undefined> | undefined,
	/** Return all or part of a Risk Profile risk state. */
	riskState?: ModelTypes["RiskStateType"] | undefined,
	/** List cover limitations (inclusions and exclusions) for the given Risk Profile. */
	coverLimitations?: Array<ModelTypes["CoverLimitationType"] | undefined> | undefined,
	/** Return any draft policy update quotes. */
	policyUpdateQuote?: ModelTypes["PolicyUpdateQuoteType"] | undefined,
	policyUpdate?: ModelTypes["PolicyUpdateQuoteType"] | undefined,
	/** Returns a policy cancellation quote (if any) given a Policy ID. */
	policyCancellationQuote?: ModelTypes["PolicyCancellationQuoteType"] | undefined,
	/** Returns a Policy Renewal Quote given a Policy ID */
	policyRenewalQuote?: ModelTypes["PolicyRenewalQuoteType"] | undefined,
	/** Theme definition */
	loadTheme?: ModelTypes["ThemeType"] | undefined,
	/** Generate context for Cybersource card tokenization */
	cybersourceGenerateContext?: ModelTypes["CybersourceContextType"] | undefined,
	/** List all claims, optionally filtered by claim status type (open/closed). */
	claims?: Array<ModelTypes["ClaimType"] | undefined> | undefined,
	/** Validate an address with external services */
	validateAddressBz?: ModelTypes["ValidateAddressBzType"] | undefined,
	/** Search an address with external services */
	searchAddressBz?: ModelTypes["SearchAddressBzType"] | undefined,
	paymentMethod?: ModelTypes["PaymentMethodType"] | undefined,
	claimsAllowed?: boolean | undefined,
	riskProfilePaymentAllowed?: boolean | undefined
};
	["StripeConfigType"]: {
		account?: string | undefined
};
	["PaymentBreakdownType"]: {
		premium: number,
	surcharge?: number | undefined,
	total: number
};
	["AdminType"]: {
		customers?: ModelTypes["CustomersType"] | undefined,
	customer?: ModelTypes["CustomerDetailType"] | undefined,
	policies?: ModelTypes["PoliciesType"] | undefined,
	policy?: ModelTypes["PolicyType"] | undefined,
	quotes?: ModelTypes["QuotesType"] | undefined,
	quote?: ModelTypes["QuoteDetailType"] | undefined,
	claims?: ModelTypes["ClaimsType"] | undefined,
	claim?: ModelTypes["ClaimDetailType"] | undefined,
	products?: Array<ModelTypes["ProductType"] | undefined> | undefined,
	distributionPartners?: Array<ModelTypes["DistributionPartnerType"] | undefined> | undefined,
	reports?: ModelTypes["ReportsType"] | undefined,
	report?: ModelTypes["ReportType"] | undefined,
	claimsAllowed?: boolean | undefined,
	/** Returns all data analytics */
	dataAnalytics?: ModelTypes["DataAnalyticsType"] | undefined
};
	["CustomersType"]: {
		totalItemCount?: number | undefined,
	page?: number | undefined,
	pageSize?: ModelTypes["PageSize"] | undefined,
	pageCount?: number | undefined,
	hasNext?: boolean | undefined,
	hasPrev?: boolean | undefined,
	items?: Array<ModelTypes["UserType"] | undefined> | undefined
};
	/** Set default page sizes for pagination. */
["PageSize"]:any;
	["UserType"]: {
		id: string,
	firstName: string,
	lastName: string,
	isStaff?: boolean | undefined,
	isActive?: boolean | undefined,
	dateJoined: ModelTypes["DateTime"],
	email?: string | undefined,
	uuid: ModelTypes["UUID"],
	/** For lazy users only. Once a user has registered, the `email` address field is the one we care about. */
	contactEmail?: string | undefined,
	contactNumber?: string | undefined,
	organization?: ModelTypes["OrganizationType"] | undefined,
	isSsoEnabled?: boolean | undefined,
	isLazy?: boolean | undefined,
	isPasswordLess?: boolean | undefined,
	allowCustomerPortalAccess?: boolean | undefined,
	isHijacked?: boolean | undefined,
	latestReferrer?: ModelTypes["DistributionPartnerType"] | undefined,
	allowAdminPortalAccess?: boolean | undefined,
	fullName?: string | undefined,
	allowUpdatePaymentMethod?: boolean | undefined
};
	/** The `DateTime` scalar type represents a DateTime
value as specified by
[iso8601](https://en.wikipedia.org/wiki/ISO_8601). */
["DateTime"]:any;
	/** Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
in fields, resolvers and input. */
["UUID"]:any;
	["OrganizationType"]: {
		/** The name of the organization */
	name: string,
	key: string,
	/** The operating hours for this Organization. Will be displayed within any contact us sections. */
	operatingHours?: string | undefined,
	/** The customer facing email address to get in touch with this Organization. Will be displayed within any contact us sections. */
	emailAddress?: string | undefined,
	/** The website for this Organization. Will be displayed within any contact us sections. */
	website?: string | undefined,
	/** The disclaimer will be shown in the footer of any customer facing page. Supports basic HTML. */
	disclaimer?: string | undefined,
	disclaimerLinks?: Array<ModelTypes["DisclaimerLinksType"] | undefined> | undefined,
	phoneDisplay?: string | undefined
};
	["DisclaimerLinksType"]: {
		name?: string | undefined,
	url?: string | undefined
};
	["DistributionPartnerType"]: {
		name: string,
	/** Will be used to identify the Distribution Partner when loading a product directly via URL (i.e. `/getquote?product=[product.key]&distributionPartner=[key]`) */
	key: string,
	/** If True, allow users coming from this distribution partner to set their password and access the customer portal. If False, they remain password-less users and can't access the customer portal. */
	allowCustomerPortalAccess: boolean
};
	["CustomerDetailType"]: {
		details?: ModelTypes["UserType"] | undefined,
	quotes?: Array<ModelTypes["QuoteType"] | undefined> | undefined,
	policies?: Array<ModelTypes["PolicyType"] | undefined> | undefined,
	claims?: Array<ModelTypes["ClaimType"] | undefined> | undefined,
	payments?: Array<ModelTypes["TransactionType"] | undefined> | undefined
};
	["QuoteType"]: {
		id: string,
	riskProfile: ModelTypes["RiskProfileType"],
	currentRiskData?: ModelTypes["JSONString"] | undefined,
	product: ModelTypes["ProductType"],
	covers: Array<ModelTypes["CoverType"]>,
	exposures: Array<ModelTypes["ExposureType"]>,
	limitations: Array<ModelTypes["CoverLimitationType"]>,
	state: ModelTypes["QuoteState"],
	referralState?: ModelTypes["QuoteReferralState"] | undefined,
	createdTimestamp: ModelTypes["DateTime"],
	quotedTimestamp: ModelTypes["DateTime"],
	updatedTimestamp: ModelTypes["DateTime"],
	startDate?: ModelTypes["Date"] | undefined,
	finishDate?: ModelTypes["Date"] | undefined,
	expirationDate?: ModelTypes["DateTime"] | undefined,
	preTaxPremium?: number | undefined,
	postTaxPremium?: number | undefined,
	unadjustedPostTaxPremium?: number | undefined,
	commission?: number | undefined,
	amountDue?: number | undefined,
	paymentFrequency?: ModelTypes["QuotePaymentFrequency"] | undefined,
	/** Other pricing-related figures */
	pricingOthers?: ModelTypes["JSONString"] | undefined,
	/** Quote messages */
	messages?: ModelTypes["JSONString"] | undefined,
	privateMessages?: ModelTypes["JSONString"] | undefined,
	installments: Array<ModelTypes["InstallmentType"]>,
	policyPeriod?: ModelTypes["PolicyPeriodType"] | undefined,
	policyUpdates: Array<ModelTypes["PolicyUpdateQuoteType"]>,
	policyRenewals: Array<ModelTypes["PolicyRenewalQuoteType"]>,
	purchaseTransactions: Array<ModelTypes["TransactionType"]>,
	updateTransactions: Array<ModelTypes["TransactionType"]>,
	periodicPrice?: number | undefined,
	userReference?: string | undefined,
	documents?: Array<ModelTypes["GeneratedDocumentType"] | undefined> | undefined,
	stateDisplay?: string | undefined,
	fees?: ModelTypes["FeeSummaryType"] | undefined,
	referralStateDisplay?: string | undefined,
	referredQuestionSetKeys?: Array<string | undefined> | undefined,
	isBound?: boolean | undefined,
	daysToExpiry?: number | undefined
};
	["RiskProfileType"]: {
		id: string,
	owner: ModelTypes["UserType"],
	riskData: ModelTypes["JSONString"],
	quotes: Array<ModelTypes["QuoteType"]>,
	/** The original risk profile created in the Multi-Product flow */
	asParentInBundledRiskProfiles: Array<ModelTypes["BundledRiskProfileType"]>,
	paymentFrequency?: ModelTypes["QuotePaymentFrequency"] | undefined,
	periodicPrice?: number | undefined,
	availableProducts?: Array<ModelTypes["ProductType"] | undefined> | undefined,
	enabledProducts?: Array<ModelTypes["ProductType"] | undefined> | undefined,
	referredProducts?: Array<ModelTypes["ProductType"] | undefined> | undefined,
	knockoutProducts?: Array<ModelTypes["ProductType"] | undefined> | undefined,
	enabledCovers?: Array<ModelTypes["CoverType"] | undefined> | undefined,
	enabledExposures?: ModelTypes["GenericScalar"] | undefined,
	enabledLimitations?: Array<ModelTypes["CoverLimitationType"] | undefined> | undefined,
	state?: string | undefined,
	quoteDocumentGenerateStatus?: string | undefined,
	policyDocumentGenerateStatus?: string | undefined,
	policyPeriods?: Array<ModelTypes["PolicyPeriodType"] | undefined> | undefined,
	data?: ModelTypes["JSONString"] | undefined,
	startDate?: string | undefined,
	finishDate?: string | undefined,
	riskStateQuestionSets?: Array<ModelTypes["QuestionSetType"] | undefined> | undefined
};
	/** Allows use of a JSON String for input / output from the GraphQL schema.

Use of this type is *not recommended* as you lose the benefits of having a defined, static
schema (one of the key benefits of GraphQL). */
["JSONString"]:any;
	["BundledRiskProfileType"]: {
		id: string,
	/** Used to link a risk profile to a bundle in a Multi-Product flow */
	riskProfiles: Array<ModelTypes["RiskProfileType"]>
};
	["QuotePaymentFrequency"]:QuotePaymentFrequency;
	["ProductType"]: {
		id: string,
	provider?: ModelTypes["ProviderType"] | undefined,
	key: string,
	description?: string | undefined,
	covers: Array<ModelTypes["CoverType"]>,
	exposures: Array<ModelTypes["ExposureType"]>,
	policyCancellationQuotes: Array<ModelTypes["PolicyCancellationQuoteType"]>,
	name?: string | undefined,
	autoRenewAllowed?: boolean | undefined,
	renewalPeriod?: number | undefined,
	updateAllowed?: boolean | undefined,
	cancellationAllowed?: boolean | undefined,
	cancellationCoolingOffPeriod?: number | undefined,
	claimsAllowed?: boolean | undefined,
	paymentGateway?: ModelTypes["PaymentGateway"] | undefined,
	skipPayments?: boolean | undefined,
	autoQuote?: boolean | undefined,
	quoteDisclaimer?: string | undefined,
	availableCovers?: Array<ModelTypes["CoverType"] | undefined> | undefined
};
	["ProviderType"]: {
		name: string,
	key: string,
	logo?: string | undefined
};
	["CoverType"]: {
		id: string,
	product: ModelTypes["ProductType"],
	parentCover?: ModelTypes["CoverType"] | undefined,
	/** Whether this cover is enabled by default on an exposure. */
	isDefault: boolean,
	exposure?: ModelTypes["ExposureType"] | undefined,
	key: string,
	title: string,
	description?: string | undefined,
	icon?: string | undefined,
	subCovers: Array<ModelTypes["CoverType"]>,
	details: Array<ModelTypes["CoverLimitationType"]>,
	coverQuestionSets: Array<ModelTypes["CoverQuestionSetType"]>,
	coverquestionflowSet: Array<ModelTypes["CoverQuestionFlowType"]>,
	coversummaryquestionflowSet: Array<ModelTypes["CoverSummaryQuestionFlowType"]>,
	claimcoverquestionflowSet: Array<ModelTypes["ClaimCoverQuestionFlowType"]>,
	editable?: boolean | undefined
};
	["ExposureType"]: {
		id: string,
	/** An identifier for the exposure. */
	key: string,
	/** A category for the exposure. E.g. car, property, person, etc. */
	type: string,
	/** Human readable text for display purposes. */
	name: string,
	product: ModelTypes["ProductType"],
	/** The maximum number of exposures allowed for this key for this product. */
	limit: number,
	/** The path in the risk data to a value used to identify the exposure. */
	userReferencePath?: string | undefined,
	icon?: string | undefined,
	covers: Array<ModelTypes["CoverType"]>,
	exposureQuestionSets: Array<ModelTypes["ExposureQuestionSetType"]>,
	exposurequestionflowSet: Array<ModelTypes["ExposureQuestionFlowType"]>
};
	["ExposureQuestionSetType"]: {
		id: string,
	exposure: ModelTypes["ExposureType"],
	questionSet: ModelTypes["QuestionSetType"],
	/** The key of the exposure item in the risk data that this question set is related to. Not to be confused with the db model attribute Exposure.key. */
	exposureItemKey: string
};
	["QuestionSetType"]: {
		id: string,
	/** Will be used as the URL slug. */
	key: string,
	/** A small headline for this question set. */
	title?: string | undefined,
	/** Main headline for this question set. */
	description?: string | undefined,
	/** An optional label to help group the questions under this question set. */
	label?: string | undefined,
	/** Optional help text displayed below the description. Callouts may be used instead for better display options. */
	help?: string | undefined,
	/** Questions may be skipped (i.e. not delivered to a user) if they have a single default value. In all other cases, they will be shown. */
	skippable: boolean,
	/** Optional list of serialized `Validator` classes to execute upon answer of this question set. These validators will be have access/context of all questions within the question set (as opposed to question validators which don't). */
	validators?: ModelTypes["JSONString"] | undefined,
	/** The order this question set will be delivered in relation to other question sets. */
	order: number,
	questions: Array<ModelTypes["QuestionType"]>,
	/** For nested forms. Only used for `input_type` with `form` or `form-list` values. */
	parentQuestions: Array<ModelTypes["QuestionType"]>,
	rhetoricals: Array<ModelTypes["RhetoricalType"]>,
	enquiries: Array<ModelTypes["EnquiryType"]>,
	coverQuestionSets: Array<ModelTypes["CoverQuestionSetType"]>,
	exposureQuestionSets: Array<ModelTypes["ExposureQuestionSetType"]>
};
	["QuestionType"]: {
		id: string,
	questionSet: ModelTypes["QuestionSetType"],
	/** The input field label. */
	label?: string | undefined,
	/** The summary display label, falls back to the `label` if not set. */
	displayLabel?: string | undefined,
	/** Used to optionally display a more prominent title for a question. (Usually used in combination with `{"show_label": False}` on `input_args`) */
	title?: string | undefined,
	/** An optional caption for the input field, displayed underneath it. */
	help?: string | undefined,
	/** The type of input field for this question. See `inputRegistry` and `displayRegistry` for possible values. */
	inputType: string,
	/** Special arguments to be passed (as props) to the chosen `input_type`, that allows customizing its behavour. Check the chosen `input_type` component (or other similar questions) for possible values for each input type. */
	inputArgs?: ModelTypes["JSONString"] | undefined,
	/** For nested forms. Only used for `input_type` with `form` or `form-list` values. */
	inputForm?: ModelTypes["QuestionSetType"] | undefined,
	/** The path to where the answer from the user will be stored. */
	storagePath: string,
	/** Default value (if any). */
	default?: ModelTypes["JSONString"] | undefined,
	/** Optional list of serialized `Validator` classes to execute upon answer of this question. */
	validators?: ModelTypes["JSONString"] | undefined,
	/** The order this question will be delivered in relation to other questions. */
	order: number,
	/** Metadata for this question. */
	metadata?: ModelTypes["JSONString"] | undefined,
	answers: Array<ModelTypes["AnswerType"]>,
	rhetoricals: Array<ModelTypes["RhetoricalType"]>
};
	["AnswerType"]: {
		id: string,
	question: ModelTypes["QuestionType"],
	value?: ModelTypes["JSONString"] | undefined,
	source?: ModelTypes["DataProviderType"] | undefined
};
	["DataProviderType"]: {
		id: string,
	name: string
};
	["RhetoricalType"]: {
		id: string,
	/** An internal reference name to help identify this object. Needs to be unique for each release and question/question set. */
	name: string,
	questionSet?: ModelTypes["QuestionSetType"] | undefined,
	question?: ModelTypes["QuestionType"] | undefined,
	kind: ModelTypes["RhetoricalKind"],
	/** Special arguments to be passed (as props) to the chosen `kind`, that allows customizing its behavour. Check the chosen `kind` component (or other similar rhetoricals) for possible values for each kind. */
	args?: ModelTypes["JSONString"] | undefined,
	/** The order this object will be delivered in relation to other objects from this question or question set. */
	order: number
};
	["RhetoricalKind"]:RhetoricalKind;
	["EnquiryType"]: {
		id: string,
	user?: ModelTypes["UserType"] | undefined,
	questionFlow?: ModelTypes["QuestionFlowType"] | undefined,
	questionSet: ModelTypes["QuestionSetType"],
	timestamp: ModelTypes["DateTime"]
};
	["QuestionFlowType"]: ModelTypes["ExposureQuestionFlowType"] | ModelTypes["CoverQuestionFlowType"] | ModelTypes["CoverSummaryQuestionFlowType"] | ModelTypes["ClaimCoverQuestionFlowType"] | ModelTypes["QuoteQuestionFlowType"] | ModelTypes["PolicyHolderQuestionFlowType"] | ModelTypes["AdjustmentQuestionFlowType"] | ModelTypes["CancellationQuestionFlowType"] | ModelTypes["QuoteSummaryQuestionFlowType"] | ModelTypes["KnockoutQuestionFlowType"] | ModelTypes["ClaimQuestionFlowType"] | ModelTypes["UpdateQuestionFlowType"] | ModelTypes["LegalQuestionFlowType"] | ModelTypes["PolicyDetailsQuestionFlowType"] | ModelTypes["ClaimProductQuestionFlowType"];
	["MessageType"]: {
		id: string,
	kind: ModelTypes["MessageKind"],
	content: string
};
	["MessageKind"]:MessageKind;
	["CoverQuestionSetType"]: {
		id: string,
	cover: ModelTypes["CoverType"],
	questionSet: ModelTypes["QuestionSetType"]
};
	["ExposureQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: ModelTypes["RiskProfileType"],
	exposure: ModelTypes["ExposureType"],
	exposureItemKey: string,
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["CoverLimitationType"]: {
		id: string,
	cover: ModelTypes["CoverType"],
	key: string,
	kind: ModelTypes["CoverLimitationKind"],
	text: string,
	description: string,
	order: number,
	overrides: Array<ModelTypes["CoverLimitationType"]>,
	/** Default limitations are enabled by default, while extra limitations are enabled by the underwriter during the adjust referral quote process. */
	level: ModelTypes["CoverLimitationLevel"],
	overriddenBy: Array<ModelTypes["CoverLimitationType"]>
};
	["CoverLimitationKind"]:CoverLimitationKind;
	["CoverLimitationLevel"]:CoverLimitationLevel;
	["CoverQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: ModelTypes["RiskProfileType"],
	cover: ModelTypes["CoverType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["CoverSummaryQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: ModelTypes["RiskProfileType"],
	cover: ModelTypes["CoverType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["ClaimCoverQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	claimProfile: ModelTypes["ClaimProfileType"],
	cover: ModelTypes["CoverType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["ClaimProfileType"]: {
		id: string,
	owner: ModelTypes["UserType"],
	claim?: ModelTypes["ClaimType"] | undefined,
	policyPeriods?: Array<ModelTypes["PolicyPeriodType"] | undefined> | undefined,
	products?: Array<ModelTypes["ProductType"] | undefined> | undefined,
	covers?: Array<ModelTypes["CoverType"] | undefined> | undefined,
	claimStateQuestionSets?: Array<ModelTypes["QuestionSetType"] | undefined> | undefined,
	data?: ModelTypes["JSONString"] | undefined
};
	["ClaimType"]: {
		id: string,
	created: ModelTypes["DateTime"],
	policyPeriods: Array<ModelTypes["PolicyPeriodType"]>,
	claimNumber: string,
	claimProfile?: ModelTypes["ClaimProfileType"] | undefined,
	status?: ModelTypes["ClaimStatusChoices"] | undefined,
	policyNumber?: string | undefined,
	statusType?: ModelTypes["ClaimStatusTypes"] | undefined,
	statusTypeDisplay?: string | undefined,
	decision?: string | undefined,
	closedDate?: string | undefined
};
	["PolicyPeriodType"]: {
		id: string,
	policy: ModelTypes["PolicyType"],
	quote: ModelTypes["QuoteType"],
	boundTimestamp: ModelTypes["DateTime"],
	startDate: ModelTypes["Date"],
	finishDate: ModelTypes["Date"],
	periodNumber: number,
	kind: ModelTypes["PolicyPeriodKind"],
	/** Policy Period in effect at the moment of creating this renewal quote. */
	renewalQuotes: Array<ModelTypes["PolicyRenewalQuoteType"]>,
	claims: Array<ModelTypes["ClaimType"]>,
	transactions: Array<ModelTypes["TransactionType"]>,
	policyNumber?: string | undefined,
	documents?: Array<ModelTypes["GeneratedDocumentType"] | undefined> | undefined,
	latestTransaction?: ModelTypes["TransactionType"] | undefined
};
	["PolicyType"]: {
		id: string,
	policyNumber?: string | undefined,
	uuid: ModelTypes["UUID"],
	autoRenewEnabled: boolean,
	currentPeriod?: ModelTypes["PolicyPeriodType"] | undefined,
	status: ModelTypes["PolicyStatus"],
	periods: Array<ModelTypes["PolicyPeriodType"]>,
	updateQuotes: Array<ModelTypes["PolicyUpdateQuoteType"]>,
	cancellationQuotes: Array<ModelTypes["PolicyCancellationQuoteType"]>,
	renewalQuotes: Array<ModelTypes["PolicyRenewalQuoteType"]>,
	transactions?: Array<ModelTypes["TransactionType"] | undefined> | undefined,
	documents?: Array<ModelTypes["GeneratedDocumentType"] | undefined> | undefined,
	statusDisplay?: string | undefined,
	riskProfile?: ModelTypes["RiskProfileType"] | undefined,
	startDate?: string | undefined,
	finishDate?: string | undefined,
	quote?: ModelTypes["QuoteType"] | undefined,
	policyUpdate?: ModelTypes["PolicyUpdateQuoteType"] | undefined,
	latestUpdate?: ModelTypes["PolicyUpdateQuoteType"] | undefined,
	draftUpdate?: ModelTypes["QuoteType"] | undefined,
	policyCancellationQuote?: ModelTypes["PolicyCancellationQuoteType"] | undefined,
	updateAllowed?: boolean | undefined,
	cancellationAllowed?: boolean | undefined,
	claimsAllowed?: boolean | undefined,
	latestRenewal?: ModelTypes["PolicyRenewalQuoteType"] | undefined,
	latestCancellation?: ModelTypes["PolicyCancellationQuoteType"] | undefined,
	isWithinRenewalPeriod?: boolean | undefined,
	isPendingCancellation?: boolean | undefined,
	policyPeriods?: Array<ModelTypes["PolicyPeriodType"] | undefined> | undefined
};
	["PolicyStatus"]:PolicyStatus;
	["PolicyUpdateQuoteType"]: {
		id: string,
	created: ModelTypes["DateTime"],
	modified: ModelTypes["DateTime"],
	policy: ModelTypes["PolicyType"],
	quote: ModelTypes["QuoteType"],
	/** Pro-rata amount balance to charge or refund. */
	proRataAmountDue: number
};
	["PolicyCancellationQuoteType"]: {
		id: string,
	policy: ModelTypes["PolicyType"],
	state: ModelTypes["PolicyCancellationQuoteState"],
	effectiveDate?: ModelTypes["Date"] | undefined,
	amountDue?: number | undefined,
	fees?: ModelTypes["FeeSummaryType"] | undefined,
	data?: ModelTypes["JSONString"] | undefined
};
	["PolicyCancellationQuoteState"]:PolicyCancellationQuoteState;
	/** The `Date` scalar type represents a Date
value as specified by
[iso8601](https://en.wikipedia.org/wiki/ISO_8601). */
["Date"]:any;
	["FeeSummaryType"]: {
		breakdown?: Array<ModelTypes["FeeType"] | undefined> | undefined,
	taxes?: number | undefined,
	fees?: number | undefined,
	stampDuty?: number | undefined
};
	["FeeType"]: {
		kind?: string | undefined,
	amount?: number | undefined,
	feeType?: ModelTypes["FeeTypeType"] | undefined
};
	["FeeTypeType"]: {
		key: string,
	label: string,
	kind: ModelTypes["FeeTypeKind"]
};
	["FeeTypeKind"]:FeeTypeKind;
	["PolicyRenewalQuoteType"]: {
		id: string,
	policy: ModelTypes["PolicyType"],
	/** Policy Period in effect at the moment of creating this renewal quote. */
	policyPeriod: ModelTypes["PolicyPeriodType"],
	quote: ModelTypes["QuoteType"],
	submittedTimestamp: ModelTypes["DateTime"],
	canDiscard?: boolean | undefined,
	canAccept?: boolean | undefined
};
	["TransactionType"]: {
		id: string,
	policyPeriod?: ModelTypes["PolicyPeriodType"] | undefined,
	status: ModelTypes["TransactionStatus"],
	paymentProfile?: ModelTypes["PaymentProfileType"] | undefined,
	/** Unique identifier for this transaction within the payment gateway. */
	paymentGatewayTransactionReference: string,
	actionType: ModelTypes["TransactionActionType"],
	transactionType: ModelTypes["TransactionTransactionType"],
	amount: number,
	currency: ModelTypes["TransactionCurrency"],
	policyNumber?: string | undefined,
	statusDisplay?: string | undefined,
	transactionTypeDisplay?: string | undefined,
	actionTypeDisplay?: string | undefined,
	amountWithSurcharge?: number | undefined
};
	["TransactionStatus"]:TransactionStatus;
	["PaymentProfileType"]: {
		id: string,
	/** To help the customer identify this payment profile (i.e. last 4 digits of a cc). */
	customerReference: string,
	paymentGateway: ModelTypes["PaymentProfilePaymentGateway"]
};
	["PaymentProfilePaymentGateway"]:PaymentProfilePaymentGateway;
	["TransactionActionType"]:TransactionActionType;
	["TransactionTransactionType"]:TransactionTransactionType;
	["TransactionCurrency"]:TransactionCurrency;
	["GeneratedDocumentType"]: {
		id: string,
	created: ModelTypes["DateTime"],
	modified: ModelTypes["DateTime"],
	objectId?: number | undefined,
	user: ModelTypes["UserType"],
	file: string,
	name: string,
	type?: string | undefined,
	key?: string | undefined,
	url?: string | undefined
};
	["PolicyPeriodKind"]:PolicyPeriodKind;
	["ClaimStatusChoices"]:ClaimStatusChoices;
	["ClaimStatusTypes"]:ClaimStatusTypes;
	["ClaimStateFilterEnum"]:ClaimStateFilterEnum;
	["PaymentGateway"]:PaymentGateway;
	/** The `GenericScalar` scalar type represents a generic
GraphQL scalar value that could be:
String, Boolean, Int, Float, List or Object. */
["GenericScalar"]:any;
	["RiskStateFilterEnum"]:RiskStateFilterEnum;
	["QuoteState"]:QuoteState;
	["QuoteReferralState"]:QuoteReferralState;
	["InstallmentType"]: {
		id: string,
	quote?: ModelTypes["QuoteType"] | undefined,
	dueDate: ModelTypes["Date"],
	inclusivePrice: number,
	kind: ModelTypes["InstallmentKind"],
	fees: Array<ModelTypes["FeeType"]>
};
	["InstallmentKind"]:InstallmentKind;
	["PoliciesType"]: {
		totalItemCount?: number | undefined,
	page?: number | undefined,
	pageSize?: ModelTypes["PageSize"] | undefined,
	pageCount?: number | undefined,
	hasNext?: boolean | undefined,
	hasPrev?: boolean | undefined,
	items?: Array<ModelTypes["PolicyType"] | undefined> | undefined
};
	["QuotesType"]: {
		totalItemCount?: number | undefined,
	page?: number | undefined,
	pageSize?: ModelTypes["PageSize"] | undefined,
	pageCount?: number | undefined,
	hasNext?: boolean | undefined,
	hasPrev?: boolean | undefined,
	items?: Array<ModelTypes["QuoteType"] | undefined> | undefined
};
	["QuoteFilterBy"]:QuoteFilterBy;
	["QuoteDetailType"]: {
		details?: ModelTypes["QuoteType"] | undefined,
	notes?: Array<ModelTypes["NoteType"] | undefined> | undefined
};
	["NoteType"]: {
		id: string,
	created: ModelTypes["DateTime"],
	content?: string | undefined,
	author: ModelTypes["UserType"]
};
	["ClaimsType"]: {
		totalItemCount?: number | undefined,
	page?: number | undefined,
	pageSize?: ModelTypes["PageSize"] | undefined,
	pageCount?: number | undefined,
	hasNext?: boolean | undefined,
	hasPrev?: boolean | undefined,
	items?: Array<ModelTypes["ClaimType"] | undefined> | undefined
};
	["ClaimFilterBy"]:ClaimFilterBy;
	["ClaimDetailType"]: {
		details?: ModelTypes["ClaimType"] | undefined,
	notes?: Array<ModelTypes["NoteType"] | undefined> | undefined
};
	["ReportsType"]: {
		totalItemCount?: number | undefined,
	page?: number | undefined,
	pageSize?: ModelTypes["PageSize"] | undefined,
	pageCount?: number | undefined,
	hasNext?: boolean | undefined,
	hasPrev?: boolean | undefined,
	items?: Array<ModelTypes["ReportType"] | undefined> | undefined,
	reportTypes?: ModelTypes["GenericScalar"] | undefined
};
	["ReportType"]: {
		id: string,
	file?: string | undefined,
	/** Start date/time of report data date range. */
	startDatetime: ModelTypes["DateTime"],
	/** End date/time of report data date range. */
	endDatetime: ModelTypes["DateTime"],
	name?: string | undefined,
	generatedDate?: ModelTypes["DateTime"] | undefined,
	reportType?: string | undefined,
	url?: string | undefined,
	taskStatus?: string | undefined
};
	["DataAnalyticsType"]: {
		totalQuotes?: ModelTypes["DataAnalyticsCardType"] | undefined,
	quotesThisMonth?: ModelTypes["DataAnalyticsCardType"] | undefined,
	policiesByStatus?: ModelTypes["DataAnalyticsCardType"] | undefined,
	policiesRenewed?: ModelTypes["DataAnalyticsCardType"] | undefined,
	totalActivePolicies?: ModelTypes["DataAnalyticsCardType"] | undefined,
	totalCustomers?: ModelTypes["DataAnalyticsCardType"] | undefined,
	totalClaims?: ModelTypes["DataAnalyticsCardType"] | undefined,
	conversionRate?: ModelTypes["DataAnalyticsCardType"] | undefined,
	totalGwp?: ModelTypes["DataAnalyticsCardType"] | undefined
};
	["DataAnalyticsCardType"]: {
		title?: string | undefined,
	summaryValue?: string | undefined,
	summaryValueType?: string | undefined,
	statistics?: Array<ModelTypes["DataAnalyticsStatisticType"] | undefined> | undefined
};
	["DataAnalyticsStatisticType"]: {
		label?: string | undefined,
	value?: string | undefined,
	type?: string | undefined
};
	["SsoConfigurationType"]: {
		/** Unique identifier for this configuration within the IDP platform. This is required to authenticate authenticator as a client. */
	clientIdKey?: string | undefined,
	/** Login URL for this configuration. For the login button link use the Login initialize URL. */
	loginUrl: string,
	/** Logout URL for this configuration. */
	logoutUrl: string,
	/** Call back URL for this configuration. */
	callbackUrl?: string | undefined,
	/** Success redirect URL for this configuration. */
	successRedirectUrl?: string | undefined,
	/** Error redirect URL for this configuration. */
	errorRedirectUrl?: string | undefined,
	isClientSecretKeySet?: boolean | undefined
};
	["DownloadDocumentType"]: {
		url?: string | undefined
};
	["DownloadFileType"]: {
		url?: string | undefined
};
	["AnzsicCodeDivisionType"]: {
		id: string,
	year: string,
	code: string,
	label: string,
	subdivisions: Array<ModelTypes["AnzsicCodeSubdivisionType"]>
};
	["AnzsicCodeSubdivisionType"]: {
		id: string,
	division: ModelTypes["AnzsicCodeDivisionType"],
	year: string,
	code: string,
	label: string,
	groups: Array<ModelTypes["AnzsicCodeGroupType"]>
};
	["AnzsicCodeGroupType"]: {
		id: string,
	subdivision: ModelTypes["AnzsicCodeSubdivisionType"],
	year: string,
	code: string,
	label: string,
	classes: Array<ModelTypes["AnzsicCodeClassType"]>
};
	["AnzsicCodeClassType"]: {
		id: string,
	group: ModelTypes["AnzsicCodeGroupType"],
	year: string,
	code: string,
	label: string
};
	["ClaimStateType"]: {
		claimProfile?: ModelTypes["ClaimProfileType"] | undefined,
	questionSets?: Array<ModelTypes["QuestionSetType"] | undefined> | undefined
};
	["RiskStateType"]: {
		riskProfile?: ModelTypes["RiskProfileType"] | undefined,
	questionSets?: Array<ModelTypes["QuestionSetType"] | undefined> | undefined
};
	["ThemeType"]: {
		logo?: ModelTypes["LogoType"] | undefined,
	themeOverride?: ModelTypes["GenericScalar"] | undefined
};
	["LogoType"]: {
		src?: string | undefined,
	altText?: string | undefined
};
	["CybersourceContextType"]: {
		context?: string | undefined
};
	["ValidateAddressBzType"]: {
		data?: ModelTypes["JSONString"] | undefined
};
	["SearchAddressBzType"]: {
		data?: ModelTypes["JSONString"] | undefined
};
	["PaymentMethodType"]: {
		cardNumber?: string | undefined,
	cardType?: string | undefined,
	expiryDate?: string | undefined
};
	["Mutation"]: {
		admin?: ModelTypes["AdminMutation"] | undefined,
	/** Hijack user endpoint.

This endpoint triggers the django-hijack function. */
	hijackUser?: ModelTypes["TokenType"] | undefined,
	/** Release user endpoint.

This endpoint triggers the django-release function. */
	releaseUser?: ModelTypes["TokenType"] | undefined,
	/** SSO verification mutation.

This endpoint verifies user login.

authenticator_type: Authenticator for this login
token: Token to use for verification, this can be different in different IDPs
    - For SamlAuthenticator - It's the refresh token */
	ssoVerification?: ModelTypes["TokenType"] | undefined,
	/** SSO init mutation.

This is to initiate the SSO login process. This receives the fetch back key,
fetch back value and the authenticator type from the front end.

This fetch back value is used to identify the existing session if user is already
logged in. The fetch back key is the key for this value and the value retried from
the browser local storage by using the key. This fetch back key and the value
varies based on the IDP and for SAML authenticator, it is the `refresh_token`.

This mutation responds back with the updated authentication URL by attaching the
fetch back value and the key, if exists. Then the frontend will redirect the user
to that URL and there we check if the session is already exists or not. */
	ssoAuthenticate?: ModelTypes["SsoRedirectType"] | undefined,
	/** Bind quotes and complete payment for a given Risk Profile. */
	completePayment?: ModelTypes["CompletePaymentMutation"] | undefined,
	/** Bind quote without payment for a given Risk Profile. */
	confirmQuote?: ModelTypes["ConfirmQuoteMutation"] | undefined,
	/** Update payment method for a given Risk Profile. */
	updatePaymentMethod?: ModelTypes["UpdatePaymentMethodMutation"] | undefined,
	/** Refresh user tokens (if session based log in) or create an anonymous user session.

All entities created through the quote flow are associated with this user. */
	refreshUser?: ModelTypes["TokenType"] | undefined,
	/** Authenticate a given email/password combination. */
	tokenAuth?: ModelTypes["ObtainJSONWebToken"] | undefined,
	/** Logout a user. */
	logoutUser?: ModelTypes["LogoutUserMutation"] | undefined,
	/** Resets the password of a user and sends them an email.

If the user has an unusable password, this will do nothing; no error will be raised
and and no email will be sent. */
	sendPasswordResetEmail?: ModelTypes["SendPasswordResetEmailMutation"] | undefined,
	/** Change user password without old password.

Receive the token that was sent by email.

If token and new passwords are valid, update
user password and in case of using refresh
tokens, revoke all of them.

Also, if user has not been verified yet, verify it. */
	passwordReset?: ModelTypes["PasswordReset"] | undefined,
	updateAccount?: ModelTypes["UpdateAccount"] | undefined,
	/** Convert an existing LazyUser/PasswordLessUser into a User. */
	registerUser?: ModelTypes["RegisterUserMutation"] | undefined,
	/** Convert an existing LazyUser into a PasswordLessUser. */
	registerPasswordLessUser?: ModelTypes["RegisterPasswordLessUserMutation"] | undefined,
	/** Update keys and urls for SSO config. */
	updateSsoConfiguration?: ModelTypes["SsoConfigurationOutputType"] | undefined,
	/** Perform a Data Import for a new or existing user.

A risk profile is created and a one-time login link is returned. */
	dataImport?: ModelTypes["DataImportMutation"] | undefined,
	sortedImport?: ModelTypes["SortedImportMutation"] | undefined,
	/** Start and return a Quote question flow for a given Risk Profile. */
	startQuote?: ModelTypes["QuoteQuestionFlowType"] | undefined,
	/** Start a policy cancellation flow. */
	startCancellation?: ModelTypes["CancellationQuestionFlowType"] | undefined,
	/** Start and return a Cover question flow for a given Risk Profile. */
	startCover?: ModelTypes["CoverQuestionFlowType"] | undefined,
	/** Start and return a Cover Summary question flow for a given Risk Profile. */
	startCoverSummary?: ModelTypes["CoverSummaryQuestionFlowType"] | undefined,
	/** Start and return an Exposure question flow for a given Risk Profile. */
	startExposure?: ModelTypes["ExposureQuestionFlowType"] | undefined,
	/** Start and return a Quote Summary question flow for a given Risk Profile. */
	startQuoteSummary?: ModelTypes["QuoteSummaryQuestionFlowType"] | undefined,
	/** Start and return a Policy Holder question flow for a given Risk Profile. */
	startPolicyholder?: ModelTypes["PolicyHolderQuestionFlowType"] | undefined,
	/** Start and return a Knockouts question flow for a given Risk Profile. */
	startKnockouts?: ModelTypes["KnockoutQuestionFlowType"] | undefined,
	/** Start and return a Claim question flow for a given Policy. */
	startClaim?: ModelTypes["ClaimQuestionFlowType"] | undefined,
	/** Formally submit a Claim given a claim profile. */
	submitClaim?: Array<ModelTypes["ClaimType"] | undefined> | undefined,
	/** Provide an answer for a given Enquiry and return the next Question flow. */
	answerEnquiry?: ModelTypes["QuestionFlowType"] | undefined,
	/** Price (get a quote for) a given Risk Profile. */
	priceRiskProfile?: ModelTypes["RiskProfileType"] | undefined,
	/** Store changes to a cover's questions.

A cover can be enabled/disabled, and have answers to the cover's
questions stored against the risk profile.

Returns the risk profile after first recalculating quotes in
response to the new answers. */
	updateRiskCover?: ModelTypes["RiskProfileType"] | undefined,
	/** Store changes to an exposure item's questions.

An exposure item can be enabled/disabled, and have answers to the item's
questions stored against the risk profile.

Returns the risk profile after first recalculating quotes in
response to the new answers. */
	updateRiskExposure?: ModelTypes["RiskProfileType"] | undefined,
	updatePolicy?: ModelTypes["PolicyType"] | undefined,
	/** Bind a Quote (from a given Risk Profile) to create a Policy.

This endpoint does not process payments. */
	bindQuotes?: Array<ModelTypes["PolicyPeriodType"] | undefined> | undefined,
	/** Generates multiple documents.

If 'quote_id' or 'policy_id' is provided, this will generate all documents
associated with the 'quote' or 'bind' events depending on which was provided. */
	generateDocuments?: ModelTypes["GenerateDocuments"] | undefined,
	/** Generates a single document for the given 'type'.

'quote_id' or 'policy_id' is required to link the generated document to and find
the relevant product. */
	generateDocument?: ModelTypes["GenerateDocument"] | undefined,
	/** Start a policy update flow.

Create a new PolicyUpdate model (if needed), then depending on the 'flow' parameter
passed in will return the appropriate QuestionSet to be answered next by the user. */
	startPolicyUpdate?: ModelTypes["UpdateQuestionFlowType"] | undefined,
	/** Confirm and bind the policy update quote for a given policy. */
	confirmPolicyUpdate?: ModelTypes["PolicyType"] | undefined,
	/** Provides a summary of changes in the draft update quote for a policy. */
	policyUpdateSummary?: ModelTypes["PolicyUpdateSummaryChangesType"] | undefined,
	/** Provides a summary of a draft cancellation quote request for a given policy. */
	policyCancellationSummary?: ModelTypes["PolicyCancellationQuoteType"] | undefined,
	/** Finalizes cancelling a policy given a policy cancellation quote. */
	confirmPolicyCancellation?: ModelTypes["PolicyType"] | undefined,
	/** Provides a summary of changes in the draft renewal quote for a policy. */
	policyRenewalSummary?: ModelTypes["PolicyRenewalSummaryChangesType"] | undefined,
	/** Store changes to enabled products question.

A product can be enabled when starting a new quote.
This mutation allows the user to enable/disable products. */
	toggleEnabledProducts?: ModelTypes["RiskProfileType"] | undefined,
	/** Discard a renewal quote. */
	discardRenewalQuote?: ModelTypes["PolicyRenewalQuoteType"] | undefined,
	/** Create a new renewal quote. */
	createRenewalQuote?: ModelTypes["PolicyRenewalQuoteType"] | undefined,
	/** Accept a renewal quote. */
	acceptRenewalQuote?: ModelTypes["PolicyRenewalQuoteType"] | undefined
};
	["AdminMutation"]: {
		closeClaim?: ModelTypes["CloseClaimMutation"] | undefined,
	/** Create lazy user endpoint.

This endpoint will create a lazy user. */
	createLazyUser?: ModelTypes["UserType"] | undefined,
	/** Create note endpoint.

This endpoint will create a note. */
	createNote?: ModelTypes["NoteType"] | undefined,
	/** Start and return a quote question flow for a given referred quote. */
	editReferredQuote?: ModelTypes["QuoteQuestionFlowType"] | undefined,
	/** Start and return a Policy Holder question flow for a given Risk Profile. */
	editPolicyholder?: ModelTypes["PolicyHolderQuestionFlowType"] | undefined,
	/** Send quote email endpoint.

This endpoint will email a quote link to user */
	emailQuote?: ModelTypes["SendQuoteEmailMutation"] | undefined,
	generateReport?: ModelTypes["ReportType"] | undefined,
	/** Price a referred RiskProfile. */
	priceReferredRiskProfile?: ModelTypes["RiskProfileType"] | undefined,
	/** Start and return a adjustment question flow for a given quote. */
	startAdjustment?: ModelTypes["AdjustmentQuestionFlowType"] | undefined,
	/** Update a referred quote's referral state. */
	updateQuoteReferralState?: ModelTypes["UpdateQuoteReferralStateMutation"] | undefined,
	discardRenewalQuote?: ModelTypes["AdminDiscardRenewalQuoteMutation"] | undefined
};
	["CloseClaimMutation"]: {
		success?: boolean | undefined,
	claim?: ModelTypes["ClaimType"] | undefined
};
	["ClosedStatus"]:ClosedStatus;
	["CreateLazyUserInput"]: {
	email: string,
	firstName: string,
	lastName: string
};
	["NoteAssociationLimit"]:NoteAssociationLimit;
	["QuoteQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: ModelTypes["RiskProfileType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["EditQuoteInput"]: {
	quoteId: string
};
	["PolicyHolderQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: ModelTypes["RiskProfileType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["EditPolicyholderInput"]: {
	riskProfileId: string
};
	/** Send quote email endpoint.

This endpoint will email a quote link to user */
["SendQuoteEmailMutation"]: {
		message?: string | undefined
};
	["SendQuoteEmailInput"]: {
	quoteId: string,
	toEmail: string
};
	["GenerateReportInput"]: {
	reportType: string,
	startDate: string,
	endDate: string
};
	["AdjustmentQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: ModelTypes["RiskProfileType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["StartAdjustmentInput"]: {
	riskProfileId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	/** Update a referred quote's referral state. */
["UpdateQuoteReferralStateMutation"]: {
		success?: boolean | undefined,
	quote?: ModelTypes["QuoteType"] | undefined,
	note?: ModelTypes["NoteType"] | undefined
};
	["ReferralState"]:ReferralState;
	["AdminDiscardRenewalQuoteMutation"]: {
		success?: boolean | undefined,
	renewalQuote?: ModelTypes["PolicyRenewalQuoteType"] | undefined
};
	["RenewalQuoteInput"]: {
	renewalQuoteId: string
};
	["TokenType"]: {
		token?: string | undefined,
	user?: ModelTypes["UserType"] | undefined
};
	["HijackUserInput"]: {
	userId: string
};
	["SsoRedirectType"]: {
		url?: string | undefined
};
	["CompletePaymentMutation"]: {
		paymentSuccess?: boolean | undefined,
	bindSuccess?: boolean | undefined,
	errorMessage?: string | undefined
};
	["CompletePaymentInput"]: {
	riskProfileId: string,
	metadata: ModelTypes["GenericScalar"]
};
	["ConfirmQuoteMutation"]: {
		paymentSuccess?: boolean | undefined,
	bindSuccess?: boolean | undefined,
	errorMessage?: string | undefined
};
	["UpdatePaymentMethodMutation"]: {
		success?: boolean | undefined,
	errorMessage?: string | undefined
};
	["UpdatePaymentMethodInput"]: {
	metadata: ModelTypes["GenericScalar"]
};
	["RefreshUserInput"]: {
	distributionPartner?: string | undefined
};
	/** Authenticate a given email/password combination. */
["ObtainJSONWebToken"]: {
		token?: string | undefined,
	user?: ModelTypes["UserType"] | undefined
};
	/** Logout a user. */
["LogoutUserMutation"]: {
		success?: boolean | undefined
};
	/** Resets the password of a user and sends them an email.

If the user has an unusable password, this will do nothing; no error will be raised
and and no email will be sent. */
["SendPasswordResetEmailMutation"]: {
		success?: boolean | undefined,
	errors?: ModelTypes["ExpectedErrorType"] | undefined
};
	/**
    Errors messages and codes mapped to
    fields or non fields errors.
    Example:
    {
        field_name: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ],
        other_field: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ],
        nonFieldErrors: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ]
    }
     */
["ExpectedErrorType"]:any;
	/** Change user password without old password.

Receive the token that was sent by email.

If token and new passwords are valid, update
user password and in case of using refresh
tokens, revoke all of them.

Also, if user has not been verified yet, verify it. */
["PasswordReset"]: {
		success?: boolean | undefined,
	errors?: ModelTypes["ExpectedErrorType"] | undefined
};
	["UpdateAccount"]: {
		success?: boolean | undefined,
	errors?: ModelTypes["ExpectedErrorType"] | undefined
};
	/** Convert an existing LazyUser/PasswordLessUser into a User. */
["RegisterUserMutation"]: {
		success?: boolean | undefined,
	errors?: ModelTypes["ExpectedErrorType"] | undefined,
	user?: ModelTypes["UserType"] | undefined,
	token?: string | undefined
};
	/** Convert an existing LazyUser into a PasswordLessUser. */
["RegisterPasswordLessUserMutation"]: {
		success?: boolean | undefined,
	errors?: ModelTypes["ExpectedErrorType"] | undefined,
	user?: ModelTypes["UserType"] | undefined,
	token?: string | undefined
};
	["SsoConfigurationOutputType"]: {
		clientIdKey?: string | undefined,
	loginUrl?: string | undefined,
	logoutUrl?: string | undefined,
	callbackUrl?: string | undefined,
	successRedirectUrl?: string | undefined,
	errorRedirectUrl?: string | undefined
};
	["SsoConfigurationInput"]: {
	clientIdKey?: string | undefined,
	clientSecretKey?: string | undefined,
	loginUrl?: string | undefined,
	logoutUrl?: string | undefined,
	callbackUrl?: string | undefined,
	successRedirectUrl?: string | undefined,
	errorRedirectUrl?: string | undefined
};
	/** Perform a Data Import for a new or existing user.

A risk profile is created and a one-time login link is returned. */
["DataImportMutation"]: {
		oneTimeLoginUrl?: string | undefined
};
	["DataImportInput"]: {
	distributionPartner: string,
	enabledProducts: Array<string | undefined>,
	userReference?: string | undefined,
	email?: string | undefined,
	riskData?: ModelTypes["GenericScalar"] | undefined
};
	["SortedImportMutation"]: {
		loginUrl?: string | undefined,
	user?: ModelTypes["SortedUserType"] | undefined
};
	["SortedUserType"]: {
		id: string,
	sortedId?: string | undefined,
	customerNumber: string,
	user: ModelTypes["UserType"],
	email?: string | undefined,
	uuid: ModelTypes["UUID"],
	workPhone?: string | undefined,
	homePhone?: string | undefined,
	mobile?: string | undefined,
	dateOfBirth?: ModelTypes["Date"] | undefined,
	propertyRoles: Array<ModelTypes["SortedUserPropertyRoleType"]>
};
	["SortedUserPropertyRoleType"]: {
		id: string,
	sortedUser: ModelTypes["SortedUserType"],
	serviceNumber: string,
	riskProfile?: ModelTypes["RiskProfileType"] | undefined
};
	["SortedImportInput"]: {
	customerNumber: string,
	serviceNumber: string,
	email: string
};
	["StartQuoteInput"]: {
	create?: boolean | undefined,
	questionSetKey?: string | undefined,
	enabledProducts?: Array<string | undefined> | undefined,
	restart?: boolean | undefined,
	autoQuote?: boolean | undefined,
	fileLink?: string | undefined
};
	["CancellationQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: ModelTypes["RiskProfileType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["StartPolicyCancellationInput"]: {
	policyId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["StartCoverInput"]: {
	riskProfileId: string,
	coverId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["StartCoverSummaryInput"]: {
	riskProfileId: string,
	coverId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["StartExposureInput"]: {
	riskProfileId: string,
	exposureId: string,
	exposureItemKey?: string | undefined,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["QuoteSummaryQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: ModelTypes["RiskProfileType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["StartQuoteSummaryInput"]: {
	riskProfileId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["StartPolicyHolderInput"]: {
	riskProfileId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["KnockoutQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: ModelTypes["RiskProfileType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["StartKnockoutsInput"]: {
	riskProfileId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["ClaimQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	claimProfile: ModelTypes["ClaimProfileType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["StartClaimInput"]: {
	policyId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["SubmitClaimInput"]: {
	claimProfileId: string
};
	["AnswerEnquiryInput"]: {
	questionFlowId: string,
	answers?: ModelTypes["JSONString"] | undefined,
	skipNext?: boolean | undefined
};
	["RiskProfileInput"]: {
	riskProfileId: string,
	enabledProducts?: Array<string | undefined> | undefined
};
	["UpdateRiskCoverInput"]: {
	riskProfileId: string,
	coverId: string,
	enabled?: boolean | undefined,
	answers?: ModelTypes["JSONString"] | undefined
};
	["UpdateRiskExposureInput"]: {
	riskProfileId: string,
	exposureId: string,
	exposureItemKey: string,
	enabled?: boolean | undefined,
	answers?: ModelTypes["JSONString"] | undefined
};
	["UpdatePolicyInput"]: {
	policyId: string,
	autoRenewEnabled?: boolean | undefined
};
	["BindQuotesInput"]: {
	riskProfileId: string
};
	/** Generates multiple documents.

If 'quote_id' or 'policy_id' is provided, this will generate all documents
associated with the 'quote' or 'bind' events depending on which was provided. */
["GenerateDocuments"]: {
		documents?: Array<ModelTypes["GeneratedDocumentType"] | undefined> | undefined
};
	/** Generates a single document for the given 'type'.

'quote_id' or 'policy_id' is required to link the generated document to and find
the relevant product. */
["GenerateDocument"]: {
		document?: ModelTypes["GeneratedDocumentType"] | undefined
};
	["UpdateQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined,
	riskProfile?: ModelTypes["RiskProfileType"] | undefined
};
	["StartPolicyUpdateInput"]: {
	policyId: string,
	flow?: string | undefined,
	questionSetKey?: string | undefined,
	create?: boolean | undefined,
	restart?: boolean | undefined,
	coverId?: string | undefined,
	autoQuote?: boolean | undefined
};
	["ConfirmPolicyUpdateInput"]: {
	policyId: string,
	startDate: ModelTypes["Date"],
	autoRenewEnabled?: boolean | undefined
};
	["PolicyUpdateSummaryChangesType"]: {
		proRataAmount?: number | undefined,
	oldPeriodicPrice?: number | undefined,
	newPeriodicPrice?: number | undefined,
	surcharge?: number | undefined,
	amountDue?: number | undefined,
	oldPaymentFrequency?: string | undefined,
	newPaymentFrequency?: string | undefined,
	newStartDate?: string | undefined,
	newFinishDate?: string | undefined,
	summary?: Array<string | undefined> | undefined
};
	["PolicyUpdateSummaryInput"]: {
	policyId: string
};
	["PolicyCancellationSummaryInput"]: {
	policyId: string
};
	["ConfirmPolicyCancellationInput"]: {
	policyId: string,
	policyCancellationQuoteId: string
};
	["PolicyRenewalSummaryChangesType"]: {
		proRataAmount?: number | undefined,
	oldPeriodicPrice?: number | undefined,
	newPeriodicPrice?: number | undefined,
	surcharge?: number | undefined,
	amountDue?: number | undefined,
	oldPaymentFrequency?: string | undefined,
	newPaymentFrequency?: string | undefined,
	newStartDate?: string | undefined,
	newFinishDate?: string | undefined,
	summary?: Array<string | undefined> | undefined
};
	["PolicyRenewalSummaryInput"]: {
	policyId: string
};
	["ToggleEnabledProductsInput"]: {
	riskProfileId: string,
	productKey: string,
	enabled?: boolean | undefined,
	answers?: ModelTypes["JSONString"] | undefined
};
	["CreateRenewalQuoteInput"]: {
	policyId: string
};
	["LegalQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: ModelTypes["RiskProfileType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["PolicyDetailsQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: ModelTypes["RiskProfileType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["ClaimProductQuestionFlowType"]: {
		id: string,
	started: ModelTypes["DateTime"],
	finished?: ModelTypes["DateTime"] | undefined,
	currentEnquiry?: ModelTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	claimProfile: ModelTypes["ClaimProfileType"],
	history?: Array<ModelTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<ModelTypes["MessageType"] | undefined> | undefined
};
	["schema"]: {
	query?: ModelTypes["Query"] | undefined,
	mutation?: ModelTypes["Mutation"] | undefined
}
    }

export type GraphQLTypes = {
    ["Query"]: {
	__typename: "Query",
	/** Stripe configuration */
	stripeConfig?: GraphQLTypes["StripeConfigType"] | undefined,
	/** Payment breakdown into premium, surcharge and total */
	paymentBreakdown?: GraphQLTypes["PaymentBreakdownType"] | undefined,
	admin?: GraphQLTypes["AdminType"] | undefined,
	/** Return details for an Organization. */
	organization?: GraphQLTypes["OrganizationType"] | undefined,
	/** Return details for an SSO Configuration. */
	ssoConfiguration?: GraphQLTypes["SsoConfigurationType"] | undefined,
	/** List all generated documents of a given document type. */
	documents?: Array<GraphQLTypes["GeneratedDocumentType"] | undefined> | undefined,
	/** Download a given generated document. */
	download?: GraphQLTypes["DownloadDocumentType"] | undefined,
	/** Download an uploaded file. */
	downloadFile?: GraphQLTypes["DownloadFileType"] | undefined,
	allAnzsicCodeDivisions?: Array<GraphQLTypes["AnzsicCodeDivisionType"] | undefined> | undefined,
	allQuestionSets?: Array<GraphQLTypes["QuestionSetType"] | undefined> | undefined,
	allQuestions?: Array<GraphQLTypes["QuestionType"] | undefined> | undefined,
	/** Return all details for a given Claim. */
	claim?: GraphQLTypes["ClaimType"] | undefined,
	/** Return all details for a given Claim Profile. */
	claimProfile?: GraphQLTypes["ClaimProfileType"] | undefined,
	/** Return all or part of a Claim Profile's state. */
	claimState?: GraphQLTypes["ClaimStateType"] | undefined,
	/** Return all details for a given Risk Profile. */
	riskProfile?: GraphQLTypes["RiskProfileType"] | undefined,
	/** Return all details for a given Policy. */
	policy?: GraphQLTypes["PolicyType"] | undefined,
	/** List all policies, optionally filtered by active/inactive status. */
	policies?: Array<GraphQLTypes["PolicyType"] | undefined> | undefined,
	/** Return the active policy if there is one. */
	activePolicy?: GraphQLTypes["PolicyType"] | undefined,
	/** Return a list of available covers for a given Risk Profile. */
	availableCovers?: Array<GraphQLTypes["CoverType"] | undefined> | undefined,
	/** Return all or part of a Risk Profile risk state. */
	riskState?: GraphQLTypes["RiskStateType"] | undefined,
	/** List cover limitations (inclusions and exclusions) for the given Risk Profile. */
	coverLimitations?: Array<GraphQLTypes["CoverLimitationType"] | undefined> | undefined,
	/** Return any draft policy update quotes. */
	policyUpdateQuote?: GraphQLTypes["PolicyUpdateQuoteType"] | undefined,
	policyUpdate?: GraphQLTypes["PolicyUpdateQuoteType"] | undefined,
	/** Returns a policy cancellation quote (if any) given a Policy ID. */
	policyCancellationQuote?: GraphQLTypes["PolicyCancellationQuoteType"] | undefined,
	/** Returns a Policy Renewal Quote given a Policy ID */
	policyRenewalQuote?: GraphQLTypes["PolicyRenewalQuoteType"] | undefined,
	/** Theme definition */
	loadTheme?: GraphQLTypes["ThemeType"] | undefined,
	/** Generate context for Cybersource card tokenization */
	cybersourceGenerateContext?: GraphQLTypes["CybersourceContextType"] | undefined,
	/** List all claims, optionally filtered by claim status type (open/closed). */
	claims?: Array<GraphQLTypes["ClaimType"] | undefined> | undefined,
	/** Validate an address with external services */
	validateAddressBz?: GraphQLTypes["ValidateAddressBzType"] | undefined,
	/** Search an address with external services */
	searchAddressBz?: GraphQLTypes["SearchAddressBzType"] | undefined,
	paymentMethod?: GraphQLTypes["PaymentMethodType"] | undefined,
	claimsAllowed?: boolean | undefined,
	riskProfilePaymentAllowed?: boolean | undefined
};
	["StripeConfigType"]: {
	__typename: "StripeConfigType",
	account?: string | undefined
};
	["PaymentBreakdownType"]: {
	__typename: "PaymentBreakdownType",
	premium: number,
	surcharge?: number | undefined,
	total: number
};
	["AdminType"]: {
	__typename: "AdminType",
	customers?: GraphQLTypes["CustomersType"] | undefined,
	customer?: GraphQLTypes["CustomerDetailType"] | undefined,
	policies?: GraphQLTypes["PoliciesType"] | undefined,
	policy?: GraphQLTypes["PolicyType"] | undefined,
	quotes?: GraphQLTypes["QuotesType"] | undefined,
	quote?: GraphQLTypes["QuoteDetailType"] | undefined,
	claims?: GraphQLTypes["ClaimsType"] | undefined,
	claim?: GraphQLTypes["ClaimDetailType"] | undefined,
	products?: Array<GraphQLTypes["ProductType"] | undefined> | undefined,
	distributionPartners?: Array<GraphQLTypes["DistributionPartnerType"] | undefined> | undefined,
	reports?: GraphQLTypes["ReportsType"] | undefined,
	report?: GraphQLTypes["ReportType"] | undefined,
	claimsAllowed?: boolean | undefined,
	/** Returns all data analytics */
	dataAnalytics?: GraphQLTypes["DataAnalyticsType"] | undefined
};
	["CustomersType"]: {
	__typename: "CustomersType",
	totalItemCount?: number | undefined,
	page?: number | undefined,
	pageSize?: GraphQLTypes["PageSize"] | undefined,
	pageCount?: number | undefined,
	hasNext?: boolean | undefined,
	hasPrev?: boolean | undefined,
	items?: Array<GraphQLTypes["UserType"] | undefined> | undefined
};
	/** Set default page sizes for pagination. */
["PageSize"]: "scalar" & { name: "PageSize" };
	["UserType"]: {
	__typename: "UserType",
	id: string,
	firstName: string,
	lastName: string,
	isStaff?: boolean | undefined,
	isActive?: boolean | undefined,
	dateJoined: GraphQLTypes["DateTime"],
	email?: string | undefined,
	uuid: GraphQLTypes["UUID"],
	/** For lazy users only. Once a user has registered, the `email` address field is the one we care about. */
	contactEmail?: string | undefined,
	contactNumber?: string | undefined,
	organization?: GraphQLTypes["OrganizationType"] | undefined,
	isSsoEnabled?: boolean | undefined,
	isLazy?: boolean | undefined,
	isPasswordLess?: boolean | undefined,
	allowCustomerPortalAccess?: boolean | undefined,
	isHijacked?: boolean | undefined,
	latestReferrer?: GraphQLTypes["DistributionPartnerType"] | undefined,
	allowAdminPortalAccess?: boolean | undefined,
	fullName?: string | undefined,
	allowUpdatePaymentMethod?: boolean | undefined
};
	/** The `DateTime` scalar type represents a DateTime
value as specified by
[iso8601](https://en.wikipedia.org/wiki/ISO_8601). */
["DateTime"]: "scalar" & { name: "DateTime" };
	/** Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
in fields, resolvers and input. */
["UUID"]: "scalar" & { name: "UUID" };
	["OrganizationType"]: {
	__typename: "OrganizationType",
	/** The name of the organization */
	name: string,
	key: string,
	/** The operating hours for this Organization. Will be displayed within any contact us sections. */
	operatingHours?: string | undefined,
	/** The customer facing email address to get in touch with this Organization. Will be displayed within any contact us sections. */
	emailAddress?: string | undefined,
	/** The website for this Organization. Will be displayed within any contact us sections. */
	website?: string | undefined,
	/** The disclaimer will be shown in the footer of any customer facing page. Supports basic HTML. */
	disclaimer?: string | undefined,
	disclaimerLinks?: Array<GraphQLTypes["DisclaimerLinksType"] | undefined> | undefined,
	phoneDisplay?: string | undefined
};
	["DisclaimerLinksType"]: {
	__typename: "DisclaimerLinksType",
	name?: string | undefined,
	url?: string | undefined
};
	["DistributionPartnerType"]: {
	__typename: "DistributionPartnerType",
	name: string,
	/** Will be used to identify the Distribution Partner when loading a product directly via URL (i.e. `/getquote?product=[product.key]&distributionPartner=[key]`) */
	key: string,
	/** If True, allow users coming from this distribution partner to set their password and access the customer portal. If False, they remain password-less users and can't access the customer portal. */
	allowCustomerPortalAccess: boolean
};
	["CustomerDetailType"]: {
	__typename: "CustomerDetailType",
	details?: GraphQLTypes["UserType"] | undefined,
	quotes?: Array<GraphQLTypes["QuoteType"] | undefined> | undefined,
	policies?: Array<GraphQLTypes["PolicyType"] | undefined> | undefined,
	claims?: Array<GraphQLTypes["ClaimType"] | undefined> | undefined,
	payments?: Array<GraphQLTypes["TransactionType"] | undefined> | undefined
};
	["QuoteType"]: {
	__typename: "QuoteType",
	id: string,
	riskProfile: GraphQLTypes["RiskProfileType"],
	currentRiskData?: GraphQLTypes["JSONString"] | undefined,
	product: GraphQLTypes["ProductType"],
	covers: Array<GraphQLTypes["CoverType"]>,
	exposures: Array<GraphQLTypes["ExposureType"]>,
	limitations: Array<GraphQLTypes["CoverLimitationType"]>,
	state: GraphQLTypes["QuoteState"],
	referralState?: GraphQLTypes["QuoteReferralState"] | undefined,
	createdTimestamp: GraphQLTypes["DateTime"],
	quotedTimestamp: GraphQLTypes["DateTime"],
	updatedTimestamp: GraphQLTypes["DateTime"],
	startDate?: GraphQLTypes["Date"] | undefined,
	finishDate?: GraphQLTypes["Date"] | undefined,
	expirationDate?: GraphQLTypes["DateTime"] | undefined,
	preTaxPremium?: number | undefined,
	postTaxPremium?: number | undefined,
	unadjustedPostTaxPremium?: number | undefined,
	commission?: number | undefined,
	amountDue?: number | undefined,
	paymentFrequency?: GraphQLTypes["QuotePaymentFrequency"] | undefined,
	/** Other pricing-related figures */
	pricingOthers?: GraphQLTypes["JSONString"] | undefined,
	/** Quote messages */
	messages?: GraphQLTypes["JSONString"] | undefined,
	privateMessages?: GraphQLTypes["JSONString"] | undefined,
	installments: Array<GraphQLTypes["InstallmentType"]>,
	policyPeriod?: GraphQLTypes["PolicyPeriodType"] | undefined,
	policyUpdates: Array<GraphQLTypes["PolicyUpdateQuoteType"]>,
	policyRenewals: Array<GraphQLTypes["PolicyRenewalQuoteType"]>,
	purchaseTransactions: Array<GraphQLTypes["TransactionType"]>,
	updateTransactions: Array<GraphQLTypes["TransactionType"]>,
	periodicPrice?: number | undefined,
	userReference?: string | undefined,
	documents?: Array<GraphQLTypes["GeneratedDocumentType"] | undefined> | undefined,
	stateDisplay?: string | undefined,
	fees?: GraphQLTypes["FeeSummaryType"] | undefined,
	referralStateDisplay?: string | undefined,
	referredQuestionSetKeys?: Array<string | undefined> | undefined,
	isBound?: boolean | undefined,
	daysToExpiry?: number | undefined
};
	["RiskProfileType"]: {
	__typename: "RiskProfileType",
	id: string,
	owner: GraphQLTypes["UserType"],
	riskData: GraphQLTypes["JSONString"],
	quotes: Array<GraphQLTypes["QuoteType"]>,
	/** The original risk profile created in the Multi-Product flow */
	asParentInBundledRiskProfiles: Array<GraphQLTypes["BundledRiskProfileType"]>,
	paymentFrequency?: GraphQLTypes["QuotePaymentFrequency"] | undefined,
	periodicPrice?: number | undefined,
	availableProducts?: Array<GraphQLTypes["ProductType"] | undefined> | undefined,
	enabledProducts?: Array<GraphQLTypes["ProductType"] | undefined> | undefined,
	referredProducts?: Array<GraphQLTypes["ProductType"] | undefined> | undefined,
	knockoutProducts?: Array<GraphQLTypes["ProductType"] | undefined> | undefined,
	enabledCovers?: Array<GraphQLTypes["CoverType"] | undefined> | undefined,
	enabledExposures?: GraphQLTypes["GenericScalar"] | undefined,
	enabledLimitations?: Array<GraphQLTypes["CoverLimitationType"] | undefined> | undefined,
	state?: string | undefined,
	quoteDocumentGenerateStatus?: string | undefined,
	policyDocumentGenerateStatus?: string | undefined,
	policyPeriods?: Array<GraphQLTypes["PolicyPeriodType"] | undefined> | undefined,
	data?: GraphQLTypes["JSONString"] | undefined,
	startDate?: string | undefined,
	finishDate?: string | undefined,
	riskStateQuestionSets?: Array<GraphQLTypes["QuestionSetType"] | undefined> | undefined
};
	/** Allows use of a JSON String for input / output from the GraphQL schema.

Use of this type is *not recommended* as you lose the benefits of having a defined, static
schema (one of the key benefits of GraphQL). */
["JSONString"]: "scalar" & { name: "JSONString" };
	["BundledRiskProfileType"]: {
	__typename: "BundledRiskProfileType",
	id: string,
	/** Used to link a risk profile to a bundle in a Multi-Product flow */
	riskProfiles: Array<GraphQLTypes["RiskProfileType"]>
};
	/** An enumeration. */
["QuotePaymentFrequency"]: QuotePaymentFrequency;
	["ProductType"]: {
	__typename: "ProductType",
	id: string,
	provider?: GraphQLTypes["ProviderType"] | undefined,
	key: string,
	description?: string | undefined,
	covers: Array<GraphQLTypes["CoverType"]>,
	exposures: Array<GraphQLTypes["ExposureType"]>,
	policyCancellationQuotes: Array<GraphQLTypes["PolicyCancellationQuoteType"]>,
	name?: string | undefined,
	autoRenewAllowed?: boolean | undefined,
	renewalPeriod?: number | undefined,
	updateAllowed?: boolean | undefined,
	cancellationAllowed?: boolean | undefined,
	cancellationCoolingOffPeriod?: number | undefined,
	claimsAllowed?: boolean | undefined,
	paymentGateway?: GraphQLTypes["PaymentGateway"] | undefined,
	skipPayments?: boolean | undefined,
	autoQuote?: boolean | undefined,
	quoteDisclaimer?: string | undefined,
	availableCovers?: Array<GraphQLTypes["CoverType"] | undefined> | undefined
};
	["ProviderType"]: {
	__typename: "ProviderType",
	name: string,
	key: string,
	logo?: string | undefined
};
	["CoverType"]: {
	__typename: "CoverType",
	id: string,
	product: GraphQLTypes["ProductType"],
	parentCover?: GraphQLTypes["CoverType"] | undefined,
	/** Whether this cover is enabled by default on an exposure. */
	isDefault: boolean,
	exposure?: GraphQLTypes["ExposureType"] | undefined,
	key: string,
	title: string,
	description?: string | undefined,
	icon?: string | undefined,
	subCovers: Array<GraphQLTypes["CoverType"]>,
	details: Array<GraphQLTypes["CoverLimitationType"]>,
	coverQuestionSets: Array<GraphQLTypes["CoverQuestionSetType"]>,
	coverquestionflowSet: Array<GraphQLTypes["CoverQuestionFlowType"]>,
	coversummaryquestionflowSet: Array<GraphQLTypes["CoverSummaryQuestionFlowType"]>,
	claimcoverquestionflowSet: Array<GraphQLTypes["ClaimCoverQuestionFlowType"]>,
	editable?: boolean | undefined
};
	["ExposureType"]: {
	__typename: "ExposureType",
	id: string,
	/** An identifier for the exposure. */
	key: string,
	/** A category for the exposure. E.g. car, property, person, etc. */
	type: string,
	/** Human readable text for display purposes. */
	name: string,
	product: GraphQLTypes["ProductType"],
	/** The maximum number of exposures allowed for this key for this product. */
	limit: number,
	/** The path in the risk data to a value used to identify the exposure. */
	userReferencePath?: string | undefined,
	icon?: string | undefined,
	covers: Array<GraphQLTypes["CoverType"]>,
	exposureQuestionSets: Array<GraphQLTypes["ExposureQuestionSetType"]>,
	exposurequestionflowSet: Array<GraphQLTypes["ExposureQuestionFlowType"]>
};
	["ExposureQuestionSetType"]: {
	__typename: "ExposureQuestionSetType",
	id: string,
	exposure: GraphQLTypes["ExposureType"],
	questionSet: GraphQLTypes["QuestionSetType"],
	/** The key of the exposure item in the risk data that this question set is related to. Not to be confused with the db model attribute Exposure.key. */
	exposureItemKey: string
};
	["QuestionSetType"]: {
	__typename: "QuestionSetType",
	id: string,
	/** Will be used as the URL slug. */
	key: string,
	/** A small headline for this question set. */
	title?: string | undefined,
	/** Main headline for this question set. */
	description?: string | undefined,
	/** An optional label to help group the questions under this question set. */
	label?: string | undefined,
	/** Optional help text displayed below the description. Callouts may be used instead for better display options. */
	help?: string | undefined,
	/** Questions may be skipped (i.e. not delivered to a user) if they have a single default value. In all other cases, they will be shown. */
	skippable: boolean,
	/** Optional list of serialized `Validator` classes to execute upon answer of this question set. These validators will be have access/context of all questions within the question set (as opposed to question validators which don't). */
	validators?: GraphQLTypes["JSONString"] | undefined,
	/** The order this question set will be delivered in relation to other question sets. */
	order: number,
	questions: Array<GraphQLTypes["QuestionType"]>,
	/** For nested forms. Only used for `input_type` with `form` or `form-list` values. */
	parentQuestions: Array<GraphQLTypes["QuestionType"]>,
	rhetoricals: Array<GraphQLTypes["RhetoricalType"]>,
	enquiries: Array<GraphQLTypes["EnquiryType"]>,
	coverQuestionSets: Array<GraphQLTypes["CoverQuestionSetType"]>,
	exposureQuestionSets: Array<GraphQLTypes["ExposureQuestionSetType"]>
};
	["QuestionType"]: {
	__typename: "QuestionType",
	id: string,
	questionSet: GraphQLTypes["QuestionSetType"],
	/** The input field label. */
	label?: string | undefined,
	/** The summary display label, falls back to the `label` if not set. */
	displayLabel?: string | undefined,
	/** Used to optionally display a more prominent title for a question. (Usually used in combination with `{"show_label": False}` on `input_args`) */
	title?: string | undefined,
	/** An optional caption for the input field, displayed underneath it. */
	help?: string | undefined,
	/** The type of input field for this question. See `inputRegistry` and `displayRegistry` for possible values. */
	inputType: string,
	/** Special arguments to be passed (as props) to the chosen `input_type`, that allows customizing its behavour. Check the chosen `input_type` component (or other similar questions) for possible values for each input type. */
	inputArgs?: GraphQLTypes["JSONString"] | undefined,
	/** For nested forms. Only used for `input_type` with `form` or `form-list` values. */
	inputForm?: GraphQLTypes["QuestionSetType"] | undefined,
	/** The path to where the answer from the user will be stored. */
	storagePath: string,
	/** Default value (if any). */
	default?: GraphQLTypes["JSONString"] | undefined,
	/** Optional list of serialized `Validator` classes to execute upon answer of this question. */
	validators?: GraphQLTypes["JSONString"] | undefined,
	/** The order this question will be delivered in relation to other questions. */
	order: number,
	/** Metadata for this question. */
	metadata?: GraphQLTypes["JSONString"] | undefined,
	answers: Array<GraphQLTypes["AnswerType"]>,
	rhetoricals: Array<GraphQLTypes["RhetoricalType"]>
};
	["AnswerType"]: {
	__typename: "AnswerType",
	id: string,
	question: GraphQLTypes["QuestionType"],
	value?: GraphQLTypes["JSONString"] | undefined,
	source?: GraphQLTypes["DataProviderType"] | undefined
};
	["DataProviderType"]: {
	__typename: "DataProviderType",
	id: string,
	name: string
};
	["RhetoricalType"]: {
	__typename: "RhetoricalType",
	id: string,
	/** An internal reference name to help identify this object. Needs to be unique for each release and question/question set. */
	name: string,
	questionSet?: GraphQLTypes["QuestionSetType"] | undefined,
	question?: GraphQLTypes["QuestionType"] | undefined,
	kind: GraphQLTypes["RhetoricalKind"],
	/** Special arguments to be passed (as props) to the chosen `kind`, that allows customizing its behavour. Check the chosen `kind` component (or other similar rhetoricals) for possible values for each kind. */
	args?: GraphQLTypes["JSONString"] | undefined,
	/** The order this object will be delivered in relation to other objects from this question or question set. */
	order: number
};
	/** An enumeration. */
["RhetoricalKind"]: RhetoricalKind;
	["EnquiryType"]: {
	__typename: "EnquiryType",
	id: string,
	user?: GraphQLTypes["UserType"] | undefined,
	questionFlow?: GraphQLTypes["QuestionFlowType"] | undefined,
	questionSet: GraphQLTypes["QuestionSetType"],
	timestamp: GraphQLTypes["DateTime"]
};
	["QuestionFlowType"]: {
	__typename:"ExposureQuestionFlowType" | "CoverQuestionFlowType" | "CoverSummaryQuestionFlowType" | "ClaimCoverQuestionFlowType" | "QuoteQuestionFlowType" | "PolicyHolderQuestionFlowType" | "AdjustmentQuestionFlowType" | "CancellationQuestionFlowType" | "QuoteSummaryQuestionFlowType" | "KnockoutQuestionFlowType" | "ClaimQuestionFlowType" | "UpdateQuestionFlowType" | "LegalQuestionFlowType" | "PolicyDetailsQuestionFlowType" | "ClaimProductQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
	['...on ExposureQuestionFlowType']: '__union' & GraphQLTypes["ExposureQuestionFlowType"];
	['...on CoverQuestionFlowType']: '__union' & GraphQLTypes["CoverQuestionFlowType"];
	['...on CoverSummaryQuestionFlowType']: '__union' & GraphQLTypes["CoverSummaryQuestionFlowType"];
	['...on ClaimCoverQuestionFlowType']: '__union' & GraphQLTypes["ClaimCoverQuestionFlowType"];
	['...on QuoteQuestionFlowType']: '__union' & GraphQLTypes["QuoteQuestionFlowType"];
	['...on PolicyHolderQuestionFlowType']: '__union' & GraphQLTypes["PolicyHolderQuestionFlowType"];
	['...on AdjustmentQuestionFlowType']: '__union' & GraphQLTypes["AdjustmentQuestionFlowType"];
	['...on CancellationQuestionFlowType']: '__union' & GraphQLTypes["CancellationQuestionFlowType"];
	['...on QuoteSummaryQuestionFlowType']: '__union' & GraphQLTypes["QuoteSummaryQuestionFlowType"];
	['...on KnockoutQuestionFlowType']: '__union' & GraphQLTypes["KnockoutQuestionFlowType"];
	['...on ClaimQuestionFlowType']: '__union' & GraphQLTypes["ClaimQuestionFlowType"];
	['...on UpdateQuestionFlowType']: '__union' & GraphQLTypes["UpdateQuestionFlowType"];
	['...on LegalQuestionFlowType']: '__union' & GraphQLTypes["LegalQuestionFlowType"];
	['...on PolicyDetailsQuestionFlowType']: '__union' & GraphQLTypes["PolicyDetailsQuestionFlowType"];
	['...on ClaimProductQuestionFlowType']: '__union' & GraphQLTypes["ClaimProductQuestionFlowType"];
};
	["MessageType"]: {
	__typename: "MessageType",
	id: string,
	kind: GraphQLTypes["MessageKind"],
	content: string
};
	/** An enumeration. */
["MessageKind"]: MessageKind;
	["CoverQuestionSetType"]: {
	__typename: "CoverQuestionSetType",
	id: string,
	cover: GraphQLTypes["CoverType"],
	questionSet: GraphQLTypes["QuestionSetType"]
};
	["ExposureQuestionFlowType"]: {
	__typename: "ExposureQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: GraphQLTypes["RiskProfileType"],
	exposure: GraphQLTypes["ExposureType"],
	exposureItemKey: string,
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["CoverLimitationType"]: {
	__typename: "CoverLimitationType",
	id: string,
	cover: GraphQLTypes["CoverType"],
	key: string,
	kind: GraphQLTypes["CoverLimitationKind"],
	text: string,
	description: string,
	order: number,
	overrides: Array<GraphQLTypes["CoverLimitationType"]>,
	/** Default limitations are enabled by default, while extra limitations are enabled by the underwriter during the adjust referral quote process. */
	level: GraphQLTypes["CoverLimitationLevel"],
	overriddenBy: Array<GraphQLTypes["CoverLimitationType"]>
};
	/** An enumeration. */
["CoverLimitationKind"]: CoverLimitationKind;
	/** An enumeration. */
["CoverLimitationLevel"]: CoverLimitationLevel;
	["CoverQuestionFlowType"]: {
	__typename: "CoverQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: GraphQLTypes["RiskProfileType"],
	cover: GraphQLTypes["CoverType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["CoverSummaryQuestionFlowType"]: {
	__typename: "CoverSummaryQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: GraphQLTypes["RiskProfileType"],
	cover: GraphQLTypes["CoverType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["ClaimCoverQuestionFlowType"]: {
	__typename: "ClaimCoverQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	claimProfile: GraphQLTypes["ClaimProfileType"],
	cover: GraphQLTypes["CoverType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["ClaimProfileType"]: {
	__typename: "ClaimProfileType",
	id: string,
	owner: GraphQLTypes["UserType"],
	claim?: GraphQLTypes["ClaimType"] | undefined,
	policyPeriods?: Array<GraphQLTypes["PolicyPeriodType"] | undefined> | undefined,
	products?: Array<GraphQLTypes["ProductType"] | undefined> | undefined,
	covers?: Array<GraphQLTypes["CoverType"] | undefined> | undefined,
	claimStateQuestionSets?: Array<GraphQLTypes["QuestionSetType"] | undefined> | undefined,
	data?: GraphQLTypes["JSONString"] | undefined
};
	["ClaimType"]: {
	__typename: "ClaimType",
	id: string,
	created: GraphQLTypes["DateTime"],
	policyPeriods: Array<GraphQLTypes["PolicyPeriodType"]>,
	claimNumber: string,
	claimProfile?: GraphQLTypes["ClaimProfileType"] | undefined,
	status?: GraphQLTypes["ClaimStatusChoices"] | undefined,
	policyNumber?: string | undefined,
	statusType?: GraphQLTypes["ClaimStatusTypes"] | undefined,
	statusTypeDisplay?: string | undefined,
	decision?: string | undefined,
	closedDate?: string | undefined
};
	["PolicyPeriodType"]: {
	__typename: "PolicyPeriodType",
	id: string,
	policy: GraphQLTypes["PolicyType"],
	quote: GraphQLTypes["QuoteType"],
	boundTimestamp: GraphQLTypes["DateTime"],
	startDate: GraphQLTypes["Date"],
	finishDate: GraphQLTypes["Date"],
	periodNumber: number,
	kind: GraphQLTypes["PolicyPeriodKind"],
	/** Policy Period in effect at the moment of creating this renewal quote. */
	renewalQuotes: Array<GraphQLTypes["PolicyRenewalQuoteType"]>,
	claims: Array<GraphQLTypes["ClaimType"]>,
	transactions: Array<GraphQLTypes["TransactionType"]>,
	policyNumber?: string | undefined,
	documents?: Array<GraphQLTypes["GeneratedDocumentType"] | undefined> | undefined,
	latestTransaction?: GraphQLTypes["TransactionType"] | undefined
};
	["PolicyType"]: {
	__typename: "PolicyType",
	id: string,
	policyNumber?: string | undefined,
	uuid: GraphQLTypes["UUID"],
	autoRenewEnabled: boolean,
	currentPeriod?: GraphQLTypes["PolicyPeriodType"] | undefined,
	status: GraphQLTypes["PolicyStatus"],
	periods: Array<GraphQLTypes["PolicyPeriodType"]>,
	updateQuotes: Array<GraphQLTypes["PolicyUpdateQuoteType"]>,
	cancellationQuotes: Array<GraphQLTypes["PolicyCancellationQuoteType"]>,
	renewalQuotes: Array<GraphQLTypes["PolicyRenewalQuoteType"]>,
	transactions?: Array<GraphQLTypes["TransactionType"] | undefined> | undefined,
	documents?: Array<GraphQLTypes["GeneratedDocumentType"] | undefined> | undefined,
	statusDisplay?: string | undefined,
	riskProfile?: GraphQLTypes["RiskProfileType"] | undefined,
	startDate?: string | undefined,
	finishDate?: string | undefined,
	quote?: GraphQLTypes["QuoteType"] | undefined,
	policyUpdate?: GraphQLTypes["PolicyUpdateQuoteType"] | undefined,
	latestUpdate?: GraphQLTypes["PolicyUpdateQuoteType"] | undefined,
	draftUpdate?: GraphQLTypes["QuoteType"] | undefined,
	policyCancellationQuote?: GraphQLTypes["PolicyCancellationQuoteType"] | undefined,
	updateAllowed?: boolean | undefined,
	cancellationAllowed?: boolean | undefined,
	claimsAllowed?: boolean | undefined,
	latestRenewal?: GraphQLTypes["PolicyRenewalQuoteType"] | undefined,
	latestCancellation?: GraphQLTypes["PolicyCancellationQuoteType"] | undefined,
	isWithinRenewalPeriod?: boolean | undefined,
	isPendingCancellation?: boolean | undefined,
	policyPeriods?: Array<GraphQLTypes["PolicyPeriodType"] | undefined> | undefined
};
	/** An enumeration. */
["PolicyStatus"]: PolicyStatus;
	["PolicyUpdateQuoteType"]: {
	__typename: "PolicyUpdateQuoteType",
	id: string,
	created: GraphQLTypes["DateTime"],
	modified: GraphQLTypes["DateTime"],
	policy: GraphQLTypes["PolicyType"],
	quote: GraphQLTypes["QuoteType"],
	/** Pro-rata amount balance to charge or refund. */
	proRataAmountDue: number
};
	["PolicyCancellationQuoteType"]: {
	__typename: "PolicyCancellationQuoteType",
	id: string,
	policy: GraphQLTypes["PolicyType"],
	state: GraphQLTypes["PolicyCancellationQuoteState"],
	effectiveDate?: GraphQLTypes["Date"] | undefined,
	amountDue?: number | undefined,
	fees?: GraphQLTypes["FeeSummaryType"] | undefined,
	data?: GraphQLTypes["JSONString"] | undefined
};
	/** An enumeration. */
["PolicyCancellationQuoteState"]: PolicyCancellationQuoteState;
	/** The `Date` scalar type represents a Date
value as specified by
[iso8601](https://en.wikipedia.org/wiki/ISO_8601). */
["Date"]: "scalar" & { name: "Date" };
	["FeeSummaryType"]: {
	__typename: "FeeSummaryType",
	breakdown?: Array<GraphQLTypes["FeeType"] | undefined> | undefined,
	taxes?: number | undefined,
	fees?: number | undefined,
	stampDuty?: number | undefined
};
	["FeeType"]: {
	__typename: "FeeType",
	kind?: string | undefined,
	amount?: number | undefined,
	feeType?: GraphQLTypes["FeeTypeType"] | undefined
};
	["FeeTypeType"]: {
	__typename: "FeeTypeType",
	key: string,
	label: string,
	kind: GraphQLTypes["FeeTypeKind"]
};
	/** An enumeration. */
["FeeTypeKind"]: FeeTypeKind;
	["PolicyRenewalQuoteType"]: {
	__typename: "PolicyRenewalQuoteType",
	id: string,
	policy: GraphQLTypes["PolicyType"],
	/** Policy Period in effect at the moment of creating this renewal quote. */
	policyPeriod: GraphQLTypes["PolicyPeriodType"],
	quote: GraphQLTypes["QuoteType"],
	submittedTimestamp: GraphQLTypes["DateTime"],
	canDiscard?: boolean | undefined,
	canAccept?: boolean | undefined
};
	["TransactionType"]: {
	__typename: "TransactionType",
	id: string,
	policyPeriod?: GraphQLTypes["PolicyPeriodType"] | undefined,
	status: GraphQLTypes["TransactionStatus"],
	paymentProfile?: GraphQLTypes["PaymentProfileType"] | undefined,
	/** Unique identifier for this transaction within the payment gateway. */
	paymentGatewayTransactionReference: string,
	actionType: GraphQLTypes["TransactionActionType"],
	transactionType: GraphQLTypes["TransactionTransactionType"],
	amount: number,
	currency: GraphQLTypes["TransactionCurrency"],
	policyNumber?: string | undefined,
	statusDisplay?: string | undefined,
	transactionTypeDisplay?: string | undefined,
	actionTypeDisplay?: string | undefined,
	amountWithSurcharge?: number | undefined
};
	/** An enumeration. */
["TransactionStatus"]: TransactionStatus;
	["PaymentProfileType"]: {
	__typename: "PaymentProfileType",
	id: string,
	/** To help the customer identify this payment profile (i.e. last 4 digits of a cc). */
	customerReference: string,
	paymentGateway: GraphQLTypes["PaymentProfilePaymentGateway"]
};
	/** An enumeration. */
["PaymentProfilePaymentGateway"]: PaymentProfilePaymentGateway;
	/** An enumeration. */
["TransactionActionType"]: TransactionActionType;
	/** An enumeration. */
["TransactionTransactionType"]: TransactionTransactionType;
	/** An enumeration. */
["TransactionCurrency"]: TransactionCurrency;
	["GeneratedDocumentType"]: {
	__typename: "GeneratedDocumentType",
	id: string,
	created: GraphQLTypes["DateTime"],
	modified: GraphQLTypes["DateTime"],
	objectId?: number | undefined,
	user: GraphQLTypes["UserType"],
	file: string,
	name: string,
	type?: string | undefined,
	key?: string | undefined,
	url?: string | undefined
};
	/** An enumeration. */
["PolicyPeriodKind"]: PolicyPeriodKind;
	/** An enumeration. */
["ClaimStatusChoices"]: ClaimStatusChoices;
	/** An enumeration. */
["ClaimStatusTypes"]: ClaimStatusTypes;
	/** An enumeration. */
["ClaimStateFilterEnum"]: ClaimStateFilterEnum;
	/** An enumeration. */
["PaymentGateway"]: PaymentGateway;
	/** The `GenericScalar` scalar type represents a generic
GraphQL scalar value that could be:
String, Boolean, Int, Float, List or Object. */
["GenericScalar"]: "scalar" & { name: "GenericScalar" };
	/** An enumeration. */
["RiskStateFilterEnum"]: RiskStateFilterEnum;
	/** An enumeration. */
["QuoteState"]: QuoteState;
	/** An enumeration. */
["QuoteReferralState"]: QuoteReferralState;
	["InstallmentType"]: {
	__typename: "InstallmentType",
	id: string,
	quote?: GraphQLTypes["QuoteType"] | undefined,
	dueDate: GraphQLTypes["Date"],
	inclusivePrice: number,
	kind: GraphQLTypes["InstallmentKind"],
	fees: Array<GraphQLTypes["FeeType"]>
};
	/** An enumeration. */
["InstallmentKind"]: InstallmentKind;
	["PoliciesType"]: {
	__typename: "PoliciesType",
	totalItemCount?: number | undefined,
	page?: number | undefined,
	pageSize?: GraphQLTypes["PageSize"] | undefined,
	pageCount?: number | undefined,
	hasNext?: boolean | undefined,
	hasPrev?: boolean | undefined,
	items?: Array<GraphQLTypes["PolicyType"] | undefined> | undefined
};
	["QuotesType"]: {
	__typename: "QuotesType",
	totalItemCount?: number | undefined,
	page?: number | undefined,
	pageSize?: GraphQLTypes["PageSize"] | undefined,
	pageCount?: number | undefined,
	hasNext?: boolean | undefined,
	hasPrev?: boolean | undefined,
	items?: Array<GraphQLTypes["QuoteType"] | undefined> | undefined
};
	/** An enumeration. */
["QuoteFilterBy"]: QuoteFilterBy;
	["QuoteDetailType"]: {
	__typename: "QuoteDetailType",
	details?: GraphQLTypes["QuoteType"] | undefined,
	notes?: Array<GraphQLTypes["NoteType"] | undefined> | undefined
};
	["NoteType"]: {
	__typename: "NoteType",
	id: string,
	created: GraphQLTypes["DateTime"],
	content?: string | undefined,
	author: GraphQLTypes["UserType"]
};
	["ClaimsType"]: {
	__typename: "ClaimsType",
	totalItemCount?: number | undefined,
	page?: number | undefined,
	pageSize?: GraphQLTypes["PageSize"] | undefined,
	pageCount?: number | undefined,
	hasNext?: boolean | undefined,
	hasPrev?: boolean | undefined,
	items?: Array<GraphQLTypes["ClaimType"] | undefined> | undefined
};
	/** An enumeration. */
["ClaimFilterBy"]: ClaimFilterBy;
	["ClaimDetailType"]: {
	__typename: "ClaimDetailType",
	details?: GraphQLTypes["ClaimType"] | undefined,
	notes?: Array<GraphQLTypes["NoteType"] | undefined> | undefined
};
	["ReportsType"]: {
	__typename: "ReportsType",
	totalItemCount?: number | undefined,
	page?: number | undefined,
	pageSize?: GraphQLTypes["PageSize"] | undefined,
	pageCount?: number | undefined,
	hasNext?: boolean | undefined,
	hasPrev?: boolean | undefined,
	items?: Array<GraphQLTypes["ReportType"] | undefined> | undefined,
	reportTypes?: GraphQLTypes["GenericScalar"] | undefined
};
	["ReportType"]: {
	__typename: "ReportType",
	id: string,
	file?: string | undefined,
	/** Start date/time of report data date range. */
	startDatetime: GraphQLTypes["DateTime"],
	/** End date/time of report data date range. */
	endDatetime: GraphQLTypes["DateTime"],
	name?: string | undefined,
	generatedDate?: GraphQLTypes["DateTime"] | undefined,
	reportType?: string | undefined,
	url?: string | undefined,
	taskStatus?: string | undefined
};
	["DataAnalyticsType"]: {
	__typename: "DataAnalyticsType",
	totalQuotes?: GraphQLTypes["DataAnalyticsCardType"] | undefined,
	quotesThisMonth?: GraphQLTypes["DataAnalyticsCardType"] | undefined,
	policiesByStatus?: GraphQLTypes["DataAnalyticsCardType"] | undefined,
	policiesRenewed?: GraphQLTypes["DataAnalyticsCardType"] | undefined,
	totalActivePolicies?: GraphQLTypes["DataAnalyticsCardType"] | undefined,
	totalCustomers?: GraphQLTypes["DataAnalyticsCardType"] | undefined,
	totalClaims?: GraphQLTypes["DataAnalyticsCardType"] | undefined,
	conversionRate?: GraphQLTypes["DataAnalyticsCardType"] | undefined,
	totalGwp?: GraphQLTypes["DataAnalyticsCardType"] | undefined
};
	["DataAnalyticsCardType"]: {
	__typename: "DataAnalyticsCardType",
	title?: string | undefined,
	summaryValue?: string | undefined,
	summaryValueType?: string | undefined,
	statistics?: Array<GraphQLTypes["DataAnalyticsStatisticType"] | undefined> | undefined
};
	["DataAnalyticsStatisticType"]: {
	__typename: "DataAnalyticsStatisticType",
	label?: string | undefined,
	value?: string | undefined,
	type?: string | undefined
};
	["SsoConfigurationType"]: {
	__typename: "SsoConfigurationType",
	/** Unique identifier for this configuration within the IDP platform. This is required to authenticate authenticator as a client. */
	clientIdKey?: string | undefined,
	/** Login URL for this configuration. For the login button link use the Login initialize URL. */
	loginUrl: string,
	/** Logout URL for this configuration. */
	logoutUrl: string,
	/** Call back URL for this configuration. */
	callbackUrl?: string | undefined,
	/** Success redirect URL for this configuration. */
	successRedirectUrl?: string | undefined,
	/** Error redirect URL for this configuration. */
	errorRedirectUrl?: string | undefined,
	isClientSecretKeySet?: boolean | undefined
};
	["DownloadDocumentType"]: {
	__typename: "DownloadDocumentType",
	url?: string | undefined
};
	["DownloadFileType"]: {
	__typename: "DownloadFileType",
	url?: string | undefined
};
	["AnzsicCodeDivisionType"]: {
	__typename: "AnzsicCodeDivisionType",
	id: string,
	year: string,
	code: string,
	label: string,
	subdivisions: Array<GraphQLTypes["AnzsicCodeSubdivisionType"]>
};
	["AnzsicCodeSubdivisionType"]: {
	__typename: "AnzsicCodeSubdivisionType",
	id: string,
	division: GraphQLTypes["AnzsicCodeDivisionType"],
	year: string,
	code: string,
	label: string,
	groups: Array<GraphQLTypes["AnzsicCodeGroupType"]>
};
	["AnzsicCodeGroupType"]: {
	__typename: "AnzsicCodeGroupType",
	id: string,
	subdivision: GraphQLTypes["AnzsicCodeSubdivisionType"],
	year: string,
	code: string,
	label: string,
	classes: Array<GraphQLTypes["AnzsicCodeClassType"]>
};
	["AnzsicCodeClassType"]: {
	__typename: "AnzsicCodeClassType",
	id: string,
	group: GraphQLTypes["AnzsicCodeGroupType"],
	year: string,
	code: string,
	label: string
};
	["ClaimStateType"]: {
	__typename: "ClaimStateType",
	claimProfile?: GraphQLTypes["ClaimProfileType"] | undefined,
	questionSets?: Array<GraphQLTypes["QuestionSetType"] | undefined> | undefined
};
	["RiskStateType"]: {
	__typename: "RiskStateType",
	riskProfile?: GraphQLTypes["RiskProfileType"] | undefined,
	questionSets?: Array<GraphQLTypes["QuestionSetType"] | undefined> | undefined
};
	["ThemeType"]: {
	__typename: "ThemeType",
	logo?: GraphQLTypes["LogoType"] | undefined,
	themeOverride?: GraphQLTypes["GenericScalar"] | undefined
};
	["LogoType"]: {
	__typename: "LogoType",
	src?: string | undefined,
	altText?: string | undefined
};
	["CybersourceContextType"]: {
	__typename: "CybersourceContextType",
	context?: string | undefined
};
	["ValidateAddressBzType"]: {
	__typename: "ValidateAddressBzType",
	data?: GraphQLTypes["JSONString"] | undefined
};
	["SearchAddressBzType"]: {
	__typename: "SearchAddressBzType",
	data?: GraphQLTypes["JSONString"] | undefined
};
	["PaymentMethodType"]: {
	__typename: "PaymentMethodType",
	cardNumber?: string | undefined,
	cardType?: string | undefined,
	expiryDate?: string | undefined
};
	["Mutation"]: {
	__typename: "Mutation",
	admin?: GraphQLTypes["AdminMutation"] | undefined,
	/** Hijack user endpoint.

This endpoint triggers the django-hijack function. */
	hijackUser?: GraphQLTypes["TokenType"] | undefined,
	/** Release user endpoint.

This endpoint triggers the django-release function. */
	releaseUser?: GraphQLTypes["TokenType"] | undefined,
	/** SSO verification mutation.

This endpoint verifies user login.

authenticator_type: Authenticator for this login
token: Token to use for verification, this can be different in different IDPs
    - For SamlAuthenticator - It's the refresh token */
	ssoVerification?: GraphQLTypes["TokenType"] | undefined,
	/** SSO init mutation.

This is to initiate the SSO login process. This receives the fetch back key,
fetch back value and the authenticator type from the front end.

This fetch back value is used to identify the existing session if user is already
logged in. The fetch back key is the key for this value and the value retried from
the browser local storage by using the key. This fetch back key and the value
varies based on the IDP and for SAML authenticator, it is the `refresh_token`.

This mutation responds back with the updated authentication URL by attaching the
fetch back value and the key, if exists. Then the frontend will redirect the user
to that URL and there we check if the session is already exists or not. */
	ssoAuthenticate?: GraphQLTypes["SsoRedirectType"] | undefined,
	/** Bind quotes and complete payment for a given Risk Profile. */
	completePayment?: GraphQLTypes["CompletePaymentMutation"] | undefined,
	/** Bind quote without payment for a given Risk Profile. */
	confirmQuote?: GraphQLTypes["ConfirmQuoteMutation"] | undefined,
	/** Update payment method for a given Risk Profile. */
	updatePaymentMethod?: GraphQLTypes["UpdatePaymentMethodMutation"] | undefined,
	/** Refresh user tokens (if session based log in) or create an anonymous user session.

All entities created through the quote flow are associated with this user. */
	refreshUser?: GraphQLTypes["TokenType"] | undefined,
	/** Authenticate a given email/password combination. */
	tokenAuth?: GraphQLTypes["ObtainJSONWebToken"] | undefined,
	/** Logout a user. */
	logoutUser?: GraphQLTypes["LogoutUserMutation"] | undefined,
	/** Resets the password of a user and sends them an email.

If the user has an unusable password, this will do nothing; no error will be raised
and and no email will be sent. */
	sendPasswordResetEmail?: GraphQLTypes["SendPasswordResetEmailMutation"] | undefined,
	/** Change user password without old password.

Receive the token that was sent by email.

If token and new passwords are valid, update
user password and in case of using refresh
tokens, revoke all of them.

Also, if user has not been verified yet, verify it. */
	passwordReset?: GraphQLTypes["PasswordReset"] | undefined,
	updateAccount?: GraphQLTypes["UpdateAccount"] | undefined,
	/** Convert an existing LazyUser/PasswordLessUser into a User. */
	registerUser?: GraphQLTypes["RegisterUserMutation"] | undefined,
	/** Convert an existing LazyUser into a PasswordLessUser. */
	registerPasswordLessUser?: GraphQLTypes["RegisterPasswordLessUserMutation"] | undefined,
	/** Update keys and urls for SSO config. */
	updateSsoConfiguration?: GraphQLTypes["SsoConfigurationOutputType"] | undefined,
	/** Perform a Data Import for a new or existing user.

A risk profile is created and a one-time login link is returned. */
	dataImport?: GraphQLTypes["DataImportMutation"] | undefined,
	sortedImport?: GraphQLTypes["SortedImportMutation"] | undefined,
	/** Start and return a Quote question flow for a given Risk Profile. */
	startQuote?: GraphQLTypes["QuoteQuestionFlowType"] | undefined,
	/** Start a policy cancellation flow. */
	startCancellation?: GraphQLTypes["CancellationQuestionFlowType"] | undefined,
	/** Start and return a Cover question flow for a given Risk Profile. */
	startCover?: GraphQLTypes["CoverQuestionFlowType"] | undefined,
	/** Start and return a Cover Summary question flow for a given Risk Profile. */
	startCoverSummary?: GraphQLTypes["CoverSummaryQuestionFlowType"] | undefined,
	/** Start and return an Exposure question flow for a given Risk Profile. */
	startExposure?: GraphQLTypes["ExposureQuestionFlowType"] | undefined,
	/** Start and return a Quote Summary question flow for a given Risk Profile. */
	startQuoteSummary?: GraphQLTypes["QuoteSummaryQuestionFlowType"] | undefined,
	/** Start and return a Policy Holder question flow for a given Risk Profile. */
	startPolicyholder?: GraphQLTypes["PolicyHolderQuestionFlowType"] | undefined,
	/** Start and return a Knockouts question flow for a given Risk Profile. */
	startKnockouts?: GraphQLTypes["KnockoutQuestionFlowType"] | undefined,
	/** Start and return a Claim question flow for a given Policy. */
	startClaim?: GraphQLTypes["ClaimQuestionFlowType"] | undefined,
	/** Formally submit a Claim given a claim profile. */
	submitClaim?: Array<GraphQLTypes["ClaimType"] | undefined> | undefined,
	/** Provide an answer for a given Enquiry and return the next Question flow. */
	answerEnquiry?: GraphQLTypes["QuestionFlowType"] | undefined,
	/** Price (get a quote for) a given Risk Profile. */
	priceRiskProfile?: GraphQLTypes["RiskProfileType"] | undefined,
	/** Store changes to a cover's questions.

A cover can be enabled/disabled, and have answers to the cover's
questions stored against the risk profile.

Returns the risk profile after first recalculating quotes in
response to the new answers. */
	updateRiskCover?: GraphQLTypes["RiskProfileType"] | undefined,
	/** Store changes to an exposure item's questions.

An exposure item can be enabled/disabled, and have answers to the item's
questions stored against the risk profile.

Returns the risk profile after first recalculating quotes in
response to the new answers. */
	updateRiskExposure?: GraphQLTypes["RiskProfileType"] | undefined,
	updatePolicy?: GraphQLTypes["PolicyType"] | undefined,
	/** Bind a Quote (from a given Risk Profile) to create a Policy.

This endpoint does not process payments. */
	bindQuotes?: Array<GraphQLTypes["PolicyPeriodType"] | undefined> | undefined,
	/** Generates multiple documents.

If 'quote_id' or 'policy_id' is provided, this will generate all documents
associated with the 'quote' or 'bind' events depending on which was provided. */
	generateDocuments?: GraphQLTypes["GenerateDocuments"] | undefined,
	/** Generates a single document for the given 'type'.

'quote_id' or 'policy_id' is required to link the generated document to and find
the relevant product. */
	generateDocument?: GraphQLTypes["GenerateDocument"] | undefined,
	/** Start a policy update flow.

Create a new PolicyUpdate model (if needed), then depending on the 'flow' parameter
passed in will return the appropriate QuestionSet to be answered next by the user. */
	startPolicyUpdate?: GraphQLTypes["UpdateQuestionFlowType"] | undefined,
	/** Confirm and bind the policy update quote for a given policy. */
	confirmPolicyUpdate?: GraphQLTypes["PolicyType"] | undefined,
	/** Provides a summary of changes in the draft update quote for a policy. */
	policyUpdateSummary?: GraphQLTypes["PolicyUpdateSummaryChangesType"] | undefined,
	/** Provides a summary of a draft cancellation quote request for a given policy. */
	policyCancellationSummary?: GraphQLTypes["PolicyCancellationQuoteType"] | undefined,
	/** Finalizes cancelling a policy given a policy cancellation quote. */
	confirmPolicyCancellation?: GraphQLTypes["PolicyType"] | undefined,
	/** Provides a summary of changes in the draft renewal quote for a policy. */
	policyRenewalSummary?: GraphQLTypes["PolicyRenewalSummaryChangesType"] | undefined,
	/** Store changes to enabled products question.

A product can be enabled when starting a new quote.
This mutation allows the user to enable/disable products. */
	toggleEnabledProducts?: GraphQLTypes["RiskProfileType"] | undefined,
	/** Discard a renewal quote. */
	discardRenewalQuote?: GraphQLTypes["PolicyRenewalQuoteType"] | undefined,
	/** Create a new renewal quote. */
	createRenewalQuote?: GraphQLTypes["PolicyRenewalQuoteType"] | undefined,
	/** Accept a renewal quote. */
	acceptRenewalQuote?: GraphQLTypes["PolicyRenewalQuoteType"] | undefined
};
	["AdminMutation"]: {
	__typename: "AdminMutation",
	closeClaim?: GraphQLTypes["CloseClaimMutation"] | undefined,
	/** Create lazy user endpoint.

This endpoint will create a lazy user. */
	createLazyUser?: GraphQLTypes["UserType"] | undefined,
	/** Create note endpoint.

This endpoint will create a note. */
	createNote?: GraphQLTypes["NoteType"] | undefined,
	/** Start and return a quote question flow for a given referred quote. */
	editReferredQuote?: GraphQLTypes["QuoteQuestionFlowType"] | undefined,
	/** Start and return a Policy Holder question flow for a given Risk Profile. */
	editPolicyholder?: GraphQLTypes["PolicyHolderQuestionFlowType"] | undefined,
	/** Send quote email endpoint.

This endpoint will email a quote link to user */
	emailQuote?: GraphQLTypes["SendQuoteEmailMutation"] | undefined,
	generateReport?: GraphQLTypes["ReportType"] | undefined,
	/** Price a referred RiskProfile. */
	priceReferredRiskProfile?: GraphQLTypes["RiskProfileType"] | undefined,
	/** Start and return a adjustment question flow for a given quote. */
	startAdjustment?: GraphQLTypes["AdjustmentQuestionFlowType"] | undefined,
	/** Update a referred quote's referral state. */
	updateQuoteReferralState?: GraphQLTypes["UpdateQuoteReferralStateMutation"] | undefined,
	discardRenewalQuote?: GraphQLTypes["AdminDiscardRenewalQuoteMutation"] | undefined
};
	["CloseClaimMutation"]: {
	__typename: "CloseClaimMutation",
	success?: boolean | undefined,
	claim?: GraphQLTypes["ClaimType"] | undefined
};
	/** An enumeration. */
["ClosedStatus"]: ClosedStatus;
	["CreateLazyUserInput"]: {
		email: string,
	firstName: string,
	lastName: string
};
	/**
    Enumeration to define valid associations for a note.

    Enum Members:
    - POLICY: Association with a policy object in the 'insurance' app.
    - QUOTE: Association with a quote object in the 'insurance' app.
    - CLAIM: Association with a claim object in the 'insurance' app.
     */
["NoteAssociationLimit"]: NoteAssociationLimit;
	["QuoteQuestionFlowType"]: {
	__typename: "QuoteQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: GraphQLTypes["RiskProfileType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["EditQuoteInput"]: {
		quoteId: string
};
	["PolicyHolderQuestionFlowType"]: {
	__typename: "PolicyHolderQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: GraphQLTypes["RiskProfileType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["EditPolicyholderInput"]: {
		riskProfileId: string
};
	/** Send quote email endpoint.

This endpoint will email a quote link to user */
["SendQuoteEmailMutation"]: {
	__typename: "SendQuoteEmailMutation",
	message?: string | undefined
};
	["SendQuoteEmailInput"]: {
		quoteId: string,
	toEmail: string
};
	["GenerateReportInput"]: {
		reportType: string,
	startDate: string,
	endDate: string
};
	["AdjustmentQuestionFlowType"]: {
	__typename: "AdjustmentQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: GraphQLTypes["RiskProfileType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["StartAdjustmentInput"]: {
		riskProfileId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	/** Update a referred quote's referral state. */
["UpdateQuoteReferralStateMutation"]: {
	__typename: "UpdateQuoteReferralStateMutation",
	success?: boolean | undefined,
	quote?: GraphQLTypes["QuoteType"] | undefined,
	note?: GraphQLTypes["NoteType"] | undefined
};
	/** An enumeration. */
["ReferralState"]: ReferralState;
	["AdminDiscardRenewalQuoteMutation"]: {
	__typename: "AdminDiscardRenewalQuoteMutation",
	success?: boolean | undefined,
	renewalQuote?: GraphQLTypes["PolicyRenewalQuoteType"] | undefined
};
	["RenewalQuoteInput"]: {
		renewalQuoteId: string
};
	["TokenType"]: {
	__typename: "TokenType",
	token?: string | undefined,
	user?: GraphQLTypes["UserType"] | undefined
};
	["HijackUserInput"]: {
		userId: string
};
	["SsoRedirectType"]: {
	__typename: "SsoRedirectType",
	url?: string | undefined
};
	["CompletePaymentMutation"]: {
	__typename: "CompletePaymentMutation",
	paymentSuccess?: boolean | undefined,
	bindSuccess?: boolean | undefined,
	errorMessage?: string | undefined
};
	["CompletePaymentInput"]: {
		riskProfileId: string,
	metadata: GraphQLTypes["GenericScalar"]
};
	["ConfirmQuoteMutation"]: {
	__typename: "ConfirmQuoteMutation",
	paymentSuccess?: boolean | undefined,
	bindSuccess?: boolean | undefined,
	errorMessage?: string | undefined
};
	["UpdatePaymentMethodMutation"]: {
	__typename: "UpdatePaymentMethodMutation",
	success?: boolean | undefined,
	errorMessage?: string | undefined
};
	["UpdatePaymentMethodInput"]: {
		metadata: GraphQLTypes["GenericScalar"]
};
	["RefreshUserInput"]: {
		distributionPartner?: string | undefined
};
	/** Authenticate a given email/password combination. */
["ObtainJSONWebToken"]: {
	__typename: "ObtainJSONWebToken",
	token?: string | undefined,
	user?: GraphQLTypes["UserType"] | undefined
};
	/** Logout a user. */
["LogoutUserMutation"]: {
	__typename: "LogoutUserMutation",
	success?: boolean | undefined
};
	/** Resets the password of a user and sends them an email.

If the user has an unusable password, this will do nothing; no error will be raised
and and no email will be sent. */
["SendPasswordResetEmailMutation"]: {
	__typename: "SendPasswordResetEmailMutation",
	success?: boolean | undefined,
	errors?: GraphQLTypes["ExpectedErrorType"] | undefined
};
	/**
    Errors messages and codes mapped to
    fields or non fields errors.
    Example:
    {
        field_name: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ],
        other_field: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ],
        nonFieldErrors: [
            {
                "message": "error message",
                "code": "error_code"
            }
        ]
    }
     */
["ExpectedErrorType"]: "scalar" & { name: "ExpectedErrorType" };
	/** Change user password without old password.

Receive the token that was sent by email.

If token and new passwords are valid, update
user password and in case of using refresh
tokens, revoke all of them.

Also, if user has not been verified yet, verify it. */
["PasswordReset"]: {
	__typename: "PasswordReset",
	success?: boolean | undefined,
	errors?: GraphQLTypes["ExpectedErrorType"] | undefined
};
	["UpdateAccount"]: {
	__typename: "UpdateAccount",
	success?: boolean | undefined,
	errors?: GraphQLTypes["ExpectedErrorType"] | undefined
};
	/** Convert an existing LazyUser/PasswordLessUser into a User. */
["RegisterUserMutation"]: {
	__typename: "RegisterUserMutation",
	success?: boolean | undefined,
	errors?: GraphQLTypes["ExpectedErrorType"] | undefined,
	user?: GraphQLTypes["UserType"] | undefined,
	token?: string | undefined
};
	/** Convert an existing LazyUser into a PasswordLessUser. */
["RegisterPasswordLessUserMutation"]: {
	__typename: "RegisterPasswordLessUserMutation",
	success?: boolean | undefined,
	errors?: GraphQLTypes["ExpectedErrorType"] | undefined,
	user?: GraphQLTypes["UserType"] | undefined,
	token?: string | undefined
};
	["SsoConfigurationOutputType"]: {
	__typename: "SsoConfigurationOutputType",
	clientIdKey?: string | undefined,
	loginUrl?: string | undefined,
	logoutUrl?: string | undefined,
	callbackUrl?: string | undefined,
	successRedirectUrl?: string | undefined,
	errorRedirectUrl?: string | undefined
};
	["SsoConfigurationInput"]: {
		clientIdKey?: string | undefined,
	clientSecretKey?: string | undefined,
	loginUrl?: string | undefined,
	logoutUrl?: string | undefined,
	callbackUrl?: string | undefined,
	successRedirectUrl?: string | undefined,
	errorRedirectUrl?: string | undefined
};
	/** Perform a Data Import for a new or existing user.

A risk profile is created and a one-time login link is returned. */
["DataImportMutation"]: {
	__typename: "DataImportMutation",
	oneTimeLoginUrl?: string | undefined
};
	["DataImportInput"]: {
		distributionPartner: string,
	enabledProducts: Array<string | undefined>,
	userReference?: string | undefined,
	email?: string | undefined,
	riskData?: GraphQLTypes["GenericScalar"] | undefined
};
	["SortedImportMutation"]: {
	__typename: "SortedImportMutation",
	loginUrl?: string | undefined,
	user?: GraphQLTypes["SortedUserType"] | undefined
};
	["SortedUserType"]: {
	__typename: "SortedUserType",
	id: string,
	sortedId?: string | undefined,
	customerNumber: string,
	user: GraphQLTypes["UserType"],
	email?: string | undefined,
	uuid: GraphQLTypes["UUID"],
	workPhone?: string | undefined,
	homePhone?: string | undefined,
	mobile?: string | undefined,
	dateOfBirth?: GraphQLTypes["Date"] | undefined,
	propertyRoles: Array<GraphQLTypes["SortedUserPropertyRoleType"]>
};
	["SortedUserPropertyRoleType"]: {
	__typename: "SortedUserPropertyRoleType",
	id: string,
	sortedUser: GraphQLTypes["SortedUserType"],
	serviceNumber: string,
	riskProfile?: GraphQLTypes["RiskProfileType"] | undefined
};
	["SortedImportInput"]: {
		customerNumber: string,
	serviceNumber: string,
	email: string
};
	["StartQuoteInput"]: {
		create?: boolean | undefined,
	questionSetKey?: string | undefined,
	enabledProducts?: Array<string | undefined> | undefined,
	restart?: boolean | undefined,
	autoQuote?: boolean | undefined,
	fileLink?: string | undefined
};
	["CancellationQuestionFlowType"]: {
	__typename: "CancellationQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: GraphQLTypes["RiskProfileType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["StartPolicyCancellationInput"]: {
		policyId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["StartCoverInput"]: {
		riskProfileId: string,
	coverId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["StartCoverSummaryInput"]: {
		riskProfileId: string,
	coverId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["StartExposureInput"]: {
		riskProfileId: string,
	exposureId: string,
	exposureItemKey?: string | undefined,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["QuoteSummaryQuestionFlowType"]: {
	__typename: "QuoteSummaryQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: GraphQLTypes["RiskProfileType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["StartQuoteSummaryInput"]: {
		riskProfileId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["StartPolicyHolderInput"]: {
		riskProfileId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["KnockoutQuestionFlowType"]: {
	__typename: "KnockoutQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: GraphQLTypes["RiskProfileType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["StartKnockoutsInput"]: {
		riskProfileId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["ClaimQuestionFlowType"]: {
	__typename: "ClaimQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	claimProfile: GraphQLTypes["ClaimProfileType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["StartClaimInput"]: {
		policyId: string,
	questionSetKey?: string | undefined,
	restart?: boolean | undefined
};
	["SubmitClaimInput"]: {
		claimProfileId: string
};
	["AnswerEnquiryInput"]: {
		questionFlowId: string,
	answers?: GraphQLTypes["JSONString"] | undefined,
	skipNext?: boolean | undefined
};
	["RiskProfileInput"]: {
		riskProfileId: string,
	enabledProducts?: Array<string | undefined> | undefined
};
	["UpdateRiskCoverInput"]: {
		riskProfileId: string,
	coverId: string,
	enabled?: boolean | undefined,
	answers?: GraphQLTypes["JSONString"] | undefined
};
	["UpdateRiskExposureInput"]: {
		riskProfileId: string,
	exposureId: string,
	exposureItemKey: string,
	enabled?: boolean | undefined,
	answers?: GraphQLTypes["JSONString"] | undefined
};
	["UpdatePolicyInput"]: {
		policyId: string,
	autoRenewEnabled?: boolean | undefined
};
	["BindQuotesInput"]: {
		riskProfileId: string
};
	/** Generates multiple documents.

If 'quote_id' or 'policy_id' is provided, this will generate all documents
associated with the 'quote' or 'bind' events depending on which was provided. */
["GenerateDocuments"]: {
	__typename: "GenerateDocuments",
	documents?: Array<GraphQLTypes["GeneratedDocumentType"] | undefined> | undefined
};
	/** Generates a single document for the given 'type'.

'quote_id' or 'policy_id' is required to link the generated document to and find
the relevant product. */
["GenerateDocument"]: {
	__typename: "GenerateDocument",
	document?: GraphQLTypes["GeneratedDocumentType"] | undefined
};
	["UpdateQuestionFlowType"]: {
	__typename: "UpdateQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined,
	riskProfile?: GraphQLTypes["RiskProfileType"] | undefined
};
	["StartPolicyUpdateInput"]: {
		policyId: string,
	flow?: string | undefined,
	questionSetKey?: string | undefined,
	create?: boolean | undefined,
	restart?: boolean | undefined,
	coverId?: string | undefined,
	autoQuote?: boolean | undefined
};
	["ConfirmPolicyUpdateInput"]: {
		policyId: string,
	startDate: GraphQLTypes["Date"],
	autoRenewEnabled?: boolean | undefined
};
	["PolicyUpdateSummaryChangesType"]: {
	__typename: "PolicyUpdateSummaryChangesType",
	proRataAmount?: number | undefined,
	oldPeriodicPrice?: number | undefined,
	newPeriodicPrice?: number | undefined,
	surcharge?: number | undefined,
	amountDue?: number | undefined,
	oldPaymentFrequency?: string | undefined,
	newPaymentFrequency?: string | undefined,
	newStartDate?: string | undefined,
	newFinishDate?: string | undefined,
	summary?: Array<string | undefined> | undefined
};
	["PolicyUpdateSummaryInput"]: {
		policyId: string
};
	["PolicyCancellationSummaryInput"]: {
		policyId: string
};
	["ConfirmPolicyCancellationInput"]: {
		policyId: string,
	policyCancellationQuoteId: string
};
	["PolicyRenewalSummaryChangesType"]: {
	__typename: "PolicyRenewalSummaryChangesType",
	proRataAmount?: number | undefined,
	oldPeriodicPrice?: number | undefined,
	newPeriodicPrice?: number | undefined,
	surcharge?: number | undefined,
	amountDue?: number | undefined,
	oldPaymentFrequency?: string | undefined,
	newPaymentFrequency?: string | undefined,
	newStartDate?: string | undefined,
	newFinishDate?: string | undefined,
	summary?: Array<string | undefined> | undefined
};
	["PolicyRenewalSummaryInput"]: {
		policyId: string
};
	["ToggleEnabledProductsInput"]: {
		riskProfileId: string,
	productKey: string,
	enabled?: boolean | undefined,
	answers?: GraphQLTypes["JSONString"] | undefined
};
	["CreateRenewalQuoteInput"]: {
		policyId: string
};
	["LegalQuestionFlowType"]: {
	__typename: "LegalQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: GraphQLTypes["RiskProfileType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["PolicyDetailsQuestionFlowType"]: {
	__typename: "PolicyDetailsQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	riskProfile: GraphQLTypes["RiskProfileType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
};
	["ClaimProductQuestionFlowType"]: {
	__typename: "ClaimProductQuestionFlowType",
	id: string,
	started: GraphQLTypes["DateTime"],
	finished?: GraphQLTypes["DateTime"] | undefined,
	currentEnquiry?: GraphQLTypes["EnquiryType"] | undefined,
	maxSets?: number | undefined,
	currentSet?: number | undefined,
	claimProfile: GraphQLTypes["ClaimProfileType"],
	history?: Array<GraphQLTypes["EnquiryType"] | undefined> | undefined,
	messages?: Array<GraphQLTypes["MessageType"] | undefined> | undefined
}
    }
/** An enumeration. */
export const enum QuotePaymentFrequency {
	MONTHLY = "MONTHLY",
	YEARLY = "YEARLY"
}
/** An enumeration. */
export const enum RhetoricalKind {
	BUTTON = "BUTTON",
	MARKDOWN = "MARKDOWN",
	CALLOUT = "CALLOUT"
}
/** An enumeration. */
export const enum MessageKind {
	INFO = "INFO",
	WARNING = "WARNING",
	ERROR = "ERROR",
	POSITIVE = "POSITIVE"
}
/** An enumeration. */
export const enum CoverLimitationKind {
	INCLUSION = "INCLUSION",
	EXCLUSION = "EXCLUSION"
}
/** An enumeration. */
export const enum CoverLimitationLevel {
	DEFAULT = "DEFAULT",
	EXTRA = "EXTRA"
}
/** An enumeration. */
export const enum PolicyStatus {
	BOUND = "BOUND",
	CANCELLED = "CANCELLED",
	EXPIRED = "EXPIRED",
	PENDING_CANCELLATION = "PENDING_CANCELLATION"
}
/** An enumeration. */
export const enum PolicyCancellationQuoteState {
	DRAFT = "DRAFT",
	SUBMITTED = "SUBMITTED",
	ISSUED = "ISSUED",
	DISCARDED = "DISCARDED"
}
/** An enumeration. */
export const enum FeeTypeKind {
	FEE = "FEE",
	TAX = "TAX",
	STAMP_DUTY = "STAMP_DUTY"
}
/** An enumeration. */
export const enum TransactionStatus {
	IN_PROGRESS = "IN_PROGRESS",
	SUCCESS = "SUCCESS",
	ERROR = "ERROR"
}
/** An enumeration. */
export const enum PaymentProfilePaymentGateway {
	STRIPE = "STRIPE",
	CYBERSOURCE = "CYBERSOURCE",
	QBE_CYBERSOURCE = "QBE_CYBERSOURCE"
}
/** An enumeration. */
export const enum TransactionActionType {
	AUTH = "AUTH",
	CAPTURE = "CAPTURE",
	AUTH_AND_CAPTURE = "AUTH_AND_CAPTURE",
	VOID = "VOID",
	REFUND = "REFUND"
}
/** An enumeration. */
export const enum TransactionTransactionType {
	PURCHASE = "PURCHASE",
	UPDATE = "UPDATE",
	CANCELLATION = "CANCELLATION",
	RENEWAL = "RENEWAL",
	INSTALLMENT = "INSTALLMENT"
}
/** An enumeration. */
export const enum TransactionCurrency {
	AUD = "AUD"
}
/** An enumeration. */
export const enum PolicyPeriodKind {
	PURCHASE = "PURCHASE",
	UPDATE = "UPDATE"
}
/** An enumeration. */
export const enum ClaimStatusChoices {
	DRAFT = "DRAFT",
	DRAFT_DISCARDED = "DRAFT_DISCARDED",
	SUBMITTED = "SUBMITTED",
	PENDING_RESOLUTION = "PENDING_RESOLUTION",
	PAID = "PAID",
	REJECTED = "REJECTED",
	OTHER = "OTHER"
}
/** An enumeration. */
export const enum ClaimStatusTypes {
	OPEN = "OPEN",
	CLOSED = "CLOSED"
}
/** An enumeration. */
export const enum ClaimStateFilterEnum {
	ALL = "ALL",
	PRODUCT = "PRODUCT",
	COVER = "COVER",
	SUMMARY = "SUMMARY"
}
/** An enumeration. */
export const enum PaymentGateway {
	STRIPE = "STRIPE",
	CYBERSOURCE = "CYBERSOURCE",
	QBE_CYBERSOURCE = "QBE_CYBERSOURCE"
}
/** An enumeration. */
export const enum RiskStateFilterEnum {
	ALL = "ALL",
	PRODUCT = "PRODUCT",
	POLICY_HOLDER = "POLICY_HOLDER",
	ADJUSTMENT = "ADJUSTMENT",
	KNOCKOUT = "KNOCKOUT",
	EXPOSURE = "EXPOSURE"
}
/** An enumeration. */
export const enum QuoteState {
	DRAFT = "DRAFT",
	KNOCKOUT = "KNOCKOUT",
	SUBMITTED = "SUBMITTED",
	QUOTED = "QUOTED",
	ACCEPTED = "ACCEPTED",
	DISCARDED = "DISCARDED",
	REFERRED = "REFERRED",
	EXPIRED = "EXPIRED"
}
/** An enumeration. */
export const enum QuoteReferralState {
	PENDING = "PENDING",
	ACCEPTED = "ACCEPTED",
	DECLINED = "DECLINED"
}
/** An enumeration. */
export const enum InstallmentKind {
	MONTHLY = "MONTHLY",
	YEARLY = "YEARLY"
}
/** An enumeration. */
export const enum QuoteFilterBy {
	ALL = "ALL",
	DRAFT = "DRAFT",
	QUOTED = "QUOTED",
	ACCEPTED = "ACCEPTED",
	SUBMITTED = "SUBMITTED",
	DISCARDED = "DISCARDED",
	REFERRED = "REFERRED",
	REFERRED_PENDING = "REFERRED_PENDING",
	REFERRED_DECLINED = "REFERRED_DECLINED",
	QUOTED_ACCEPTED = "QUOTED_ACCEPTED",
	EXPIRED = "EXPIRED"
}
/** An enumeration. */
export const enum ClaimFilterBy {
	OPEN = "OPEN",
	CLOSED = "CLOSED",
	ALL = "ALL"
}
/** An enumeration. */
export const enum ClosedStatus {
	PAID = "PAID",
	REJECTED = "REJECTED",
	OTHER = "OTHER"
}
/**
    Enumeration to define valid associations for a note.

    Enum Members:
    - POLICY: Association with a policy object in the 'insurance' app.
    - QUOTE: Association with a quote object in the 'insurance' app.
    - CLAIM: Association with a claim object in the 'insurance' app.
     */
export const enum NoteAssociationLimit {
	POLICY = "POLICY",
	QUOTE = "QUOTE",
	CLAIM = "CLAIM"
}
/** An enumeration. */
export const enum ReferralState {
	PENDING = "PENDING",
	ACCEPTED = "ACCEPTED",
	DECLINED = "DECLINED"
}

type ZEUS_VARIABLES = {
	["PageSize"]: ValueTypes["PageSize"];
	["DateTime"]: ValueTypes["DateTime"];
	["UUID"]: ValueTypes["UUID"];
	["JSONString"]: ValueTypes["JSONString"];
	["QuotePaymentFrequency"]: ValueTypes["QuotePaymentFrequency"];
	["RhetoricalKind"]: ValueTypes["RhetoricalKind"];
	["MessageKind"]: ValueTypes["MessageKind"];
	["CoverLimitationKind"]: ValueTypes["CoverLimitationKind"];
	["CoverLimitationLevel"]: ValueTypes["CoverLimitationLevel"];
	["PolicyStatus"]: ValueTypes["PolicyStatus"];
	["PolicyCancellationQuoteState"]: ValueTypes["PolicyCancellationQuoteState"];
	["Date"]: ValueTypes["Date"];
	["FeeTypeKind"]: ValueTypes["FeeTypeKind"];
	["TransactionStatus"]: ValueTypes["TransactionStatus"];
	["PaymentProfilePaymentGateway"]: ValueTypes["PaymentProfilePaymentGateway"];
	["TransactionActionType"]: ValueTypes["TransactionActionType"];
	["TransactionTransactionType"]: ValueTypes["TransactionTransactionType"];
	["TransactionCurrency"]: ValueTypes["TransactionCurrency"];
	["PolicyPeriodKind"]: ValueTypes["PolicyPeriodKind"];
	["ClaimStatusChoices"]: ValueTypes["ClaimStatusChoices"];
	["ClaimStatusTypes"]: ValueTypes["ClaimStatusTypes"];
	["ClaimStateFilterEnum"]: ValueTypes["ClaimStateFilterEnum"];
	["PaymentGateway"]: ValueTypes["PaymentGateway"];
	["GenericScalar"]: ValueTypes["GenericScalar"];
	["RiskStateFilterEnum"]: ValueTypes["RiskStateFilterEnum"];
	["QuoteState"]: ValueTypes["QuoteState"];
	["QuoteReferralState"]: ValueTypes["QuoteReferralState"];
	["InstallmentKind"]: ValueTypes["InstallmentKind"];
	["QuoteFilterBy"]: ValueTypes["QuoteFilterBy"];
	["ClaimFilterBy"]: ValueTypes["ClaimFilterBy"];
	["ClosedStatus"]: ValueTypes["ClosedStatus"];
	["CreateLazyUserInput"]: ValueTypes["CreateLazyUserInput"];
	["NoteAssociationLimit"]: ValueTypes["NoteAssociationLimit"];
	["EditQuoteInput"]: ValueTypes["EditQuoteInput"];
	["EditPolicyholderInput"]: ValueTypes["EditPolicyholderInput"];
	["SendQuoteEmailInput"]: ValueTypes["SendQuoteEmailInput"];
	["GenerateReportInput"]: ValueTypes["GenerateReportInput"];
	["StartAdjustmentInput"]: ValueTypes["StartAdjustmentInput"];
	["ReferralState"]: ValueTypes["ReferralState"];
	["RenewalQuoteInput"]: ValueTypes["RenewalQuoteInput"];
	["HijackUserInput"]: ValueTypes["HijackUserInput"];
	["CompletePaymentInput"]: ValueTypes["CompletePaymentInput"];
	["UpdatePaymentMethodInput"]: ValueTypes["UpdatePaymentMethodInput"];
	["RefreshUserInput"]: ValueTypes["RefreshUserInput"];
	["ExpectedErrorType"]: ValueTypes["ExpectedErrorType"];
	["SsoConfigurationInput"]: ValueTypes["SsoConfigurationInput"];
	["DataImportInput"]: ValueTypes["DataImportInput"];
	["SortedImportInput"]: ValueTypes["SortedImportInput"];
	["StartQuoteInput"]: ValueTypes["StartQuoteInput"];
	["StartPolicyCancellationInput"]: ValueTypes["StartPolicyCancellationInput"];
	["StartCoverInput"]: ValueTypes["StartCoverInput"];
	["StartCoverSummaryInput"]: ValueTypes["StartCoverSummaryInput"];
	["StartExposureInput"]: ValueTypes["StartExposureInput"];
	["StartQuoteSummaryInput"]: ValueTypes["StartQuoteSummaryInput"];
	["StartPolicyHolderInput"]: ValueTypes["StartPolicyHolderInput"];
	["StartKnockoutsInput"]: ValueTypes["StartKnockoutsInput"];
	["StartClaimInput"]: ValueTypes["StartClaimInput"];
	["SubmitClaimInput"]: ValueTypes["SubmitClaimInput"];
	["AnswerEnquiryInput"]: ValueTypes["AnswerEnquiryInput"];
	["RiskProfileInput"]: ValueTypes["RiskProfileInput"];
	["UpdateRiskCoverInput"]: ValueTypes["UpdateRiskCoverInput"];
	["UpdateRiskExposureInput"]: ValueTypes["UpdateRiskExposureInput"];
	["UpdatePolicyInput"]: ValueTypes["UpdatePolicyInput"];
	["BindQuotesInput"]: ValueTypes["BindQuotesInput"];
	["StartPolicyUpdateInput"]: ValueTypes["StartPolicyUpdateInput"];
	["ConfirmPolicyUpdateInput"]: ValueTypes["ConfirmPolicyUpdateInput"];
	["PolicyUpdateSummaryInput"]: ValueTypes["PolicyUpdateSummaryInput"];
	["PolicyCancellationSummaryInput"]: ValueTypes["PolicyCancellationSummaryInput"];
	["ConfirmPolicyCancellationInput"]: ValueTypes["ConfirmPolicyCancellationInput"];
	["PolicyRenewalSummaryInput"]: ValueTypes["PolicyRenewalSummaryInput"];
	["ToggleEnabledProductsInput"]: ValueTypes["ToggleEnabledProductsInput"];
	["CreateRenewalQuoteInput"]: ValueTypes["CreateRenewalQuoteInput"];
}
